"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2129],{

/***/ 63129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DO": function() { return /* binding */ ALL_RESOLUTIONS; },
/* harmony export */   "MG": function() { return /* binding */ getTradingViewWidgetOptions; },
/* harmony export */   "bn": function() { return /* binding */ DAILY_RESOLUTION; },
/* harmony export */   "iA": function() { return /* binding */ TV_IDENTIFIERS; },
/* harmony export */   "qE": function() { return /* binding */ formulaToPriceDataObjKey; },
/* harmony export */   "uz": function() { return /* binding */ nonIndicatorApiFormula; },
/* harmony export */   "zO": function() { return /* binding */ INTRADAY_RESOLUTION; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36305);
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86123);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51077);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72521);





var getTradingViewWidgetOptions = function(param) {
    var isDark = param.isDark, isMobile = param.isMobile, isDesktop = param.isDesktop, newChartbit = param.newChartbit;
    return {
        interval: newChartbit ? "1D" : null,
        loading_screen: {
            foregroundColor: "#00ab6b",
            backgroundColor: (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .handleBackgroundColor */ .Gn)(isDark, isDesktop)
        },
        timezone: "Asia/Jakarta",
        container: "tv_chart_container",
        library_path: isDesktop ? "https://stockbit.com/tradingview/charting_library/" : "".concat(constants_app__WEBPACK_IMPORTED_MODULE_0__/* .assetPrefix */ .Vc, "/tradingview/charting_library/"),
        locale: (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .getLanguageFromURL */ .rY)() || "en",
        charts_storage_api_version: "1.1",
        custom_css_url: "../../tradingview/styles/custom".concat(isMobile ? "-mobile" : isDesktop ? "-desktop" : "", ".css"),
        custom_font_family: isDesktop ? isDesktop.fontFamily : "'ProximaNovaRg'",
        client_id: "tradingview.com",
        user_id: "public_user_id",
        study_count_limit: 100,
        disabled_features: [
            "trading_account_manager",
            "custom_resolutions",
            "display_market_status",
            "create_volume_indicator_by_default",
            "go_to_date",
            "right_toolbar",
            "header_quick_search", 
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .optionalArray */ .ih)(!!isMobile, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .optionalArray */ .ih)(typeof isMobile === "object" && !isMobile.showSearchBar, [
            "header_symbol_search",
            "header_compare"
        ])).concat([
            "header_settings",
            "header_screenshot",
            "header_fullscreen_button",
            "source_selection_markers", 
        ]))), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .optionalArray */ .ih)(!newChartbit, [
            "header_saveload",
            "save_shortcut",
            "support_multicharts",
            "header_layouttoggle",
            "drawing_templates", 
        ])), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .optionalArray */ .ih)(!!isDesktop, [
            "header_screenshot",
            "header_symbol_search", 
        ]))),
        enabled_features: [
            "use_localstorage_for_settings",
            "show_average_close_price_line_and_label",
            "symbol_search_hot_key", 
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .optionalArray */ .ih)(!!isMobile, [
            "hide_left_toolbar_by_default",
            "iframe_loading_compatibility_mode", 
        ])), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .optionalArray */ .ih)(newChartbit, [
            "chart_template_storage",
            "study_templates",
            "saveload_separate_drawings_storage", 
        ]))),
        autosize: true,
        auto_save_delay: newChartbit ? 5 : 1,
        overrides: {
            // main chart
            "paneProperties.topMargin": 17,
            "paneProperties.bottomMargin": 15,
            "paneProperties.legendProperties.showStudyValues": false,
            "paneProperties.legendProperties.showLegend": true,
            // main series
            "mainSeriesProperties.candleStyle.upColor": isDark ? "#53b987" : "#009900",
            "mainSeriesProperties.candleStyle.downColor": isDark ? "#eb4d5c" : "#B80E0C",
            "mainSeriesProperties.candleStyle.wickUpColor": isDark ? "#336854" : "#000000",
            "mainSeriesProperties.candleStyle.wickDownColor": isDark ? "#7f323f" : "#000000",
            "mainSeriesProperties.candleStyle.borderColor": isDark ? "#378658" : "#000000",
            "mainSeriesProperties.candleStyle.borderUpColor": isDark ? "#53b987" : "#000000",
            "mainSeriesProperties.candleStyle.borderDownColor": isDark ? "#eb4d5c" : "#000000",
            "scalesProperties.showStudyLastValue": true,
            "scalesProperties.showSeriesLastValue": true,
            // drawing
            "linetoolfibretracement.coeffsAsPercents": true,
            "linetoolfibchannel.coeffsAsPercents": true,
            "linetoolfibcircles.coeffsAsPercents": true,
            "linetooltrendbasedfibextension.coeffsAsPercents": true,
            "linetoolray.linewidth": 2,
            "linetoolfibretracement.extendLines": true,
            "linetoolfibretracement.transparency": 90,
            "linetoolfibretracement.horzLabelsAlign": "right",
            "linetoolfibretracement.vertLabelsAlign": "bottom",
            "linetoolfibretracement.showPrices": false
        },
        time_frames: [
            {
                text: "1d",
                resolution: "5",
                description: "1 Day",
                title: "1D"
            },
            {
                text: "5d",
                resolution: "5",
                description: "5 Days",
                title: "5D"
            },
            {
                text: "1m",
                resolution: "D",
                description: "1 Month",
                title: "1M"
            },
            {
                text: "3m",
                resolution: "D",
                description: "3 Months",
                title: "3M"
            },
            {
                text: "6m",
                resolution: "D",
                description: "6 Months",
                title: "6M"
            },
            {
                text: "1y",
                resolution: "D",
                description: "1 Year",
                title: "1Y"
            },
            {
                text: "5y",
                resolution: "D",
                description: "5 Years",
                title: "5Y"
            },
            {
                text: "1000y",
                resolution: "D",
                description: "All",
                title: "All"
            }, 
        ],
        widgetbar: {
            datawindow: true
        }
    };
};
var INTRADAY_RESOLUTION = [
    "1",
    "3",
    "5",
    "15",
    "30",
    "45",
    "60",
    "120",
    "180",
    "240", 
];
var DAILY_RESOLUTION = [
    "1D",
    "1W",
    "1M",
    "3M",
    "6M",
    "12M", 
];
var generateResolution = function(from, to, resolution) {
    var data = [];
    for(var i = from; i <= to; i += 1){
        data.push("".concat(i).concat(resolution || ""));
    }
    return data;
};
var ALL_RESOLUTIONS = // Intraday
(0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(generateResolution(1, 1440)).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(generateResolution(1, 24, "H")), // DWM
(0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(generateResolution(1, 365, "D")), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(generateResolution(1, 52, "W")), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(generateResolution(1, 12, "M")));
var TV_IDENTIFIERS = {
    DIALOG_COMPARE_SELECTOR: '[data-name="compare-dialog"]',
    DIALOG_SETTINGS_SELECTOR: '[data-name="series-properties-dialog"]',
    DIALOG_SYMBOL_SEARCH_SELECTOR: '[data-name="symbol-search-items-dialog"]',
    HEADER_TOOLBAR_UNDO_REDO_SELECTOR: '[data-name="header-toolbar-undo-redo"],#header-toolbar-undo-redo',
    TIMEZONE_LIST_ID: "overlap-manager-root",
    TIMEZONE_LIST_SELECTOR: '[data-name="menu-inner"] table',
    CAMERA_MENU_SELECTOR: '[data-name="save-chart-image"]',
    LOAD_LAYOUT_MENU_SELECTOR: '[data-name="save-load-menu-item-load"]',
    CHART_CONTAINER: "tv_chart_container",
    CUSTOM_SAVE_BUTTON_ICON: "#custom-save-button",
    HEADER_TOOLBAR_TRADE_BUTTON_SLOT: "trade-button-slot",
    CUSTOM_TEMPLATES_BUTTON: "#custom-templates-button",
    THEME_TOGGLER_BUTTON: "theme-toggler-button",
    CUSTOM_INDICATORS_BUTTON: "#custom-indicators-button",
    INDICATORS_BUTTON: "#header-toolbar-indicators",
    CUSTOM_SETTINGS_BUTTON: "custom-settings-button",
    BODY: ".chart-page",
    TIMEFRAME_ALL: '[data-name="date-range-tab-12000M"]',
    INDICATOR_TEMPLATES_BUTTON: "#header-toolbar-study-templates",
    SYNC_DRAWING: '[data-name="SyncDrawing"]',
    SAVE_LOAD_MENU: '[data-name="save-load-menu"]',
    MY_INVESTMENT_BUTTON_ICON: "my_investment_pie_chart"
};
var nonIndicatorApiFormula = [
    "VALUE",
    "FREQUENCY"
];
var _obj;
var formulaToPriceDataObjKey = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, nonIndicatorApiFormula[0], "value"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, nonIndicatorApiFormula[1], "frequency"), _obj);



/***/ }),

/***/ 51077:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A$": function() { return /* binding */ getLocalUserSetting; },
/* harmony export */   "AX": function() { return /* binding */ checkIfDefaultLightMode; },
/* harmony export */   "CQ": function() { return /* binding */ normalizeSymbol; },
/* harmony export */   "Ew": function() { return /* binding */ overrideSavedDataToDesktopDarkMode; },
/* harmony export */   "Fr": function() { return /* binding */ getUnix; },
/* harmony export */   "HY": function() { return /* binding */ getStudyParam; },
/* harmony export */   "Hu": function() { return /* binding */ getWidgetBarAPI; },
/* harmony export */   "IC": function() { return /* binding */ isTVIntraday; },
/* harmony export */   "KG": function() { return /* binding */ getTVDocument; },
/* harmony export */   "L$": function() { return /* binding */ getChartSymbol; },
/* harmony export */   "Lr": function() { return /* binding */ changeTheme; },
/* harmony export */   "Ok": function() { return /* binding */ overrideCandleColor; },
/* harmony export */   "PW": function() { return /* binding */ checkThemeToOverride; },
/* harmony export */   "U$": function() { return /* binding */ overrideDesktopDarkMode; },
/* harmony export */   "U7": function() { return /* binding */ getTVWindow; },
/* harmony export */   "V3": function() { return /* binding */ prepareLayoutBeforeLoad; },
/* harmony export */   "VB": function() { return /* binding */ fixDefaultSymbol; },
/* harmony export */   "WS": function() { return /* binding */ isSideToolbarOpen; },
/* harmony export */   "Ws": function() { return /* binding */ checkTextColor; },
/* harmony export */   "Xd": function() { return /* binding */ hideDrawingTemplateSaveMenu; },
/* harmony export */   "Y$": function() { return /* binding */ overrideHtmlClass; },
/* harmony export */   "ZI": function() { return /* binding */ saveClientTheme; },
/* harmony export */   "ad": function() { return /* binding */ compressString; },
/* harmony export */   "bC": function() { return /* binding */ compressChart; },
/* harmony export */   "bd": function() { return /* binding */ normalizeDrawingSourceSymbol; },
/* harmony export */   "cn": function() { return /* binding */ decompressChart; },
/* harmony export */   "e5": function() { return /* binding */ mergeLocalAndApi; },
/* harmony export */   "fO": function() { return /* binding */ fixV26StudyDrawing; },
/* harmony export */   "ih": function() { return /* binding */ optionalArray; },
/* harmony export */   "mB": function() { return /* binding */ localizedColors; },
/* harmony export */   "ob": function() { return /* binding */ injectThemeToSavedLayout; },
/* harmony export */   "pu": function() { return /* binding */ getDataFromTicker; },
/* harmony export */   "rY": function() { return /* binding */ getLanguageFromURL; },
/* harmony export */   "uH": function() { return /* binding */ selectTVElementByQuery; },
/* harmony export */   "vq": function() { return /* binding */ checkIfDefaultCandle; },
/* harmony export */   "yn": function() { return /* binding */ getClientTheme; },
/* harmony export */   "zV": function() { return /* binding */ isWidgetbarMinimized; },
/* harmony export */   "zv": function() { return /* binding */ normalizeDrawingGroupSymbol; }
/* harmony export */ });
/* unused harmony exports isMainSeriesExist, injectSymbolToMainSeries, fixHiddenExchangeAndInterval, resolveOldStudy, validateLayout, overrideByTheme, getTVResolution, isTVReady */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(828);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils_logger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91635);
/* harmony import */ var global_AlertMessage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6430);
/* harmony import */ var jszip__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55733);
/* harmony import */ var jszip__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(jszip__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(12902);
/* harmony import */ var _config_template__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66483);
/* eslint-disable no-use-before-define */ /* eslint-disable no-param-reassign */ /* eslint-disable guard-for-in */ /* eslint-disable no-restricted-syntax */ 










var lightTemplate = _config_template__WEBPACK_IMPORTED_MODULE_4__/* ["default"][0].template */ .Z[0].template;
var darkTemplate = _config_template__WEBPACK_IMPORTED_MODULE_4__/* ["default"][1].template */ .Z[1].template;
var getClientTheme = function(tvWidgetKey) {
    try {
        if (window && window.tvWidget && window.tvWidget[tvWidgetKey]) {
            return window.tvWidget[tvWidgetKey].getTheme();
        }
        return window.localStorage.getItem("stradingview.current_theme.name") || "light";
    } catch (error) {
        (0,utils_logger__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(error, {
            event: "getClientTheme",
            place: "TradingView/utils"
        });
        return "light";
    }
};
var isMainSeriesExist = function(layout) {
    return layout.charts[0].panes.some(function(param) {
        var sources = param.sources;
        return sources.some(function(param) {
            var type = param.type;
            return type && type.toUpperCase() === "MAINSERIES";
        });
    });
};
var injectSymbolToMainSeries = function(source, symbol) {
    var newSource = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, source);
    if (newSource.type && newSource.type.toUpperCase() === "MAINSERIES" && newSource.state) {
        newSource.state.symbol = symbol.toUpperCase();
        newSource.state.shortName = symbol.toUpperCase();
    }
    return newSource;
};
var fixHiddenExchangeAndInterval = function(source) {
    var newSource = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, source);
    if (newSource.type && newSource.type.toUpperCase() === "MAINSERIES" && newSource.state) {
        // We need to set all saved layout in Database showExhance, showInterval to true
        // Hiding Exchange and Interval for mobile now is controlled by CSS in custom-mobile.css
        newSource.state.statusViewStyle.showExchange = true;
        newSource.state.statusViewStyle.showInterval = true;
    }
    return newSource;
};
var resolveOldStudy = function(source) {
    var newSource = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, source);
    if (newSource.type && newSource.type.toUpperCase() === "STUDY" && newSource.state) {
        var ref, ref1;
        // `source.state.inputs.in_1` will be used to identify is the old data already resolved
        // other data still being keep for unexpected issues in the future
        switch((ref = source.state) === null || ref === void 0 ? void 0 : (ref1 = ref.shortId) === null || ref1 === void 0 ? void 0 : ref1.toUpperCase()){
            case "MOVING AVERAGE":
            case "MOVING AVERAGE EXPONENTIAL":
            case "MOVING AVERAGE WEIGHTED":
                {
                    if (source.state.inputs && source.state.inputs.in_1 !== undefined) {
                        newSource.state.inputs.symbol = "";
                        newSource.state.inputs.length = source.state.inputs.in_0;
                        newSource.state.inputs.source = source.state.inputs.in_1;
                        newSource.state.inputs.offset = source.state.inputs.in_2;
                        delete newSource.state.inputs.in_1;
                    }
                    break;
                }
            default:
                {
                    break;
                }
        }
    }
    return newSource;
};
var validateLayout = function(layout) {
    var themeFromStorage = getClientTheme();
    var fallbackTemplate = themeFromStorage.toLowerCase() === "dark" ? darkTemplate : lightTemplate;
    // probably API load layout error
    if (!layout) return fallbackTemplate;
    // `layout.layout` is used to differentiate Old and New layout schema
    if (!layout.layout) {
        // Old Layout Schema (probably generated when accessing old tradingview versions).
        // Migrate old layout to new layout schema
        var newLayout = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, fallbackTemplate);
        if (layout.panes) {
            newLayout.charts[0].panes = layout.panes;
        }
        if (layout.theme) {
            newLayout.charts[0].theme = layout.theme;
        }
        if (layout.chartProperties) {
            newLayout.charts[0].chartProperties = layout.chartProperties;
        }
        return newLayout;
    }
    if (!isMainSeriesExist(layout)) return fallbackTemplate;
    return layout;
};
var changeTheme = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(tvWidgetKey, theme) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (window.tvWidget) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return", false);
                case 2:
                    return _ctx.abrupt("return", window.tvWidget[tvWidgetKey].changeTheme(theme));
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function changeTheme(tvWidgetKey, theme) {
        return _ref.apply(this, arguments);
    };
}();
var overrideCandleColor = function(tvWidget, theme) {
    if (!tvWidget) return;
    switch(theme){
        case "light":
            tvWidget.applyOverrides({
                "mainSeriesProperties.candleStyle.upColor": "#009900",
                "mainSeriesProperties.candleStyle.downColor": "#B80E0C",
                "mainSeriesProperties.candleStyle.wickUpColor": "#000000",
                "mainSeriesProperties.candleStyle.wickDownColor": "#000000",
                "mainSeriesProperties.candleStyle.borderColor": "#000000",
                "mainSeriesProperties.candleStyle.borderUpColor": "#000000",
                "mainSeriesProperties.candleStyle.borderDownColor": "#000000",
                "mainSeriesProperties.statusViewStyle.showExchange": true,
                "mainSeriesProperties.statusViewStyle.showInterval": true
            });
            break;
        case "dark":
            tvWidget.applyOverrides({
                "mainSeriesProperties.candleStyle.upColor": "#53b987",
                "mainSeriesProperties.candleStyle.downColor": "#eb4d5c",
                "mainSeriesProperties.candleStyle.wickUpColor": "#336854",
                "mainSeriesProperties.candleStyle.wickDownColor": "#7f323f",
                "mainSeriesProperties.candleStyle.borderColor": "#378658",
                "mainSeriesProperties.candleStyle.borderUpColor": "#53b987",
                "mainSeriesProperties.candleStyle.borderDownColor": "#eb4d5c",
                "mainSeriesProperties.statusViewStyle.showExchange": true,
                "mainSeriesProperties.statusViewStyle.showInterval": true
            });
            break;
        default:
            break;
    }
};
// localize other platform after being forced to change to desktop colors
var localizedColors = function(chartLayout) {
    var overrideLayout = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, chartLayout);
    var toOverride = [];
    if (chartLayout) {
        overrideLayout.layout.charts.forEach(function(x) {
            var temp = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, x);
            if (overrideLayout.theme === "dark") {
                if (x.chartProperties.paneProperties.background.toLowerCase() === "#fff" || x.chartProperties.paneProperties.background.toLowerCase() === "#ffffff" || x.chartProperties.paneProperties.background.toLowerCase() === "#131722" || x.chartProperties.paneProperties.background.toLowerCase() === "#1f1f1f" && x.chartProperties.paneProperties.backgroundType === "gradient" && x.chartProperties.paneProperties.backgroundEndColor === "#131722") {
                    temp.chartProperties.paneProperties.background = "#1f1f1f";
                    temp.chartProperties.paneProperties.backgroundType = "solid";
                    temp.chartProperties.paneProperties.vertGridProperties.color = "rgba(196, 196, 196, 0.06)";
                    temp.chartProperties.paneProperties.horzGridProperties.color = "rgba(196, 196, 196, 0.06)";
                    if (x.chartProperties.scalesProperties.textColor === "#131722") {
                        temp.chartProperties.scalesProperties.textColor = "#B2B5BE";
                    }
                    if (x.chartProperties.paneProperties.separatorColor === "#2A2E39") {
                        temp.chartProperties.paneProperties.separatorColor = "#E0E3EB";
                    }
                }
            }
            if (overrideLayout.theme === "light" && x.chartProperties.paneProperties.background.toLowerCase() === "#1f1f1f" || x.chartProperties.paneProperties.background.toLowerCase() === "#131722") {
                temp.chartProperties.paneProperties.backgroundType = "solid";
                temp.chartProperties.paneProperties.background = "#FFF";
                temp.chartProperties.paneProperties.vertGridProperties.color = "rgba(225, 236, 242, 0.27)";
                temp.chartProperties.paneProperties.horzGridProperties.color = "rgba(225, 236, 242, 0.27)";
            }
            if (x.chartProperties.scalesProperties.textColor === "#B2B5BE" && overrideLayout.theme === "light") {
                temp.chartProperties.scalesProperties.textColor = "#131722";
            }
            if (x.chartProperties.paneProperties.separatorColor === "#E0E3EB") {
                temp.chartProperties.paneProperties.separatorColor = "#2A2E39";
            }
            toOverride.push(temp);
        });
        overrideLayout.layout.charts = toOverride;
    }
    return overrideLayout;
};
var overrideByTheme = function(theme, chartLayout) {
    if (chartLayout) {
        chartLayout.theme = theme;
        chartLayout.layout.charts[0].chartProperties.scalesProperties.textColor = theme === "dark" ? "#B2B5BE" : "#555";
        chartLayout.layout.charts[0].chartProperties.paneProperties.backgroundType = theme === "dark" ? "gradient" : "solid";
        chartLayout.layout.charts[0].chartProperties.paneProperties.background = theme === "dark" ? "#131722" : "#ffffff";
        if (theme === "dark") {
            chartLayout.layout.charts[0].chartProperties.paneProperties.backgroundGradientStartColor = "#181C27";
            chartLayout.layout.charts[0].chartProperties.paneProperties.backgroundGradientEndColor = "#131722";
        }
        chartLayout.layout.charts[0].panes.forEach(function(param) {
            var sources = param.sources;
            var mainSeries = sources.find(function(param) {
                var type = param.type;
                return type && type.toUpperCase() === "MAINSERIES";
            });
            mainSeries.state.candleStyle.upColor = theme === "dark" ? "#53b987" : "#009900";
            mainSeries.state.candleStyle.downColor = theme === "dark" ? "#eb4d5c" : "#B80E0C";
            mainSeries.state.candleStyle.wickUpColor = theme === "dark" ? "#336854" : "#000000";
            mainSeries.state.candleStyle.wickDownColor = theme === "dark" ? "#7f323f" : "#000000";
            mainSeries.state.candleStyle.borderColor = theme === "dark" ? "#378658" : "#000000";
            mainSeries.state.candleStyle.borderUpColor = theme === "dark" ? "#53b987" : "#000000";
            mainSeries.state.candleStyle.borderDownColor = theme === "dark" ? "#eb4d5c" : "#000000";
        });
    }
    return chartLayout;
};
var prepareLayoutBeforeLoad = function(rawLayout, symbol) {
    var skipOverwriteAxises = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var layout = validateLayout(rawLayout);
    var themeFromServer = layout.charts[0].theme;
    var _tmp;
    _tmp = layout.charts[0].panes.map(function(_param) {
        var sources = _param.sources, /** TV v22 down */ rightAxisState = _param.rightAxisState, /** TV v22 up */ rightAxisesState = _param.rightAxisesState, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
            "sources",
            "rightAxisState",
            "rightAxisesState"
        ]);
        var newPanes = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, rest), {
            sources: sources.map(function(source) {
                var newSource = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, source);
                newSource = injectSymbolToMainSeries(newSource, symbol);
                newSource = fixHiddenExchangeAndInterval(newSource);
                newSource = resolveOldStudy(newSource);
                return newSource;
            })
        });
        if (rightAxisState) {
            if (!skipOverwriteAxises) rightAxisState.m_priceRange = null;
            newPanes.rightAxisState = rightAxisState;
        }
        if (rightAxisesState) {
            var ref, ref1;
            if (!skipOverwriteAxises && (rightAxisesState === null || rightAxisesState === void 0 ? void 0 : (ref = rightAxisesState[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.state) === null || ref1 === void 0 ? void 0 : ref1.m_priceRange)) {
                rightAxisesState[0].state.m_priceRange = null;
            }
            newPanes.rightAxisesState = rightAxisesState;
        }
        return newPanes;
    }), layout.charts[0].panes = _tmp, _tmp;
    return {
        layout: layout,
        theme: themeFromServer
    };
};
var injectThemeToSavedLayout = function(layout, theme, isDesktop) {
    var newLayout = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, layout);
    try {
        if (!theme || !layout.charts || !layout.charts[0]) return layout;
        newLayout.charts[0].theme = theme;
        if (isDesktop) {
            newLayout.charts[0].theme = "dark";
            newLayout.charts.forEach(function(x, index) {
                x.theme = "dark";
                if (x.chartProperties.paneProperties.background === "#ffffff") {
                    x.chartProperties.paneProperties.background = "#1F1F1F";
                    x.chartProperties.scalesProperties.textColor = "#B2B5BE";
                    x.chartProperties.paneProperties.separatorColor = "#2A2E39";
                    x.chartProperties.paneProperties.separatorColor = "#2A2E39";
                    x.chartProperties.paneProperties.vertGridProperties.color = "rgba(196, 196, 196, 0.06)";
                    x.chartProperties.paneProperties.horzGridProperties.color = "rgba(196, 196, 196, 0.06)";
                }
                if (checkIfDefaultCandle(newLayout, index)) {
                    x.panes[0].sources[0].state.candleStyle.upColor = "#53b987";
                    x.panes[0].sources[0].state.candleStyle.downColor = "#eb4d5c";
                    x.panes[0].sources[0].state.candleStyle.wickUpColor = "#336854";
                    x.panes[0].sources[0].state.candleStyle.wickDownColor = "#7f323f";
                    x.panes[0].sources[0].state.candleStyle.borderColor = "#378658";
                    x.panes[0].sources[0].state.candleStyle.borderUpColor = "#53b987";
                    x.panes[0].sources[0].state.candleStyle.borderDownColor = "#eb4d5c";
                    x.panes[0].sources[0].state.statusViewStyle.showExchange = true;
                    x.panes[0].sources[0].state.statusViewStyle.showInterval = true;
                }
            });
        }
        return newLayout;
    } catch (error) {
        (0,utils_logger__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(error, {
            event: "injectThemeToSavedLayout",
            place: "TradingView/utils"
        });
        return newLayout;
    }
};
var fixV26StudyDrawing = function(layout) {
    var newLayout = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, layout);
    try {
        if (!layout.charts || !layout.charts[0]) return layout;
        newLayout.charts[0].panes.forEach(function(pane) {
            if (pane.sources[0].type === "Study") {
                if (!pane.sources[0].state.shortId) {
                    pane.sources[0].state.shortId = pane.sources[0].metaInfo.shortId;
                }
            }
        });
        return newLayout;
    } catch (error) {
        (0,utils_logger__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(error, {
            event: "fixV26StudyDrawing",
            place: "TradingView/utils"
        });
        return newLayout;
    }
};
var getStudyParam = function(tvWidget, indicator) {
    var inputData = {};
    var overrides = {};
    var options = {};
    var indicatorName = indicator.desc || indicator.name.toLowerCase();
    var lockStudy = false;
    var isOverlay = indicatorName.includes("underlay") || indicatorName.includes("overlay");
    if (indicator.inputData) {
        inputData = typeof indicator.inputData === "function" ? indicator.inputData(tvWidget) : indicator.inputData;
    }
    if (indicator.overrides) overrides = indicator.overrides;
    if (indicator.options) options = indicator.options;
    return [
        indicatorName,
        isOverlay,
        lockStudy,
        inputData,
        overrides,
        options
    ];
};
var getTVDocument = function(parent) {
    if (!document) return null;
    // const selector = '#tv_chart_container > iframe';
    var tvElement = (parent || document).querySelector("iframe");
    if (!tvElement) return null;
    // @ts-ignore
    var tvDocument = tvElement.contentDocument;
    return tvDocument;
};
var getTVWindow = function() {
    if (!document) return null;
    var tvElement = document.querySelector("iframe");
    if (!tvElement) return null;
    var tvWindow = tvElement.contentWindow;
    return tvWindow;
};
var selectTVElementByQuery = function(query, parent) {
    var tvDoc = getTVDocument(parent);
    if (!tvDoc) return null;
    return tvDoc.querySelector(query);
};
var getTVResolution = function(tvWidgetKey) {
    var ref;
    if (!(window === null || window === void 0 ? void 0 : (ref = window.tvWidget) === null || ref === void 0 ? void 0 : ref[tvWidgetKey])) return "";
    return window.tvWidget[tvWidgetKey].activeChart().resolution();
};
var isTVIntraday = function(tvWidgetKey) {
    var ref;
    if (!(window === null || window === void 0 ? void 0 : (ref = window.tvWidget) === null || ref === void 0 ? void 0 : ref[tvWidgetKey])) return false;
    var resolutionInNumber = Number(getTVResolution(tvWidgetKey));
    return !Number.isNaN(resolutionInNumber);
};
var saveClientTheme = function(clientTheme) {
    if (!window) return;
    try {
        window.localStorage.setItem("tvTheme", clientTheme);
        window.localStorage.setItem("stradingview.current_theme.name", clientTheme);
    // eslint-disable-next-line no-empty
    } catch (error) {
        (0,utils_logger__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(error, {
            event: "saveClientTheme",
            place: "TradingView/utils"
        });
    }
};
var overrideDesktopDarkMode = function(tvWidget, theme) {
    if (!tvWidget || theme === "light") return;
    tvWidget.applyOverrides({
        "paneProperties.backgroundType": "solid",
        "paneProperties.background": "#1F1F1F",
        "paneProperties.vertGridProperties.color": "rgba(196, 196, 196, 0.06)",
        "paneProperties.horzGridProperties.color": "rgba(196, 196, 196, 0.06)",
        "scalesProperties.textColor": "#B2B5BE",
        "paneProperties.separatorColor": "#2A2E39"
    });
};
var overrideSavedDataToDesktopDarkMode = function(chartLayout) {
    var overrideLayout = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, chartLayout);
    var toOverride = [];
    if (chartLayout) {
        overrideLayout.theme = "dark";
        overrideLayout.layout.charts.forEach(function(x, index) {
            var temp = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, x);
            if (x.chartProperties.paneProperties.background.toLowerCase() === "#fff" || x.chartProperties.paneProperties.background.toLowerCase() === "#ffffff" || x.chartProperties.paneProperties.background.toLowerCase() === "#131722") {
                temp.chartProperties.paneProperties.backgroundType = "solid";
                temp.chartProperties.paneProperties.background = "#1F1F1F";
                temp.chartProperties.scalesProperties.textColor = "#B2B5BE";
                temp.chartProperties.paneProperties.separatorColor = "#2A2E39";
                temp.chartProperties.paneProperties.vertGridProperties.color = "rgba(196, 196, 196, 0.06)";
                temp.chartProperties.paneProperties.horzGridProperties.color = "rgba(196, 196, 196, 0.06)";
            }
            if (chartLayout === null || chartLayout === void 0 ? void 0 : chartLayout.savedStateMetaInfo) {
                if (checkIfDefaultCandle(chartLayout === null || chartLayout === void 0 ? void 0 : chartLayout.layout, index)) {
                    temp.panes[0].sources[0].state.candleStyle.upColor = "#53b987";
                    temp.panes[0].sources[0].state.candleStyle.downColor = "#eb4d5c";
                    temp.panes[0].sources[0].state.candleStyle.wickUpColor = "#336854";
                    temp.panes[0].sources[0].state.candleStyle.wickDownColor = "#7f323f";
                    temp.panes[0].sources[0].state.candleStyle.borderColor = "#378658";
                    temp.panes[0].sources[0].state.candleStyle.borderUpColor = "#53b987";
                    temp.panes[0].sources[0].state.candleStyle.borderDownColor = "#eb4d5c";
                    temp.panes[0].sources[0].state.statusViewStyle.showExchange = true;
                    temp.panes[0].sources[0].state.statusViewStyle.showInterval = true;
                }
            }
            toOverride.push(temp);
        });
        var newLayout = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, chartLayout), {
            charts: toOverride
        });
        return newLayout;
    }
    return overrideLayout;
};
var getLanguageFromURL = function() {
    var regex = new RegExp("[\\?&]lang=([^&#]*)");
    var results = regex.exec(window.location.search);
    return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, " "));
};
var optionalArray = function(state, value) {
    return state ? value : [];
};
var isSideToolbarOpen = function() {
    if (false) {}
    var localStorageValue = window.localStorage.getItem("stradingview.ChartDrawingToolbarWidget.visible");
    var isDrawingToolVisible = localStorageValue === null ? true : localStorageValue === "true";
    return isDrawingToolVisible;
};
var isWidgetbarMinimized = function() {
    if (false) {}
    var widgetBarLayoutSettings = JSON.parse(window.localStorage.getItem("stradingview.widgetbar.layout-settings"));
    if (!widgetBarLayoutSettings) return true;
    var isMinimized = !!widgetBarLayoutSettings.settings.minimized;
    return isMinimized;
};
var getWidgetBarAPI = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(tvWidget) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", tvWidget.widgetbar());
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getWidgetBarAPI(tvWidget) {
        return _ref.apply(this, arguments);
    };
}();
var getDataFromTicker = function(ticker) {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(ticker.indexOf(":") > -1 ? ticker.split(":") : [
        undefined,
        ticker
    ], 2), exchange = ref[0], symbolWithStudy = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(symbolWithStudy.split("#"), 2), symbol = ref1[0], formula = ref1[1];
    return {
        symbol: symbol,
        exchange: exchange,
        formula: formula
    };
};
var getChartSymbol = function(tvWidget, index, widgetKey) {
    var ref;
    var tv = tvWidget || window.tvWidget[widgetKey];
    if (!tv) return "";
    var chart = typeof index === "undefined" ? tv.activeChart() : tv.chart(index);
    if (!chart) return "";
    return ((ref = chart.symbolExt()) === null || ref === void 0 ? void 0 : ref.symbol) || getDataFromTicker(chart.symbol()).symbol;
};
var getUnix = function(isoStr) {
    return new Date(isoStr).getTime() / 1000;
};
var fixDefaultSymbol = function(innerContent) {
    var ref, ref1, ref2, ref3;
    var cloned = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, innerContent);
    if (cloned && (cloned === null || cloned === void 0 ? void 0 : (ref = cloned.charts) === null || ref === void 0 ? void 0 : ref.length) && (cloned === null || cloned === void 0 ? void 0 : (ref1 = cloned.charts) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.panes) === null || ref3 === void 0 ? void 0 : ref3.length)) {
        var panes = cloned.charts[0].panes;
        panes.forEach(function(pane) {
            for(var i = 0; i < pane.sources.length; i += 1){
                var source = pane.sources[i];
                var type = source.type;
                var isMainSeries = type && type.toUpperCase() === "MAINSERIES";
                if (!isMainSeries) return;
                // Migrated layout don't have symbol
                // So we set default to IHSG to prevent breaking
                if (!source.state.symbol) {
                    source.state.symbol = "IHSG";
                }
            }
        });
    }
    return cloned;
};
/**
 * Compress String with Zip and base64
 */ var compressString = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
        var layoutZip, base64;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    layoutZip = new (jszip__WEBPACK_IMPORTED_MODULE_3___default())();
                    layoutZip.file("layout.json", data);
                    _ctx.next = 4;
                    return layoutZip.generateAsync({
                        type: "base64",
                        compression: "DEFLATE",
                        compressionOptions: {
                            level: 9
                        }
                    });
                case 4:
                    base64 = _ctx.sent;
                    return _ctx.abrupt("return", base64);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function compressString(data) {
        return _ref.apply(this, arguments);
    };
}();
var compressChart = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(chartData, isDesktop) {
        var uncompressedLayoutLimit, _ref, content, parsedContent, innerContent, theme, layout, data, message, base64;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    uncompressedLayoutLimit = 46725732; // 46.7MB
                    _ref = JSON.parse(chartData.content), content = _ref.content, parsedContent = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_ref, [
                        "content"
                    ]);
                    innerContent = JSON.parse(content);
                    theme = isDesktop ? "dark" : getClientTheme();
                    innerContent = injectThemeToSavedLayout(innerContent, theme, isDesktop);
                    layout = {
                        id: chartData.id,
                        name: chartData.name,
                        resolution: chartData.resolution,
                        symbol: chartData.symbol,
                        content: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, parsedContent), {
                            theme: theme,
                            content: innerContent
                        })
                    };
                    data = JSON.stringify(layout);
                    if (!(data.length > uncompressedLayoutLimit)) {
                        _ctx.next = 11;
                        break;
                    }
                    message = 'Gagal menyimpan, layout "'.concat(chartData.name, '" telah melewati batas ukuran, harap menghapus beberapa drawing untuk melanjutkan');
                    (0,global_AlertMessage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                        content: message,
                        alertType: "plain-default",
                        messageType: "error",
                        hasCloseIcon: false
                    });
                    throw Error(message);
                case 11:
                    _ctx.next = 13;
                    return compressString(data);
                case 13:
                    base64 = _ctx.sent;
                    return _ctx.abrupt("return", base64);
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function compressChart(chartData, isDesktop) {
        return _ref.apply(this, arguments);
    };
}();
var decompressChart = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(base64) {
        var layoutZip, layoutString, layout;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return jszip__WEBPACK_IMPORTED_MODULE_3___default().loadAsync(base64, {
                        base64: true
                    });
                case 2:
                    layoutZip = _ctx.sent;
                    _ctx.next = 5;
                    return layoutZip.file("layout.json").async("string");
                case 5:
                    layoutString = _ctx.sent;
                    layout = JSON.parse(layoutString);
                    return _ctx.abrupt("return", layout);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function decompressChart(base64) {
        return _ref.apply(this, arguments);
    };
}();
/*
 * Temporary Hide Drawing Template Save as Dropdown
 * https://github.com/tradingview/charting_library/issues/7937
 */ var hideDrawingTemplateSaveMenu = function() {
    var tvDoc = getTVDocument();
    if (!(tvDoc === null || tvDoc === void 0 ? void 0 : tvDoc.body)) return;
    tvDoc.body.classList.add("chartbit-old");
};
// need to override to change the frame of chart bit when overriding from desktop happens
// can not utilize changeTheme cause will reset
// all of the candle color etc that has been customized by user
var overrideHtmlClass = function(param) {
    var dataTheme = param.dataTheme, source = param.source;
    var doc = document.getElementsByTagName("iframe")[0].contentDocument;
    var isiDoc = doc.getElementsByTagName("html")[0].classList;
    if (dataTheme === "dark") {
        isiDoc.remove("theme-light");
        isiDoc.add("theme-dark");
    // onChangeThemeChartbit('dark');
    }
    if (dataTheme === "light") {
        isiDoc.remove("theme-dark");
        isiDoc.add("theme-light");
    // onChangeThemeChartbit('dark');
    }
};
var checkIfDefaultLightMode = function(data) {
    return data.layout.charts[0].chartProperties.paneProperties.background === "#ffffff";
};
var checkThemeToOverride = function(data, clientTheme) {
    if (clientTheme !== data.theme) {
        if (data.layout.charts[0].chartProperties.paneProperties.background === "#ffffff") {
            return "light";
        }
        if (data.layout.charts[0].chartProperties.paneProperties.background.toLowerCase() === "#1f1f1f") {
            return "dark";
        }
    }
    return data.theme;
};
var checkIfDefaultCandle = function(layout) {
    var index = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (layout) {
        var ref, ref1, ref2, ref3, ref4, ref5;
        var style = (ref3 = layout === null || layout === void 0 ? void 0 : (ref = layout.charts) === null || ref === void 0 ? void 0 : (ref1 = ref[index]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.panes) === null || ref2 === void 0 ? void 0 : ref2[0].sources) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.state) === null || ref5 === void 0 ? void 0 : ref5.candleStyle;
        return (style === null || style === void 0 ? void 0 : style.upColor) === "#089981" && (style === null || style === void 0 ? void 0 : style.downColor) === "#F23645" || (style === null || style === void 0 ? void 0 : style.upColor) === "#009900" && (style === null || style === void 0 ? void 0 : style.downColor) === "#B80E0C" || (style === null || style === void 0 ? void 0 : style.upColor) === "#53b987" && (style === null || style === void 0 ? void 0 : style.downColor) === "#eb4d5c";
    }
    return false;
};
var checkTextColor = function(theme, apiTextColor, apiBG) {
    var overrideText = apiTextColor;
    var overrideBg = apiBG;
    if (theme === "light" && apiTextColor === "#B2B5BE") {
        overrideText = "#131722";
    }
    if (theme === "dark" && apiTextColor === "#131722") {
        overrideText = "#B2B5BE";
    }
    if (theme === "dark" && (apiBG.toLowerCase() === "#fff" || apiBG.toLowerCase() === "#ffffff")) {
        overrideBg = "#1f1f1f";
    }
    if (theme === "light" && apiBG.toLowerCase() === "#1f1f1f") {
        overrideBg = "#fff";
    }
    return {
        overrideText: overrideText,
        overrideBg: overrideBg
    };
};
var isTVReady = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(tvWidgetKey) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", new Promise(function(resolve, reject) {
                        var ref;
                        var tv = window === null || window === void 0 ? void 0 : (ref = window.tvWidget) === null || ref === void 0 ? void 0 : ref[tvWidgetKey];
                        if (!tv) reject(Error("TradingView Not Found"));
                        tv.onChartReady(function() {
                            return resolve(true);
                        });
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function isTVReady(tvWidgetKey) {
        return _ref.apply(this, arguments);
    };
}();
// Remove Exchange from symbol
var normalizeSymbol = function(symbol) {
    return (symbol === null || symbol === void 0 ? void 0 : symbol.includes(":")) ? symbol === null || symbol === void 0 ? void 0 : symbol.split(":")[1] : symbol;
};
var normalizeDrawingSourceSymbol = function(data) {
    var formatted = (0,immer__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(data, function(draft) {
        var ref, ref1;
        draft.symbol = normalizeSymbol(draft === null || draft === void 0 ? void 0 : draft.symbol);
        if (draft === null || draft === void 0 ? void 0 : (ref = draft.state) === null || ref === void 0 ? void 0 : (ref1 = ref.state) === null || ref1 === void 0 ? void 0 : ref1.symbol) {
            var ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
            draft.state.state.symbol = (draft === null || draft === void 0 ? void 0 : (ref2 = draft.state) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.state) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.symbol) === null || ref4 === void 0 ? void 0 : ref4.includes(":")) ? draft === null || draft === void 0 ? void 0 : (ref5 = draft.state) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.state) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.symbol) === null || ref7 === void 0 ? void 0 : ref7.split(":")[1] : draft === null || draft === void 0 ? void 0 : (ref8 = draft.state) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.state) === null || ref9 === void 0 ? void 0 : ref9.symbol;
        }
    });
    return formatted;
};
var normalizeDrawingGroupSymbol = function(data) {
    var formatted = (0,immer__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(data, function(draft) {
        draft.symbol = normalizeSymbol(draft === null || draft === void 0 ? void 0 : draft.symbol);
    });
    return formatted;
};
var getLocalUserSetting = function(prefix) {
    var items = {};
    // Iterate over all keys in localStorage
    // eslint-disable-next-line no-plusplus
    for(var i = 0; i < localStorage.length; i++){
        var key = localStorage.key(i);
        // Check if the key starts with the given prefix
        if (key.startsWith(prefix)) {
            // Get the value associated with the key
            var value = localStorage.getItem(key);
            items[key.replace("".concat(prefix, "."), "")] = value;
        }
    }
    return items;
};
// merge preexisting user setting from local storage with one from api
var mergeLocalAndApi = function(param) {
    var localUserSetting = param.localUserSetting, userSettingFromServer = param.userSettingFromServer;
    var merged = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, userSettingFromServer, localUserSetting);
    try {
        for(var keyFromServer in userSettingFromServer){
            for(var keyLocal in localUserSetting){
                if (keyFromServer === keyLocal && userSettingFromServer[keyFromServer] !== localUserSetting[keyLocal]) {
                    if (Array.isArray(JSON.parse(localUserSetting[keyLocal]))) {
                        // put together if array
                        var concat = JSON.parse(localUserSetting[keyLocal]).concat(JSON.parse(userSettingFromServer[keyFromServer]));
                        merged[keyFromServer] = JSON.stringify(concat);
                    } else {
                        // replace with local if not array
                        merged[keyLocal] = localUserSetting[keyLocal];
                    }
                }
            }
        }
    } catch (error) {
        return userSettingFromServer;
    }
    for(var i in merged){
        localStorage.setItem("stradingview.".concat(i), merged[i]);
    }
    return merged;
};


/***/ }),

/***/ 66483:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var templates = [
    {
        key: "light",
        name: "Light",
        template: {
            layout: "s",
            charts: [
                {
                    theme: "Light",
                    panes: [
                        {
                            sources: [
                                {
                                    type: "MainSeries",
                                    id: "_seriesId",
                                    state: {
                                        style: 1,
                                        esdShowDividends: true,
                                        esdShowSplits: true,
                                        esdShowEarnings: true,
                                        esdShowBreaks: false,
                                        esdBreaksStyle: {
                                            color: "rgba( 235, 77, 92, 1)",
                                            style: 2,
                                            width: 1
                                        },
                                        esdFlagSize: 2,
                                        showCountdown: false,
                                        showInDataWindow: true,
                                        visible: true,
                                        showPriceLine: true,
                                        priceLineWidth: 1,
                                        priceLineColor: "",
                                        baseLineColor: "#B2B5BE",
                                        showPrevClosePriceLine: false,
                                        prevClosePriceLineWidth: 1,
                                        prevClosePriceLineColor: "rgba( 85, 85, 85, 1)",
                                        minTick: "default",
                                        extendedHours: false,
                                        sessVis: false,
                                        statusViewStyle: {
                                            fontSize: 17,
                                            showExchange: true,
                                            showInterval: true,
                                            showSymbolAsDescription: false
                                        },
                                        candleStyle: {
                                            upColor: "#009900",
                                            downColor: "#B80E0C",
                                            drawWick: true,
                                            drawBorder: true,
                                            borderColor: "#000000",
                                            borderUpColor: "#000000",
                                            borderDownColor: "#000000",
                                            wickColor: "#737375",
                                            wickUpColor: "#000000",
                                            wickDownColor: "#000000",
                                            barColorsOnPrevClose: false
                                        },
                                        hollowCandleStyle: {
                                            upColor: "#53b987",
                                            downColor: "#eb4d5c",
                                            drawWick: true,
                                            drawBorder: true,
                                            borderColor: "#378658",
                                            borderUpColor: "#53b987",
                                            borderDownColor: "#eb4d5c",
                                            wickColor: "#737375",
                                            wickUpColor: "#a9dcc3",
                                            wickDownColor: "#f5a6ae"
                                        },
                                        haStyle: {
                                            upColor: "#53b987",
                                            downColor: "#eb4d5c",
                                            drawWick: true,
                                            drawBorder: true,
                                            borderColor: "#378658",
                                            borderUpColor: "#53b987",
                                            borderDownColor: "#eb4d5c",
                                            wickColor: "#737375",
                                            wickUpColor: "#53b987",
                                            wickDownColor: "#eb4d5c",
                                            showRealLastPrice: false,
                                            barColorsOnPrevClose: false,
                                            inputs: {},
                                            inputInfo: {}
                                        },
                                        barStyle: {
                                            upColor: "#53b987",
                                            downColor: "#eb4d5c",
                                            barColorsOnPrevClose: false,
                                            dontDrawOpen: false
                                        },
                                        lineStyle: {
                                            color: "#0303F7",
                                            linestyle: 0,
                                            linewidth: 1,
                                            priceSource: "close",
                                            styleType: 2
                                        },
                                        areaStyle: {
                                            color1: "rgba(96, 96, 144, 0.5)",
                                            color2: "rgba(1, 246, 245, 0.5)",
                                            linecolor: "#0094FF",
                                            linestyle: 0,
                                            linewidth: 1,
                                            priceSource: "close",
                                            transparency: 50
                                        },
                                        renkoStyle: {
                                            upColor: "#53b987",
                                            downColor: "#eb4d5c",
                                            borderUpColor: "#53b987",
                                            borderDownColor: "#eb4d5c",
                                            upColorProjection: "#a9dcc3",
                                            downColorProjection: "#f5a6ae",
                                            borderUpColorProjection: "#a9dcc3",
                                            borderDownColorProjection: "#f5a6ae",
                                            wickUpColor: "#a9dcc3",
                                            wickDownColor: "#f5a6ae",
                                            inputs: {
                                                source: "close",
                                                boxSize: 3,
                                                style: "ATR",
                                                atrLength: 14,
                                                wicks: true
                                            },
                                            inputInfo: {
                                                source: {
                                                    name: "Source"
                                                },
                                                boxSize: {
                                                    name: "Box size"
                                                },
                                                style: {
                                                    name: "Style"
                                                },
                                                atrLength: {
                                                    name: "ATR Length"
                                                },
                                                wicks: {
                                                    name: "Wicks"
                                                }
                                            }
                                        },
                                        pbStyle: {
                                            upColor: "#53b987",
                                            downColor: "#eb4d5c",
                                            borderUpColor: "#53b987",
                                            borderDownColor: "#eb4d5c",
                                            upColorProjection: "#a9dcc3",
                                            downColorProjection: "#f5a6ae",
                                            borderUpColorProjection: "#a9dcc3",
                                            borderDownColorProjection: "#f5a6ae",
                                            inputs: {
                                                source: "close",
                                                lb: 3
                                            },
                                            inputInfo: {
                                                source: {
                                                    name: "Source"
                                                },
                                                lb: {
                                                    name: "Number of line"
                                                }
                                            }
                                        },
                                        kagiStyle: {
                                            upColor: "#53b987",
                                            downColor: "#eb4d5c",
                                            upColorProjection: "#a9dcc3",
                                            downColorProjection: "#f5a6ae",
                                            inputs: {
                                                source: "close",
                                                style: "ATR",
                                                atrLength: 14,
                                                reversalAmount: 1
                                            },
                                            inputInfo: {
                                                source: {
                                                    name: "Source"
                                                },
                                                style: {
                                                    name: "Style"
                                                },
                                                atrLength: {
                                                    name: "ATR Length"
                                                },
                                                reversalAmount: {
                                                    name: "Reversal amount"
                                                }
                                            }
                                        },
                                        pnfStyle: {
                                            upColor: "#53b987",
                                            downColor: "#eb4d5c",
                                            upColorProjection: "#a9dcc3",
                                            downColorProjection: "#f5a6ae",
                                            inputs: {
                                                sources: "Close",
                                                reversalAmount: 3,
                                                boxSize: 1,
                                                style: "ATR",
                                                atrLength: 14
                                            },
                                            inputInfo: {
                                                sources: {
                                                    name: "Source"
                                                },
                                                boxSize: {
                                                    name: "Box size"
                                                },
                                                reversalAmount: {
                                                    name: "Reversal amount"
                                                },
                                                style: {
                                                    name: "Style"
                                                },
                                                atrLength: {
                                                    name: "ATR Length"
                                                }
                                            }
                                        },
                                        baselineStyle: {
                                            baselineColor: "rgba( 117, 134, 150, 1)",
                                            topFillColor1: "rgba( 83, 185, 135, 0.1)",
                                            topFillColor2: "rgba( 83, 185, 135, 0.1)",
                                            bottomFillColor1: "rgba( 235, 77, 92, 0.1)",
                                            bottomFillColor2: "rgba( 235, 77, 92, 0.1)",
                                            topLineColor: "rgba( 83, 185, 135, 1)",
                                            bottomLineColor: "rgba( 235, 77, 92, 1)",
                                            topLineWidth: 1,
                                            bottomLineWidth: 1,
                                            priceSource: "close",
                                            transparency: 50,
                                            baseLevelPercentage: 50
                                        },
                                        rangeStyle: {
                                            upColor: "#53b987",
                                            downColor: "#eb4d5c",
                                            upColorProjection: "#a9dcc3",
                                            downColorProjection: "#f5a6ae",
                                            inputs: {
                                                range: 10,
                                                phantomBars: false
                                            },
                                            inputInfo: {
                                                range: {
                                                    name: "Range"
                                                },
                                                phantomBars: {
                                                    name: "Phantom Bars"
                                                }
                                            }
                                        },
                                        symbol: "IHSG",
                                        shortName: "IHSG",
                                        timeframe: "",
                                        onWidget: false,
                                        interval: "D",
                                        priceAxisProperties: {
                                            autoScale: true,
                                            autoScaleDisabled: false,
                                            lockScale: false,
                                            percentage: false,
                                            percentageDisabled: false,
                                            log: false,
                                            logDisabled: false,
                                            alignLabels: false,
                                            indexedTo100: false
                                        },
                                        showSessions: false
                                    },
                                    zorder: -1,
                                    haStyle: {
                                        studyId: "BarSetHeikenAshi@tv-basicstudies-60"
                                    },
                                    renkoStyle: {
                                        studyId: "BarSetRenko@tv-prostudies-15"
                                    },
                                    pbStyle: {
                                        studyId: "BarSetPriceBreak@tv-prostudies-15"
                                    },
                                    kagiStyle: {
                                        studyId: "BarSetKagi@tv-prostudies-15"
                                    },
                                    pnfStyle: {
                                        studyId: "BarSetPnF@tv-prostudies-15"
                                    },
                                    rangeStyle: {
                                        studyId: "BarSetRange@tv-basicstudies-72"
                                    }
                                },
                                {
                                    type: "study_Sessions",
                                    id: "VP10po",
                                    state: {
                                        graphics: {
                                            vertlines: {
                                                sessBreaks: {
                                                    color: "#4985e7",
                                                    style: 2,
                                                    visible: false,
                                                    width: 1,
                                                    name: "Session Break"
                                                }
                                            }
                                        },
                                        linkedToSeries: true,
                                        precision: "default",
                                        inputs: {},
                                        styles: {},
                                        palettes: {},
                                        bands: {},
                                        area: {},
                                        showInDataWindow: true,
                                        visible: true,
                                        showStudyArguments: true,
                                        plots: {},
                                        _metainfoVersion: 44,
                                        description: "Sessions",
                                        id: "Sessions@tv-basicstudies",
                                        is_hidden_study: true,
                                        is_price_study: true,
                                        name: "Sessions@tv-basicstudies",
                                        shortDescription: "Sessions",
                                        description_localized: "Sessions",
                                        shortId: "Sessions",
                                        packageId: "tv-basicstudies",
                                        version: "1",
                                        fullId: "Sessions@tv-basicstudies-1",
                                        productId: "tv-basicstudies"
                                    },
                                    zorder: -2,
                                    metaInfo: {
                                        palettes: {},
                                        inputs: [],
                                        plots: [],
                                        graphics: {
                                            vertlines: {
                                                sessBreaks: {
                                                    name: "Session Break"
                                                }
                                            }
                                        },
                                        defaults: {
                                            graphics: {
                                                vertlines: {
                                                    sessBreaks: {
                                                        color: "#4985e7",
                                                        style: 2,
                                                        visible: false,
                                                        width: 1
                                                    }
                                                }
                                            },
                                            linkedToSeries: true,
                                            precision: 4
                                        },
                                        _metainfoVersion: 44,
                                        description: "Sessions",
                                        id: "Sessions@tv-basicstudies-1",
                                        is_hidden_study: true,
                                        is_price_study: true,
                                        name: "Sessions@tv-basicstudies",
                                        shortDescription: "Sessions",
                                        description_localized: "Sessions",
                                        shortId: "Sessions",
                                        packageId: "tv-basicstudies",
                                        version: "1",
                                        fullId: "Sessions@tv-basicstudies-1",
                                        productId: "tv-basicstudies"
                                    },
                                    ownerSource: "_seriesId"
                                }, 
                            ],
                            leftAxisState: {
                                m_priceRange: {
                                    m_maxValue: 0.5,
                                    m_minValue: -0.5
                                },
                                m_isAutoScale: true,
                                m_isPercentage: false,
                                m_isIndexedTo100: false,
                                m_isLog: false,
                                m_isLockScale: false,
                                m_height: 949,
                                m_topMargin: 0.17,
                                m_bottomMargin: 0.15
                            },
                            leftAxisSources: [],
                            rightAxisState: {
                                m_priceRange: {
                                    m_maxValue: 6636.33,
                                    m_minValue: 5623.84
                                },
                                m_isAutoScale: true,
                                m_isPercentage: false,
                                m_isIndexedTo100: false,
                                m_isLog: false,
                                m_isLockScale: false,
                                m_height: 949,
                                m_topMargin: 0.17,
                                m_bottomMargin: 0.15
                            },
                            rightAxisSources: [
                                "_seriesId",
                                "VP10po"
                            ],
                            overlayPriceScales: {},
                            stretchFactor: 4484.635413319781,
                            mainSourceId: "_seriesId"
                        }, 
                    ],
                    timeScale: {
                        m_barSpacing: 6,
                        m_rightOffset: 5
                    },
                    chartProperties: {
                        paneProperties: {
                            background: "#ffffff",
                            gridProperties: {
                                color: "#e1ecf2",
                                style: 0
                            },
                            vertGridProperties: {
                                color: "rgba(225, 236, 242, 0.27)",
                                style: 0
                            },
                            horzGridProperties: {
                                color: "rgba(225, 236, 242, 0.27)",
                                style: 0
                            },
                            crossHairProperties: {
                                color: "rgba(117, 134, 150, 1)",
                                style: 2,
                                transparency: 0,
                                width: 1
                            },
                            topMargin: 17,
                            bottomMargin: 15,
                            leftAxisProperties: {
                                autoScale: true,
                                autoScaleDisabled: false,
                                lockScale: false,
                                percentage: false,
                                percentageDisabled: false,
                                indexedTo100: false,
                                log: false,
                                logDisabled: false,
                                alignLabels: true
                            },
                            rightAxisProperties: {
                                autoScale: true,
                                autoScaleDisabled: false,
                                lockScale: false,
                                percentage: false,
                                percentageDisabled: false,
                                log: false,
                                logDisabled: false,
                                alignLabels: true
                            },
                            legendProperties: {
                                showStudyArguments: true,
                                showStudyTitles: true,
                                showStudyValues: false,
                                showSeriesTitle: true,
                                showSeriesOHLC: true,
                                showLegend: false,
                                showBarChange: true,
                                showOnlyPriceSource: true
                            }
                        },
                        scalesProperties: {
                            showLeftScale: false,
                            showRightScale: true,
                            backgroundColor: "#ffffff",
                            lineColor: "#555",
                            textColor: "#555",
                            fontSize: 11,
                            scaleSeriesOnly: false,
                            showSeriesLastValue: true,
                            showSeriesPrevCloseValue: false,
                            showStudyLastValue: true,
                            showSymbolLabels: false,
                            showStudyPlotLabels: false,
                            barSpacing: 6
                        },
                        chartEventsSourceProperties: {
                            visible: true,
                            futureOnly: true,
                            breaks: {
                                color: "rgba(85, 85, 85, 1)",
                                visible: false,
                                style: 2,
                                width: 1
                            }
                        }
                    },
                    version: 2,
                    timezone: "Etc/UTC"
                }, 
            ]
        }
    },
    {
        key: "dark",
        name: "Dark",
        template: {
            layout: "s",
            charts: [
                {
                    theme: "Dark",
                    panes: [
                        {
                            sources: [
                                {
                                    type: "MainSeries",
                                    id: "_seriesId",
                                    state: {
                                        style: 1,
                                        esdShowDividends: true,
                                        esdShowSplits: true,
                                        esdShowEarnings: true,
                                        esdShowBreaks: false,
                                        esdBreaksStyle: {
                                            color: "rgba( 235, 77, 92, 1)",
                                            style: 2,
                                            width: 1
                                        },
                                        esdFlagSize: 2,
                                        showCountdown: false,
                                        showInDataWindow: true,
                                        visible: true,
                                        showPriceLine: true,
                                        priceLineWidth: 1,
                                        priceLineColor: "",
                                        baseLineColor: "#5d606b",
                                        showPrevClosePriceLine: false,
                                        prevClosePriceLineWidth: 1,
                                        prevClosePriceLineColor: "rgba( 85, 85, 85, 1)",
                                        minTick: "default",
                                        extendedHours: false,
                                        sessVis: false,
                                        statusViewStyle: {
                                            fontSize: 17,
                                            showExchange: true,
                                            showInterval: true,
                                            showSymbolAsDescription: false
                                        },
                                        candleStyle: {
                                            upColor: "#53b987",
                                            downColor: "#eb4d5c",
                                            drawWick: true,
                                            drawBorder: true,
                                            borderColor: "#378658",
                                            borderUpColor: "#53b987",
                                            borderDownColor: "#eb4d5c",
                                            wickColor: "#B5B5B8",
                                            wickUpColor: "#336854",
                                            wickDownColor: "#7f323f",
                                            barColorsOnPrevClose: false
                                        },
                                        hollowCandleStyle: {
                                            upColor: "#53b987",
                                            downColor: "#eb4d5c",
                                            drawWick: true,
                                            drawBorder: true,
                                            borderColor: "#378658",
                                            borderUpColor: "#53b987",
                                            borderDownColor: "#eb4d5c",
                                            wickColor: "#B5B5B8",
                                            wickUpColor: "#336854",
                                            wickDownColor: "#7f323f"
                                        },
                                        haStyle: {
                                            upColor: "#53b987",
                                            downColor: "#eb4d5c",
                                            drawWick: true,
                                            drawBorder: true,
                                            borderColor: "#378658",
                                            borderUpColor: "#53b987",
                                            borderDownColor: "#eb4d5c",
                                            wickColor: "#B5B5B8",
                                            wickUpColor: "#53b987",
                                            wickDownColor: "#eb4d5c",
                                            showRealLastPrice: false,
                                            barColorsOnPrevClose: false,
                                            inputs: {},
                                            inputInfo: {}
                                        },
                                        barStyle: {
                                            upColor: "#53b987",
                                            downColor: "#eb4d5c",
                                            barColorsOnPrevClose: false,
                                            dontDrawOpen: false
                                        },
                                        lineStyle: {
                                            color: "#6FB8F7",
                                            linestyle: 0,
                                            linewidth: 1,
                                            priceSource: "close",
                                            styleType: 2
                                        },
                                        areaStyle: {
                                            color1: "#606090",
                                            color2: "#01F6F5",
                                            linecolor: "#0094FF",
                                            linestyle: 0,
                                            linewidth: 1,
                                            priceSource: "close",
                                            transparency: 50
                                        },
                                        renkoStyle: {
                                            upColor: "#53b987",
                                            downColor: "#eb4d5c",
                                            borderUpColor: "#53b987",
                                            borderDownColor: "#eb4d5c",
                                            upColorProjection: "#336854",
                                            downColorProjection: "#7f323f",
                                            borderUpColorProjection: "#336854",
                                            borderDownColorProjection: "#7f323f",
                                            wickUpColor: "#336854",
                                            wickDownColor: "#7f323f",
                                            inputs: {
                                                source: "close",
                                                boxSize: 3,
                                                style: "ATR",
                                                atrLength: 14,
                                                wicks: true
                                            },
                                            inputInfo: {
                                                source: {
                                                    name: "Source"
                                                },
                                                boxSize: {
                                                    name: "Box size"
                                                },
                                                style: {
                                                    name: "Style"
                                                },
                                                atrLength: {
                                                    name: "ATR Length"
                                                },
                                                wicks: {
                                                    name: "Wicks"
                                                }
                                            }
                                        },
                                        pbStyle: {
                                            upColor: "#53b987",
                                            downColor: "#eb4d5c",
                                            borderUpColor: "#53b987",
                                            borderDownColor: "#eb4d5c",
                                            upColorProjection: "#336854",
                                            downColorProjection: "#7f323f",
                                            borderUpColorProjection: "#336854",
                                            borderDownColorProjection: "#7f323f",
                                            inputs: {
                                                source: "close",
                                                lb: 3
                                            },
                                            inputInfo: {
                                                source: {
                                                    name: "Source"
                                                },
                                                lb: {
                                                    name: "Number of line"
                                                }
                                            }
                                        },
                                        kagiStyle: {
                                            upColor: "#53b987",
                                            downColor: "#eb4d5c",
                                            upColorProjection: "#336854",
                                            downColorProjection: "#7f323f",
                                            inputs: {
                                                source: "close",
                                                style: "ATR",
                                                atrLength: 14,
                                                reversalAmount: 1
                                            },
                                            inputInfo: {
                                                source: {
                                                    name: "Source"
                                                },
                                                style: {
                                                    name: "Style"
                                                },
                                                atrLength: {
                                                    name: "ATR Length"
                                                },
                                                reversalAmount: {
                                                    name: "Reversal amount"
                                                }
                                            }
                                        },
                                        pnfStyle: {
                                            upColor: "#53b987",
                                            downColor: "#eb4d5c",
                                            upColorProjection: "#336854",
                                            downColorProjection: "#7f323f",
                                            inputs: {
                                                sources: "Close",
                                                reversalAmount: 3,
                                                boxSize: 1,
                                                style: "ATR",
                                                atrLength: 14
                                            },
                                            inputInfo: {
                                                sources: {
                                                    name: "Source"
                                                },
                                                boxSize: {
                                                    name: "Box size"
                                                },
                                                reversalAmount: {
                                                    name: "Reversal amount"
                                                },
                                                style: {
                                                    name: "Style"
                                                },
                                                atrLength: {
                                                    name: "ATR Length"
                                                }
                                            }
                                        },
                                        baselineStyle: {
                                            baselineColor: "rgba( 117, 134, 150, 1)",
                                            topFillColor1: "rgba( 83, 185, 135, 0.1)",
                                            topFillColor2: "rgba( 83, 185, 135, 0.1)",
                                            bottomFillColor1: "rgba( 235, 77, 92, 0.1)",
                                            bottomFillColor2: "rgba( 235, 77, 92, 0.1)",
                                            topLineColor: "rgba( 83, 185, 135, 1)",
                                            bottomLineColor: "rgba( 235, 77, 92, 1)",
                                            topLineWidth: 1,
                                            bottomLineWidth: 1,
                                            priceSource: "close",
                                            transparency: 50,
                                            baseLevelPercentage: 50
                                        },
                                        rangeStyle: {
                                            upColor: "#53b987",
                                            downColor: "#eb4d5c",
                                            upColorProjection: "#336854",
                                            downColorProjection: "#7f323f",
                                            inputs: {
                                                range: 10,
                                                phantomBars: false
                                            },
                                            inputInfo: {
                                                range: {
                                                    name: "Range"
                                                },
                                                phantomBars: {
                                                    name: "Phantom Bars"
                                                }
                                            }
                                        },
                                        symbol: "BBCA",
                                        shortName: "BBCA",
                                        timeframe: "",
                                        onWidget: false,
                                        interval: "D",
                                        priceAxisProperties: {
                                            autoScale: true,
                                            autoScaleDisabled: false,
                                            lockScale: false,
                                            percentage: false,
                                            percentageDisabled: false,
                                            log: false,
                                            logDisabled: false,
                                            alignLabels: false,
                                            indexedTo100: false
                                        },
                                        showSessions: false
                                    },
                                    zorder: -1,
                                    haStyle: {
                                        studyId: "BarSetHeikenAshi@tv-basicstudies-60"
                                    },
                                    renkoStyle: {
                                        studyId: "BarSetRenko@tv-prostudies-15"
                                    },
                                    pbStyle: {
                                        studyId: "BarSetPriceBreak@tv-prostudies-15"
                                    },
                                    kagiStyle: {
                                        studyId: "BarSetKagi@tv-prostudies-15"
                                    },
                                    pnfStyle: {
                                        studyId: "BarSetPnF@tv-prostudies-15"
                                    },
                                    rangeStyle: {
                                        studyId: "BarSetRange@tv-basicstudies-72"
                                    }
                                },
                                {
                                    type: "study_Sessions",
                                    id: "VP10po",
                                    state: {
                                        graphics: {
                                            vertlines: {
                                                sessBreaks: {
                                                    color: "#4985e7",
                                                    style: 2,
                                                    visible: false,
                                                    width: 1,
                                                    name: "Session Break"
                                                }
                                            }
                                        },
                                        linkedToSeries: true,
                                        precision: "default",
                                        inputs: {},
                                        styles: {},
                                        palettes: {},
                                        bands: {},
                                        area: {},
                                        showInDataWindow: true,
                                        visible: true,
                                        showStudyArguments: true,
                                        plots: {},
                                        _metainfoVersion: 44,
                                        description: "Sessions",
                                        id: "Sessions@tv-basicstudies",
                                        is_hidden_study: true,
                                        is_price_study: true,
                                        name: "Sessions@tv-basicstudies",
                                        shortDescription: "Sessions",
                                        description_localized: "Sessions",
                                        shortId: "Sessions",
                                        packageId: "tv-basicstudies",
                                        version: "1",
                                        fullId: "Sessions@tv-basicstudies-1",
                                        productId: "tv-basicstudies"
                                    },
                                    zorder: -2,
                                    metaInfo: {
                                        palettes: {},
                                        inputs: [],
                                        plots: [],
                                        graphics: {
                                            vertlines: {
                                                sessBreaks: {
                                                    name: "Session Break"
                                                }
                                            }
                                        },
                                        defaults: {
                                            graphics: {
                                                vertlines: {
                                                    sessBreaks: {
                                                        color: "#4985e7",
                                                        style: 2,
                                                        visible: false,
                                                        width: 1
                                                    }
                                                }
                                            },
                                            linkedToSeries: true,
                                            precision: 4
                                        },
                                        _metainfoVersion: 44,
                                        description: "Sessions",
                                        id: "Sessions@tv-basicstudies-1",
                                        is_hidden_study: true,
                                        is_price_study: true,
                                        name: "Sessions@tv-basicstudies",
                                        shortDescription: "Sessions",
                                        description_localized: "Sessions",
                                        shortId: "Sessions",
                                        packageId: "tv-basicstudies",
                                        version: "1",
                                        fullId: "Sessions@tv-basicstudies-1",
                                        productId: "tv-basicstudies"
                                    },
                                    ownerSource: "_seriesId"
                                },
                                {
                                    type: "LineToolABCD",
                                    id: "44EV8q",
                                    state: {
                                        intervalsVisibilities: {
                                            seconds: true,
                                            secondsFrom: 1,
                                            secondsTo: 59,
                                            minutes: true,
                                            minutesFrom: 1,
                                            minutesTo: 59,
                                            hours: true,
                                            hoursFrom: 1,
                                            hoursTo: 24,
                                            days: true,
                                            daysFrom: 1,
                                            daysTo: 366,
                                            weeks: true,
                                            months: true,
                                            ranges: true
                                        },
                                        clonable: true,
                                        color: "rgba( 0, 155, 0, 1)",
                                        textcolor: "rgba( 255, 255, 255, 1)",
                                        font: "Verdana",
                                        fontsize: 12,
                                        bold: false,
                                        italic: false,
                                        linewidth: 2,
                                        frozen: false,
                                        visible: true,
                                        symbol: "BBCA",
                                        interval: "D",
                                        lastUpdateTime: 0,
                                        _isActualInterval: true,
                                        fixedSize: true
                                    },
                                    points: [
                                        {
                                            time_t: 1577379600,
                                            offset: 0,
                                            price: 33529.98191418593
                                        },
                                        {
                                            time_t: 1577379600,
                                            offset: 0,
                                            price: 33529.98191418593
                                        },
                                        {
                                            time_t: 1575824400,
                                            offset: 0,
                                            price: 34666.94557625146
                                        },
                                        {
                                            time_t: 1577898000,
                                            offset: 0,
                                            price: 34901.28159820389
                                        }, 
                                    ],
                                    zorder: 4,
                                    linkKey: "lvBmAe9gwb3J",
                                    ownerSource: "_seriesId"
                                }, 
                            ],
                            leftAxisState: {
                                m_priceRange: {
                                    m_maxValue: 0.5,
                                    m_minValue: -0.5
                                },
                                m_isAutoScale: true,
                                m_isPercentage: false,
                                m_isIndexedTo100: false,
                                m_isLog: false,
                                m_isLockScale: false,
                                m_height: 877,
                                m_topMargin: 0.17,
                                m_bottomMargin: 0.15
                            },
                            leftAxisSources: [],
                            rightAxisState: {
                                m_priceRange: {
                                    m_maxValue: 35300,
                                    m_minValue: 25700
                                },
                                m_isAutoScale: true,
                                m_isPercentage: false,
                                m_isIndexedTo100: false,
                                m_isLog: false,
                                m_isLockScale: false,
                                m_height: 877,
                                m_topMargin: 0.17,
                                m_bottomMargin: 0.15
                            },
                            rightAxisSources: [
                                "_seriesId",
                                "VP10po"
                            ],
                            overlayPriceScales: {
                                "44EV8q": {
                                    m_priceRange: {
                                        m_maxValue: 35300,
                                        m_minValue: 25700
                                    },
                                    m_isAutoScale: true,
                                    m_isPercentage: false,
                                    m_isIndexedTo100: false,
                                    m_isLog: false,
                                    m_isLockScale: false,
                                    m_height: 877,
                                    m_topMargin: 0.17,
                                    m_bottomMargin: 0.15
                                }
                            },
                            stretchFactor: 4484.635413319781,
                            mainSourceId: "_seriesId"
                        }, 
                    ],
                    timeScale: {
                        m_barSpacing: 6,
                        m_rightOffset: 5
                    },
                    chartProperties: {
                        paneProperties: {
                            background: "#131722",
                            gridProperties: {
                                color: "#363c4e",
                                style: 0
                            },
                            vertGridProperties: {
                                color: "#363c4e",
                                style: 0
                            },
                            horzGridProperties: {
                                color: "#363c4e",
                                style: 0
                            },
                            crossHairProperties: {
                                color: "#758696",
                                style: 2,
                                transparency: 0,
                                width: 1
                            },
                            topMargin: 17,
                            bottomMargin: 15,
                            leftAxisProperties: {
                                autoScale: true,
                                autoScaleDisabled: false,
                                lockScale: false,
                                percentage: false,
                                percentageDisabled: false,
                                indexedTo100: false,
                                log: false,
                                logDisabled: false,
                                alignLabels: true
                            },
                            rightAxisProperties: {
                                autoScale: true,
                                autoScaleDisabled: false,
                                lockScale: false,
                                percentage: false,
                                percentageDisabled: false,
                                log: false,
                                logDisabled: false,
                                alignLabels: true
                            },
                            legendProperties: {
                                showStudyArguments: true,
                                showStudyTitles: true,
                                showStudyValues: false,
                                showSeriesTitle: true,
                                showSeriesOHLC: true,
                                showLegend: false,
                                showBarChange: true,
                                showOnlyPriceSource: true
                            }
                        },
                        scalesProperties: {
                            showLeftScale: false,
                            showRightScale: true,
                            backgroundColor: "#ffffff",
                            lineColor: "#787878",
                            textColor: "#D9D9D9",
                            fontSize: 11,
                            scaleSeriesOnly: false,
                            showSeriesLastValue: true,
                            showSeriesPrevCloseValue: false,
                            showStudyLastValue: true,
                            showSymbolLabels: false,
                            showStudyPlotLabels: false,
                            barSpacing: 6
                        },
                        chartEventsSourceProperties: {
                            visible: true,
                            futureOnly: true,
                            breaks: {
                                color: "rgba(85, 85, 85, 1)",
                                visible: false,
                                style: 2,
                                width: 1
                            }
                        }
                    },
                    version: 2,
                    timezone: "Etc/UTC"
                }, 
            ]
        }
    },
    {
        key: "default",
        name: "Default",
        template: {
            layout: "s",
            charts: [
                {
                    panes: [
                        {
                            sources: [
                                {
                                    type: "MainSeries",
                                    id: "_seriesId",
                                    zorder: 0,
                                    haStyle: {
                                        studyId: "BarSetHeikenAshi@tv-basicstudies-60"
                                    },
                                    renkoStyle: {
                                        studyId: "BarSetRenko@tv-prostudies-64"
                                    },
                                    pbStyle: {
                                        studyId: "BarSetPriceBreak@tv-prostudies-34"
                                    },
                                    kagiStyle: {
                                        studyId: "BarSetKagi@tv-prostudies-34"
                                    },
                                    pnfStyle: {
                                        studyId: "BarSetPnF@tv-prostudies-34"
                                    },
                                    rangeStyle: {
                                        studyId: "BarSetRange@tv-basicstudies-72"
                                    },
                                    formattingDeps: {
                                        format: "price",
                                        pricescale: 100,
                                        minmov: 1
                                    },
                                    state: {
                                        style: 1,
                                        esdShowDividends: true,
                                        esdShowSplits: true,
                                        esdShowEarnings: true,
                                        esdShowBreaks: false,
                                        esdFlagSize: 2,
                                        showContinuousContractSwitches: true,
                                        showContinuousContractSwitchesBreaks: false,
                                        showFuturesContractExpiration: true,
                                        showLastNews: true,
                                        showCountdown: false,
                                        bidAsk: {
                                            visible: false,
                                            lineStyle: 1,
                                            lineWidth: 1,
                                            bidLineColor: "#2962FF",
                                            askLineColor: "#F7525F"
                                        },
                                        prePostMarket: {
                                            visible: true,
                                            lineStyle: 1,
                                            lineWidth: 1,
                                            preMarketColor: "#FB8C00",
                                            postMarketColor: "#2962FF"
                                        },
                                        highLowAvgPrice: {
                                            highLowPriceLinesVisible: false,
                                            highLowPriceLabelsVisible: false,
                                            averageClosePriceLineVisible: false,
                                            averageClosePriceLabelVisible: false,
                                            highLowPriceLinesColor: "",
                                            highLowPriceLinesWidth: 1,
                                            averagePriceLineColor: "",
                                            averagePriceLineWidth: 1
                                        },
                                        visible: true,
                                        showPriceLine: true,
                                        priceLineWidth: 1,
                                        priceLineColor: "",
                                        baseLineColor: "#B2B5BE",
                                        showPrevClosePriceLine: false,
                                        prevClosePriceLineWidth: 1,
                                        prevClosePriceLineColor: "#555555",
                                        minTick: "default",
                                        dividendsAdjustment: null,
                                        backAdjustment: false,
                                        settlementAsClose: true,
                                        sessionId: "regular",
                                        sessVis: false,
                                        statusViewStyle: {
                                            fontSize: 16,
                                            showExchange: true,
                                            showInterval: true,
                                            symbolTextSource: "description",
                                            showSymbolAsDescription: false
                                        },
                                        candleStyle: {
                                            upColor: "#009900",
                                            downColor: "#B80E0C",
                                            drawWick: true,
                                            drawBorder: true,
                                            borderColor: "#000000",
                                            borderUpColor: "#000000",
                                            borderDownColor: "#000000",
                                            wickColor: "#737375",
                                            wickUpColor: "#000000",
                                            wickDownColor: "#000000",
                                            barColorsOnPrevClose: false,
                                            drawBody: true
                                        },
                                        hollowCandleStyle: {
                                            upColor: "#089981",
                                            downColor: "#F23645",
                                            drawWick: true,
                                            drawBorder: true,
                                            borderColor: "#378658",
                                            borderUpColor: "#089981",
                                            borderDownColor: "#F23645",
                                            wickColor: "#737375",
                                            wickUpColor: "#089981",
                                            wickDownColor: "#F23645",
                                            drawBody: true
                                        },
                                        haStyle: {
                                            upColor: "#089981",
                                            downColor: "#F23645",
                                            drawWick: true,
                                            drawBorder: true,
                                            borderColor: "#378658",
                                            borderUpColor: "#089981",
                                            borderDownColor: "#F23645",
                                            wickColor: "#737375",
                                            wickUpColor: "#089981",
                                            wickDownColor: "#F23645",
                                            showRealLastPrice: false,
                                            barColorsOnPrevClose: false,
                                            inputs: {},
                                            inputInfo: {},
                                            drawBody: true
                                        },
                                        barStyle: {
                                            upColor: "#089981",
                                            downColor: "#F23645",
                                            barColorsOnPrevClose: false,
                                            dontDrawOpen: false,
                                            thinBars: true
                                        },
                                        hiloStyle: {
                                            color: "#2962FF",
                                            showBorders: true,
                                            borderColor: "#2962FF",
                                            showLabels: true,
                                            labelColor: "#2962FF",
                                            drawBody: true,
                                            fontSize: 7
                                        },
                                        columnStyle: {
                                            upColor: "rgba(8, 153, 129, 0.5)",
                                            downColor: "rgba(242, 54, 69, 0.5)",
                                            barColorsOnPrevClose: true,
                                            priceSource: "close"
                                        },
                                        lineStyle: {
                                            color: "#2962FF",
                                            linestyle: 0,
                                            linewidth: 2,
                                            priceSource: "close"
                                        },
                                        lineWithMarkersStyle: {
                                            color: "#2962FF",
                                            linestyle: 0,
                                            linewidth: 2,
                                            priceSource: "close"
                                        },
                                        steplineStyle: {
                                            color: "#2962FF",
                                            linestyle: 0,
                                            linewidth: 2,
                                            priceSource: "close"
                                        },
                                        areaStyle: {
                                            color1: "rgba(41, 98, 255, 0.28)",
                                            color2: "#2962FF",
                                            linecolor: "#2962FF",
                                            linestyle: 0,
                                            linewidth: 1,
                                            priceSource: "close",
                                            transparency: 100
                                        },
                                        hlcAreaStyle: {
                                            highLineColor: "#089981",
                                            highLineStyle: 0,
                                            highLineWidth: 2,
                                            lowLineColor: "#F23645",
                                            lowLineStyle: 0,
                                            lowLineWidth: 2,
                                            closeLineColor: "#868993",
                                            closeLineStyle: 0,
                                            closeLineWidth: 2,
                                            highCloseFillColor: "rgba(8, 153, 129, 0.2)",
                                            closeLowFillColor: "rgba(242, 54, 69, 0.2)"
                                        },
                                        renkoStyle: {
                                            upColor: "#089981",
                                            downColor: "#F23645",
                                            borderUpColor: "#089981",
                                            borderDownColor: "#F23645",
                                            upColorProjection: "#a9dcc3",
                                            downColorProjection: "#f5a6ae",
                                            borderUpColorProjection: "#a9dcc3",
                                            borderDownColorProjection: "#f5a6ae",
                                            wickUpColor: "#089981",
                                            wickDownColor: "#F23645",
                                            inputs: {
                                                source: "close",
                                                sources: "Close",
                                                boxSize: 3,
                                                style: "ATR",
                                                atrLength: 14,
                                                wicks: true
                                            },
                                            inputInfo: {
                                                source: {
                                                    name: "Source"
                                                },
                                                sources: {
                                                    name: "Source"
                                                },
                                                boxSize: {
                                                    name: "Box size"
                                                },
                                                style: {
                                                    name: "Style"
                                                },
                                                atrLength: {
                                                    name: "ATR length"
                                                },
                                                wicks: {
                                                    name: "Wicks"
                                                }
                                            }
                                        },
                                        pbStyle: {
                                            upColor: "#089981",
                                            downColor: "#F23645",
                                            borderUpColor: "#089981",
                                            borderDownColor: "#F23645",
                                            upColorProjection: "#a9dcc3",
                                            downColorProjection: "#f5a6ae",
                                            borderUpColorProjection: "#a9dcc3",
                                            borderDownColorProjection: "#f5a6ae",
                                            inputs: {
                                                source: "close",
                                                lb: 3
                                            },
                                            inputInfo: {
                                                source: {
                                                    name: "Source"
                                                },
                                                lb: {
                                                    name: "Number of line"
                                                }
                                            }
                                        },
                                        kagiStyle: {
                                            upColor: "#089981",
                                            downColor: "#F23645",
                                            upColorProjection: "#a9dcc3",
                                            downColorProjection: "#f5a6ae",
                                            inputs: {
                                                source: "close",
                                                style: "ATR",
                                                atrLength: 14,
                                                reversalAmount: 1
                                            },
                                            inputInfo: {
                                                source: {
                                                    name: "Source"
                                                },
                                                style: {
                                                    name: "Style"
                                                },
                                                atrLength: {
                                                    name: "ATR length"
                                                },
                                                reversalAmount: {
                                                    name: "Reversal amount"
                                                }
                                            }
                                        },
                                        pnfStyle: {
                                            upColor: "#089981",
                                            downColor: "#F23645",
                                            upColorProjection: "#a9dcc3",
                                            downColorProjection: "#f5a6ae",
                                            inputs: {
                                                sources: "Close",
                                                reversalAmount: 3,
                                                boxSize: 1,
                                                style: "ATR",
                                                atrLength: 14,
                                                oneStepBackBuilding: false
                                            },
                                            inputInfo: {
                                                sources: {
                                                    name: "Source"
                                                },
                                                boxSize: {
                                                    name: "Box size"
                                                },
                                                reversalAmount: {
                                                    name: "Reversal amount"
                                                },
                                                style: {
                                                    name: "Style"
                                                },
                                                atrLength: {
                                                    name: "ATR length"
                                                },
                                                oneStepBackBuilding: {
                                                    name: "One step back building"
                                                }
                                            }
                                        },
                                        baselineStyle: {
                                            baselineColor: "#758696",
                                            topFillColor1: "rgba(8, 153, 129, 0.28)",
                                            topFillColor2: "rgba(8, 153, 129, 0.05)",
                                            bottomFillColor1: "rgba(242, 54, 69, 0.05)",
                                            bottomFillColor2: "rgba(242, 54, 69, 0.28)",
                                            topLineColor: "#089981",
                                            bottomLineColor: "#F23645",
                                            topLineWidth: 1,
                                            bottomLineWidth: 1,
                                            priceSource: "close",
                                            transparency: 50,
                                            baseLevelPercentage: 50
                                        },
                                        rangeStyle: {
                                            barStyle: 0,
                                            upColor: "#089981",
                                            downColor: "#F23645",
                                            upColorProjection: "#a9dcc3",
                                            downColorProjection: "#f5a6ae",
                                            thinBars: true,
                                            candlesUpColor: "#089981",
                                            candlesDownColor: "#F23645",
                                            candlesBorderUpColor: "#089981",
                                            candlesBorderDownColor: "#F23645",
                                            candlesWickUpColor: "#089981",
                                            candlesWickDownColor: "#F23645",
                                            inputs: {
                                                range: 10,
                                                phantomBars: false
                                            },
                                            inputInfo: {
                                                range: {
                                                    name: "Range"
                                                },
                                                phantomBars: {
                                                    name: "Phantom bars"
                                                }
                                            }
                                        },
                                        symbol: "IHSG",
                                        shortName: "IHSG",
                                        timeframe: "",
                                        onWidget: false,
                                        interval: "D",
                                        unitId: null,
                                        showInDataWindow: true,
                                        showSessions: false,
                                        shortname: "",
                                        currencyId: null,
                                        priceAxisProperties: {
                                            autoScale: true,
                                            autoScaleDisabled: false,
                                            lockScale: false,
                                            percentage: false,
                                            percentageDisabled: false,
                                            log: false,
                                            logDisabled: false,
                                            alignLabels: true,
                                            isInverted: false,
                                            indexedTo100: false
                                        }
                                    }
                                },
                                {
                                    type: "Study",
                                    id: "P1a4zR",
                                    state: {
                                        styles: {
                                            plot_0: {
                                                display: 15,
                                                linestyle: 0,
                                                linewidth: 2,
                                                plottype: 0,
                                                trackPrice: false,
                                                transparency: 11,
                                                color: "#D04EB1",
                                                title: "plot_0"
                                            },
                                            smoothedMA: {
                                                display: 0,
                                                linestyle: 0,
                                                linewidth: 1,
                                                plottype: 0,
                                                trackPrice: false,
                                                transparency: 0,
                                                color: "#0496ff",
                                                title: "smoothedMA"
                                            }
                                        },
                                        inputs: {
                                            symbol: "",
                                            length: 50,
                                            source: "close",
                                            offset: 0,
                                            smoothingLine: "SMA",
                                            smoothingLength: 9
                                        },
                                        precision: "default",
                                        bands: {},
                                        graphics: {},
                                        ohlcPlots: {},
                                        palettes: {},
                                        filledAreasStyle: {},
                                        filledAreas: {},
                                        visible: true,
                                        showLegendValues: true,
                                        showLabelsOnPriceScale: true,
                                        parentSources: {},
                                        intervalsVisibilities: {
                                            ticks: true,
                                            seconds: true,
                                            secondsFrom: 1,
                                            secondsTo: 59,
                                            minutes: true,
                                            minutesFrom: 1,
                                            minutesTo: 59,
                                            hours: true,
                                            hoursFrom: 1,
                                            hoursTo: 24,
                                            days: true,
                                            daysFrom: 1,
                                            daysTo: 366,
                                            weeks: true,
                                            weeksFrom: 1,
                                            weeksTo: 52,
                                            months: true,
                                            monthsFrom: 1,
                                            monthsTo: 12,
                                            ranges: true
                                        }
                                    },
                                    zorder: -10000,
                                    ownFirstValue: null,
                                    metaInfo: {
                                        palettes: {},
                                        inputs: [
                                            {
                                                id: "symbol",
                                                name: "Other Symbol",
                                                defval: "",
                                                type: "symbol",
                                                optional: true,
                                                isHidden: false,
                                                display: 15
                                            },
                                            {
                                                id: "length",
                                                name: "Length",
                                                defval: 9,
                                                type: "integer",
                                                min: 1,
                                                max: 10000,
                                                display: 15
                                            },
                                            {
                                                id: "source",
                                                name: "Source",
                                                defval: "close",
                                                type: "source",
                                                options: [
                                                    "open",
                                                    "high",
                                                    "low",
                                                    "close",
                                                    "hl2",
                                                    "hlc3",
                                                    "ohlc4", 
                                                ],
                                                display: 15
                                            },
                                            {
                                                id: "offset",
                                                name: "Offset",
                                                defval: 0,
                                                type: "integer",
                                                min: -10000,
                                                max: 10000,
                                                display: 15
                                            },
                                            {
                                                id: "smoothingLine",
                                                name: "Smoothing Line",
                                                defval: "SMA",
                                                type: "text",
                                                options: [
                                                    "SMA",
                                                    "EMA",
                                                    "WMA"
                                                ],
                                                display: 15
                                            },
                                            {
                                                id: "smoothingLength",
                                                name: "Smoothing Length",
                                                defval: 9,
                                                type: "integer",
                                                min: 1,
                                                max: 10000,
                                                display: 15
                                            }, 
                                        ],
                                        plots: [
                                            {
                                                id: "plot_0",
                                                type: "line"
                                            },
                                            {
                                                id: "smoothedMA",
                                                type: "line"
                                            }, 
                                        ],
                                        graphics: {},
                                        defaults: {
                                            styles: {
                                                plot_0: {
                                                    display: 15,
                                                    linestyle: 0,
                                                    linewidth: 1,
                                                    plottype: 0,
                                                    trackPrice: false,
                                                    transparency: 0,
                                                    color: "#2196F3"
                                                },
                                                smoothedMA: {
                                                    display: 0,
                                                    linestyle: 0,
                                                    linewidth: 1,
                                                    plottype: 0,
                                                    trackPrice: false,
                                                    transparency: 0
                                                }
                                            },
                                            inputs: {
                                                symbol: "",
                                                length: 9,
                                                source: "close",
                                                offset: 0,
                                                smoothingLine: "SMA",
                                                smoothingLength: 9
                                            }
                                        },
                                        _metainfoVersion: 53,
                                        isTVScript: false,
                                        isTVScriptStub: false,
                                        is_hidden_study: false,
                                        styles: {
                                            plot_0: {
                                                title: "Plot",
                                                histogramBase: 0,
                                                joinPoints: false
                                            },
                                            smoothedMA: {
                                                title: "Smoothed MA",
                                                histogramBase: 0,
                                                joinPoints: false
                                            }
                                        },
                                        description: "Moving Average",
                                        shortDescription: "MA",
                                        is_price_study: true,
                                        id: "Moving Average@tv-basicstudies-1",
                                        scriptIdPart: "",
                                        name: "Moving Average",
                                        format: {
                                            type: "inherit"
                                        },
                                        symbolSource: {
                                            type: "symbolInputSymbolSource",
                                            inputId: "symbol"
                                        },
                                        description_localized: "Moving Average",
                                        shortId: "Moving Average",
                                        packageId: "tv-basicstudies",
                                        version: "1",
                                        fullId: "Moving Average@tv-basicstudies-1",
                                        productId: "tv-basicstudies",
                                        _serverMetaInfoVersion: 52
                                    }
                                },
                                {
                                    type: "Study",
                                    id: "3soaUC",
                                    state: {
                                        styles: {
                                            plot_0: {
                                                display: 15,
                                                linestyle: 0,
                                                linewidth: 2,
                                                plottype: 0,
                                                trackPrice: false,
                                                transparency: 11,
                                                color: "#7CA7EB",
                                                title: "plot_0"
                                            },
                                            smoothedMA: {
                                                display: 0,
                                                linestyle: 0,
                                                linewidth: 1,
                                                plottype: 0,
                                                trackPrice: false,
                                                transparency: 0,
                                                color: "#044bff",
                                                title: "smoothedMA"
                                            }
                                        },
                                        inputs: {
                                            symbol: "",
                                            length: 100,
                                            source: "close",
                                            offset: 0,
                                            smoothingLine: "SMA",
                                            smoothingLength: 9
                                        },
                                        precision: "default",
                                        bands: {},
                                        graphics: {},
                                        ohlcPlots: {},
                                        palettes: {},
                                        filledAreasStyle: {},
                                        filledAreas: {},
                                        visible: true,
                                        showLegendValues: true,
                                        showLabelsOnPriceScale: true,
                                        parentSources: {},
                                        intervalsVisibilities: {
                                            ticks: true,
                                            seconds: true,
                                            secondsFrom: 1,
                                            secondsTo: 59,
                                            minutes: true,
                                            minutesFrom: 1,
                                            minutesTo: 59,
                                            hours: true,
                                            hoursFrom: 1,
                                            hoursTo: 24,
                                            days: true,
                                            daysFrom: 1,
                                            daysTo: 366,
                                            weeks: true,
                                            weeksFrom: 1,
                                            weeksTo: 52,
                                            months: true,
                                            monthsFrom: 1,
                                            monthsTo: 12,
                                            ranges: true
                                        }
                                    },
                                    zorder: -20000,
                                    ownFirstValue: null,
                                    metaInfo: {
                                        palettes: {},
                                        inputs: [
                                            {
                                                id: "symbol",
                                                name: "Other Symbol",
                                                defval: "",
                                                type: "symbol",
                                                optional: true,
                                                isHidden: false,
                                                display: 15
                                            },
                                            {
                                                id: "length",
                                                name: "Length",
                                                defval: 9,
                                                type: "integer",
                                                min: 1,
                                                max: 10000,
                                                display: 15
                                            },
                                            {
                                                id: "source",
                                                name: "Source",
                                                defval: "close",
                                                type: "source",
                                                options: [
                                                    "open",
                                                    "high",
                                                    "low",
                                                    "close",
                                                    "hl2",
                                                    "hlc3",
                                                    "ohlc4", 
                                                ],
                                                display: 15
                                            },
                                            {
                                                id: "offset",
                                                name: "Offset",
                                                defval: 0,
                                                type: "integer",
                                                min: -10000,
                                                max: 10000,
                                                display: 15
                                            },
                                            {
                                                id: "smoothingLine",
                                                name: "Smoothing Line",
                                                defval: "SMA",
                                                type: "text",
                                                options: [
                                                    "SMA",
                                                    "EMA",
                                                    "WMA"
                                                ],
                                                display: 15
                                            },
                                            {
                                                id: "smoothingLength",
                                                name: "Smoothing Length",
                                                defval: 9,
                                                type: "integer",
                                                min: 1,
                                                max: 10000,
                                                display: 15
                                            }, 
                                        ],
                                        plots: [
                                            {
                                                id: "plot_0",
                                                type: "line"
                                            },
                                            {
                                                id: "smoothedMA",
                                                type: "line"
                                            }, 
                                        ],
                                        graphics: {},
                                        defaults: {
                                            styles: {
                                                plot_0: {
                                                    display: 15,
                                                    linestyle: 0,
                                                    linewidth: 1,
                                                    plottype: 0,
                                                    trackPrice: false,
                                                    transparency: 0,
                                                    color: "#2196F3"
                                                },
                                                smoothedMA: {
                                                    display: 0,
                                                    linestyle: 0,
                                                    linewidth: 1,
                                                    plottype: 0,
                                                    trackPrice: false,
                                                    transparency: 0
                                                }
                                            },
                                            inputs: {
                                                symbol: "",
                                                length: 9,
                                                source: "close",
                                                offset: 0,
                                                smoothingLine: "SMA",
                                                smoothingLength: 9
                                            }
                                        },
                                        _metainfoVersion: 53,
                                        isTVScript: false,
                                        isTVScriptStub: false,
                                        is_hidden_study: false,
                                        styles: {
                                            plot_0: {
                                                title: "Plot",
                                                histogramBase: 0,
                                                joinPoints: false
                                            },
                                            smoothedMA: {
                                                title: "Smoothed MA",
                                                histogramBase: 0,
                                                joinPoints: false
                                            }
                                        },
                                        description: "Moving Average",
                                        shortDescription: "MA",
                                        is_price_study: true,
                                        id: "Moving Average@tv-basicstudies-1",
                                        scriptIdPart: "",
                                        name: "Moving Average",
                                        format: {
                                            type: "inherit"
                                        },
                                        symbolSource: {
                                            type: "symbolInputSymbolSource",
                                            inputId: "symbol"
                                        },
                                        description_localized: "Moving Average",
                                        shortId: "Moving Average",
                                        packageId: "tv-basicstudies",
                                        version: "1",
                                        fullId: "Moving Average@tv-basicstudies-1",
                                        productId: "tv-basicstudies",
                                        _serverMetaInfoVersion: 52
                                    }
                                },
                                {
                                    type: "Study",
                                    id: "8F3HDM",
                                    state: {
                                        styles: {
                                            plot_0: {
                                                display: 15,
                                                linestyle: 0,
                                                linewidth: 2,
                                                plottype: 0,
                                                trackPrice: false,
                                                transparency: 11,
                                                color: "#3AA36D",
                                                title: "plot_0"
                                            },
                                            smoothedMA: {
                                                display: 0,
                                                linestyle: 0,
                                                linewidth: 1,
                                                plottype: 0,
                                                trackPrice: false,
                                                transparency: 0,
                                                color: "#0904ff",
                                                title: "smoothedMA"
                                            }
                                        },
                                        inputs: {
                                            symbol: "",
                                            length: 200,
                                            source: "close",
                                            offset: 0,
                                            smoothingLine: "SMA",
                                            smoothingLength: 9
                                        },
                                        precision: "default",
                                        bands: {},
                                        graphics: {},
                                        ohlcPlots: {},
                                        palettes: {},
                                        filledAreasStyle: {},
                                        filledAreas: {},
                                        visible: true,
                                        showLegendValues: true,
                                        showLabelsOnPriceScale: true,
                                        parentSources: {},
                                        intervalsVisibilities: {
                                            ticks: true,
                                            seconds: true,
                                            secondsFrom: 1,
                                            secondsTo: 59,
                                            minutes: true,
                                            minutesFrom: 1,
                                            minutesTo: 59,
                                            hours: true,
                                            hoursFrom: 1,
                                            hoursTo: 24,
                                            days: true,
                                            daysFrom: 1,
                                            daysTo: 366,
                                            weeks: true,
                                            weeksFrom: 1,
                                            weeksTo: 52,
                                            months: true,
                                            monthsFrom: 1,
                                            monthsTo: 12,
                                            ranges: true
                                        }
                                    },
                                    zorder: -30000,
                                    ownFirstValue: null,
                                    metaInfo: {
                                        palettes: {},
                                        inputs: [
                                            {
                                                id: "symbol",
                                                name: "Other Symbol",
                                                defval: "",
                                                type: "symbol",
                                                optional: true,
                                                isHidden: false,
                                                display: 15
                                            },
                                            {
                                                id: "length",
                                                name: "Length",
                                                defval: 9,
                                                type: "integer",
                                                min: 1,
                                                max: 10000,
                                                display: 15
                                            },
                                            {
                                                id: "source",
                                                name: "Source",
                                                defval: "close",
                                                type: "source",
                                                options: [
                                                    "open",
                                                    "high",
                                                    "low",
                                                    "close",
                                                    "hl2",
                                                    "hlc3",
                                                    "ohlc4", 
                                                ],
                                                display: 15
                                            },
                                            {
                                                id: "offset",
                                                name: "Offset",
                                                defval: 0,
                                                type: "integer",
                                                min: -10000,
                                                max: 10000,
                                                display: 15
                                            },
                                            {
                                                id: "smoothingLine",
                                                name: "Smoothing Line",
                                                defval: "SMA",
                                                type: "text",
                                                options: [
                                                    "SMA",
                                                    "EMA",
                                                    "WMA"
                                                ],
                                                display: 15
                                            },
                                            {
                                                id: "smoothingLength",
                                                name: "Smoothing Length",
                                                defval: 9,
                                                type: "integer",
                                                min: 1,
                                                max: 10000,
                                                display: 15
                                            }, 
                                        ],
                                        plots: [
                                            {
                                                id: "plot_0",
                                                type: "line"
                                            },
                                            {
                                                id: "smoothedMA",
                                                type: "line"
                                            }, 
                                        ],
                                        graphics: {},
                                        defaults: {
                                            styles: {
                                                plot_0: {
                                                    display: 15,
                                                    linestyle: 0,
                                                    linewidth: 1,
                                                    plottype: 0,
                                                    trackPrice: false,
                                                    transparency: 0,
                                                    color: "#2196F3"
                                                },
                                                smoothedMA: {
                                                    display: 0,
                                                    linestyle: 0,
                                                    linewidth: 1,
                                                    plottype: 0,
                                                    trackPrice: false,
                                                    transparency: 0
                                                }
                                            },
                                            inputs: {
                                                symbol: "",
                                                length: 9,
                                                source: "close",
                                                offset: 0,
                                                smoothingLine: "SMA",
                                                smoothingLength: 9
                                            }
                                        },
                                        _metainfoVersion: 53,
                                        isTVScript: false,
                                        isTVScriptStub: false,
                                        is_hidden_study: false,
                                        styles: {
                                            plot_0: {
                                                title: "Plot",
                                                histogramBase: 0,
                                                joinPoints: false
                                            },
                                            smoothedMA: {
                                                title: "Smoothed MA",
                                                histogramBase: 0,
                                                joinPoints: false
                                            }
                                        },
                                        description: "Moving Average",
                                        shortDescription: "MA",
                                        is_price_study: true,
                                        id: "Moving Average@tv-basicstudies-1",
                                        scriptIdPart: "",
                                        name: "Moving Average",
                                        format: {
                                            type: "inherit"
                                        },
                                        symbolSource: {
                                            type: "symbolInputSymbolSource",
                                            inputId: "symbol"
                                        },
                                        description_localized: "Moving Average",
                                        shortId: "Moving Average",
                                        packageId: "tv-basicstudies",
                                        version: "1",
                                        fullId: "Moving Average@tv-basicstudies-1",
                                        productId: "tv-basicstudies",
                                        _serverMetaInfoVersion: 52
                                    }
                                }, 
                            ],
                            mainSourceId: "_seriesId",
                            stretchFactor: 4331.438645097106,
                            leftAxisesState: [],
                            rightAxisesState: [
                                {
                                    state: {
                                        id: "EZXBZ45NPMO6",
                                        m_priceRange: null,
                                        m_isAutoScale: true,
                                        m_isPercentage: false,
                                        m_isIndexedTo100: false,
                                        m_isLog: false,
                                        m_isLockScale: false,
                                        m_isInverted: false,
                                        m_topMargin: 0.17,
                                        m_bottomMargin: 0.15,
                                        alignLabels: true,
                                        logFormula: {
                                            logicalOffset: 4,
                                            coordOffset: 0.0001
                                        }
                                    },
                                    sources: [
                                        "_seriesId",
                                        "P1a4zR",
                                        "3soaUC",
                                        "8F3HDM"
                                    ]
                                }, 
                            ],
                            overlayPriceScales: {},
                            priceScaleRatio: null
                        },
                        {
                            sources: [
                                {
                                    type: "Study",
                                    id: "poq8Ua",
                                    state: {
                                        styles: {
                                            vol: {
                                                display: 15,
                                                linestyle: 0,
                                                linewidth: 1,
                                                plottype: 5,
                                                trackPrice: false,
                                                transparency: 0,
                                                color: "#000080",
                                                title: "vol"
                                            },
                                            vol_ma: {
                                                display: 15,
                                                linestyle: 0,
                                                linewidth: 2,
                                                plottype: 0,
                                                trackPrice: false,
                                                transparency: 30,
                                                color: "#0496ff",
                                                title: "vol_ma"
                                            }
                                        },
                                        precision: "default",
                                        palettes: {
                                            volumePalette: {
                                                colors: {
                                                    0: {
                                                        color: "rgba(235, 77, 92, 0.50)",
                                                        width: 1,
                                                        style: 0
                                                    },
                                                    1: {
                                                        color: "rgba(83, 185, 135, 0.50)",
                                                        width: 1,
                                                        style: 0
                                                    }
                                                }
                                            }
                                        },
                                        inputs: {
                                            showMA: true,
                                            maLength: 20
                                        },
                                        bands: {},
                                        graphics: {},
                                        ohlcPlots: {},
                                        filledAreasStyle: {},
                                        filledAreas: {},
                                        visible: true,
                                        showLegendValues: true,
                                        showLabelsOnPriceScale: true,
                                        parentSources: {},
                                        intervalsVisibilities: {
                                            ticks: true,
                                            seconds: true,
                                            secondsFrom: 1,
                                            secondsTo: 59,
                                            minutes: true,
                                            minutesFrom: 1,
                                            minutesTo: 59,
                                            hours: true,
                                            hoursFrom: 1,
                                            hoursTo: 24,
                                            days: true,
                                            daysFrom: 1,
                                            daysTo: 366,
                                            weeks: true,
                                            weeksFrom: 1,
                                            weeksTo: 52,
                                            months: true,
                                            monthsFrom: 1,
                                            monthsTo: 12,
                                            ranges: true
                                        }
                                    },
                                    zorder: -10000,
                                    ownFirstValue: null,
                                    metaInfo: {
                                        palettes: {
                                            volumePalette: {
                                                colors: [
                                                    {
                                                        name: "Falling"
                                                    },
                                                    {
                                                        name: "Growing"
                                                    }
                                                ]
                                            }
                                        },
                                        inputs: [
                                            {
                                                id: "showMA",
                                                name: "show MA",
                                                defval: true,
                                                type: "bool",
                                                display: 0
                                            },
                                            {
                                                id: "maLength",
                                                name: "MA Length",
                                                defval: 20,
                                                type: "integer",
                                                min: 1,
                                                max: 2000,
                                                display: 15
                                            }, 
                                        ],
                                        plots: [
                                            {
                                                id: "vol",
                                                type: "line"
                                            },
                                            {
                                                id: "volumePalette",
                                                palette: "volumePalette",
                                                target: "vol",
                                                type: "colorer"
                                            },
                                            {
                                                id: "vol_ma",
                                                type: "line"
                                            }, 
                                        ],
                                        graphics: {},
                                        defaults: {
                                            styles: {
                                                vol: {
                                                    display: 15,
                                                    linestyle: 0,
                                                    linewidth: 1,
                                                    plottype: 5,
                                                    trackPrice: false,
                                                    transparency: 0,
                                                    color: "#000080"
                                                },
                                                vol_ma: {
                                                    display: 15,
                                                    linestyle: 0,
                                                    linewidth: 2,
                                                    plottype: 0,
                                                    trackPrice: false,
                                                    transparency: 30,
                                                    color: "#0496FF"
                                                }
                                            },
                                            precision: 0,
                                            palettes: {
                                                volumePalette: {
                                                    colors: {
                                                        0: {
                                                            color: "rgba(235, 77, 92, 0.50)",
                                                            width: 1,
                                                            style: 0
                                                        },
                                                        1: {
                                                            color: "rgba(83, 185, 135, 0.50)",
                                                            width: 1,
                                                            style: 0
                                                        }
                                                    }
                                                }
                                            },
                                            inputs: {
                                                showMA: true,
                                                maLength: 20
                                            }
                                        },
                                        _metainfoVersion: 53,
                                        id: "Volume_@tv-basicstudies-1",
                                        is_hidden_study: false,
                                        description: "Volume_",
                                        shortDescription: "Volume",
                                        is_price_study: false,
                                        format: {
                                            type: "volume",
                                            precision: 3
                                        },
                                        styles: {
                                            vol: {
                                                title: "Volume_",
                                                histogramBase: 0
                                            },
                                            vol_ma: {
                                                title: "Volume MA",
                                                histogramBase: 0
                                            }
                                        },
                                        description_localized: "Volume_",
                                        shortId: "Volume_",
                                        packageId: "tv-basicstudies",
                                        version: "1",
                                        fullId: "Volume_@tv-basicstudies-1",
                                        productId: "tv-basicstudies",
                                        _serverMetaInfoVersion: 51
                                    }
                                }, 
                            ],
                            mainSourceId: "poq8Ua",
                            stretchFactor: 761.6340921567289,
                            leftAxisesState: [],
                            rightAxisesState: [
                                {
                                    state: {
                                        id: "Nt7ZxxUJbdwF",
                                        m_priceRange: null,
                                        m_isAutoScale: true,
                                        m_isPercentage: false,
                                        m_isIndexedTo100: false,
                                        m_isLog: false,
                                        m_isLockScale: false,
                                        m_isInverted: false,
                                        m_topMargin: 0.17,
                                        m_bottomMargin: 0.15,
                                        alignLabels: true,
                                        logFormula: {
                                            logicalOffset: 4,
                                            coordOffset: 0.0001
                                        }
                                    },
                                    sources: [
                                        "poq8Ua"
                                    ]
                                }, 
                            ],
                            overlayPriceScales: {},
                            priceScaleRatio: null
                        },
                        {
                            sources: [
                                {
                                    type: "Study",
                                    id: "1hnSfV",
                                    state: {
                                        styles: {
                                            plot_0: {
                                                display: 15,
                                                linestyle: 0,
                                                linewidth: 1,
                                                plottype: 1,
                                                trackPrice: false,
                                                transparency: 50,
                                                color: "#FF0000",
                                                title: "plot_0"
                                            },
                                            plot_1: {
                                                display: 15,
                                                linestyle: 0,
                                                linewidth: 2,
                                                plottype: 0,
                                                trackPrice: false,
                                                transparency: 11,
                                                color: "#0E4DC9",
                                                title: "plot_1"
                                            },
                                            plot_2: {
                                                display: 15,
                                                linestyle: 0,
                                                linewidth: 2,
                                                plottype: 0,
                                                trackPrice: false,
                                                transparency: 11,
                                                color: "#A41919",
                                                title: "plot_2"
                                            }
                                        },
                                        palettes: {
                                            palette_0: {
                                                colors: {
                                                    0: {
                                                        color: "#22AB94",
                                                        width: 1,
                                                        style: 0
                                                    },
                                                    1: {
                                                        color: "#ACE5DC",
                                                        width: 1,
                                                        style: 0
                                                    },
                                                    2: {
                                                        color: "#FCCBCD",
                                                        width: 1,
                                                        style: 0
                                                    },
                                                    3: {
                                                        color: "#FF5252",
                                                        width: 1,
                                                        style: 0
                                                    }
                                                }
                                            }
                                        },
                                        inputs: {
                                            in_0: 12,
                                            in_1: 26,
                                            in_3: "close",
                                            in_2: 9
                                        },
                                        precision: 2,
                                        bands: {},
                                        graphics: {},
                                        ohlcPlots: {},
                                        filledAreasStyle: {},
                                        filledAreas: {},
                                        visible: true,
                                        showLegendValues: true,
                                        showLabelsOnPriceScale: true,
                                        parentSources: {},
                                        intervalsVisibilities: {
                                            ticks: true,
                                            seconds: true,
                                            secondsFrom: 1,
                                            secondsTo: 59,
                                            minutes: true,
                                            minutesFrom: 1,
                                            minutesTo: 59,
                                            hours: true,
                                            hoursFrom: 1,
                                            hoursTo: 24,
                                            days: true,
                                            daysFrom: 1,
                                            daysTo: 366,
                                            weeks: true,
                                            weeksFrom: 1,
                                            weeksTo: 52,
                                            months: true,
                                            monthsFrom: 1,
                                            monthsTo: 12,
                                            ranges: true
                                        }
                                    },
                                    zorder: -10000,
                                    ownFirstValue: null,
                                    metaInfo: {
                                        palettes: {
                                            palette_0: {
                                                colors: {
                                                    0: {
                                                        name: "Color 0"
                                                    },
                                                    1: {
                                                        name: "Color 1"
                                                    },
                                                    2: {
                                                        name: "Color 2"
                                                    },
                                                    3: {
                                                        name: "Color 3"
                                                    }
                                                }
                                            }
                                        },
                                        inputs: [
                                            {
                                                id: "in_0",
                                                name: "fastLength",
                                                defval: 12,
                                                type: "integer",
                                                min: 1,
                                                max: 2000,
                                                display: 15
                                            },
                                            {
                                                id: "in_1",
                                                name: "slowLength",
                                                defval: 26,
                                                type: "integer",
                                                min: 1,
                                                max: 2000,
                                                display: 15
                                            },
                                            {
                                                id: "in_3",
                                                name: "Source",
                                                defval: "close",
                                                type: "source",
                                                options: [
                                                    "open",
                                                    "high",
                                                    "low",
                                                    "close",
                                                    "hl2",
                                                    "hlc3",
                                                    "ohlc4", 
                                                ],
                                                display: 15
                                            },
                                            {
                                                id: "in_2",
                                                name: "signalLength",
                                                defval: 9,
                                                type: "integer",
                                                min: 1,
                                                max: 50,
                                                display: 15
                                            }, 
                                        ],
                                        plots: [
                                            {
                                                id: "plot_0",
                                                type: "line"
                                            },
                                            {
                                                id: "plot_1",
                                                type: "line"
                                            },
                                            {
                                                id: "plot_2",
                                                type: "line"
                                            },
                                            {
                                                id: "plot_3",
                                                palette: "palette_0",
                                                target: "plot_0",
                                                type: "colorer"
                                            }, 
                                        ],
                                        graphics: {},
                                        defaults: {
                                            styles: {
                                                plot_0: {
                                                    display: 15,
                                                    linestyle: 0,
                                                    linewidth: 1,
                                                    plottype: 5,
                                                    trackPrice: false,
                                                    transparency: 0,
                                                    color: "#FF5252"
                                                },
                                                plot_1: {
                                                    display: 15,
                                                    linestyle: 0,
                                                    linewidth: 1,
                                                    plottype: 0,
                                                    trackPrice: false,
                                                    transparency: 0,
                                                    color: "#2196F3"
                                                },
                                                plot_2: {
                                                    display: 15,
                                                    linestyle: 0,
                                                    linewidth: 1,
                                                    plottype: 0,
                                                    trackPrice: false,
                                                    transparency: 0,
                                                    color: "#FF6D00"
                                                }
                                            },
                                            palettes: {
                                                palette_0: {
                                                    colors: {
                                                        0: {
                                                            color: "#22AB94",
                                                            width: 1,
                                                            style: 0
                                                        },
                                                        1: {
                                                            color: "#ACE5DC",
                                                            width: 1,
                                                            style: 0
                                                        },
                                                        2: {
                                                            color: "#FCCBCD",
                                                            width: 1,
                                                            style: 0
                                                        },
                                                        3: {
                                                            color: "#FF5252",
                                                            width: 1,
                                                            style: 0
                                                        }
                                                    }
                                                }
                                            },
                                            inputs: {
                                                in_0: 12,
                                                in_1: 26,
                                                in_3: "close",
                                                in_2: 9
                                            }
                                        },
                                        _metainfoVersion: 53,
                                        isTVScript: false,
                                        isTVScriptStub: false,
                                        is_hidden_study: false,
                                        styles: {
                                            plot_0: {
                                                title: "Histogram",
                                                histogramBase: 0,
                                                joinPoints: false
                                            },
                                            plot_1: {
                                                title: "MACD",
                                                histogramBase: 0,
                                                joinPoints: false
                                            },
                                            plot_2: {
                                                title: "Signal",
                                                histogramBase: 0,
                                                joinPoints: false
                                            }
                                        },
                                        description: "MACD",
                                        shortDescription: "MACD",
                                        is_price_study: false,
                                        id: "Moving Average Convergence/Divergence@tv-basicstudies-1",
                                        scriptIdPart: "",
                                        name: "MACD",
                                        format: {
                                            type: "inherit"
                                        },
                                        description_localized: "MACD",
                                        shortId: "Moving Average Convergence/Divergence",
                                        packageId: "tv-basicstudies",
                                        version: "1",
                                        fullId: "Moving Average Convergence/Divergence@tv-basicstudies-1",
                                        productId: "tv-basicstudies",
                                        _serverMetaInfoVersion: 52
                                    }
                                }, 
                            ],
                            mainSourceId: "1hnSfV",
                            stretchFactor: 543.2406327462922,
                            leftAxisesState: [],
                            rightAxisesState: [
                                {
                                    state: {
                                        id: "S6NM5pHUafj7",
                                        m_priceRange: null,
                                        m_isAutoScale: true,
                                        m_isPercentage: false,
                                        m_isIndexedTo100: false,
                                        m_isLog: false,
                                        m_isLockScale: false,
                                        m_isInverted: false,
                                        m_topMargin: 0.17,
                                        m_bottomMargin: 0.15,
                                        alignLabels: true,
                                        logFormula: {
                                            logicalOffset: 4,
                                            coordOffset: 0.0001
                                        }
                                    },
                                    sources: [
                                        "1hnSfV"
                                    ]
                                }, 
                            ],
                            overlayPriceScales: {},
                            priceScaleRatio: null
                        },
                        {
                            sources: [
                                {
                                    type: "Study",
                                    id: "19Hbga",
                                    state: {
                                        styles: {
                                            plot_0: {
                                                display: 15,
                                                linestyle: 0,
                                                linewidth: 2,
                                                plottype: 0,
                                                trackPrice: false,
                                                transparency: 11,
                                                color: "#465ADB",
                                                title: "plot_0"
                                            },
                                            plot_1: {
                                                display: 15,
                                                linestyle: 0,
                                                linewidth: 2,
                                                plottype: 0,
                                                trackPrice: false,
                                                transparency: 11,
                                                color: "#A41919",
                                                title: "plot_1"
                                            },
                                            bands: {
                                                0: {
                                                    color: "rgba(152, 152, 152, 0.70)"
                                                },
                                                1: {
                                                    color: "rgba(152, 152, 152, 0.70)"
                                                }
                                            }
                                        },
                                        bands: {
                                            0: {
                                                color: "#787B86",
                                                linestyle: 2,
                                                linewidth: 1,
                                                visible: true,
                                                value: 80
                                            },
                                            1: {
                                                color: "#787B86",
                                                linestyle: 2,
                                                linewidth: 1,
                                                visible: true,
                                                value: 20
                                            }
                                        },
                                        filledAreasStyle: {
                                            fill_0: {
                                                color: "#2196F3",
                                                transparency: 90,
                                                visible: false
                                            }
                                        },
                                        inputs: {
                                            in_0: 15,
                                            in_1: 1,
                                            in_2: 3
                                        },
                                        precision: 1,
                                        graphics: {},
                                        ohlcPlots: {},
                                        palettes: {},
                                        filledAreas: {},
                                        visible: true,
                                        showLegendValues: true,
                                        showLabelsOnPriceScale: true,
                                        parentSources: {},
                                        intervalsVisibilities: {
                                            ticks: true,
                                            seconds: true,
                                            secondsFrom: 1,
                                            secondsTo: 59,
                                            minutes: true,
                                            minutesFrom: 1,
                                            minutesTo: 59,
                                            hours: true,
                                            hoursFrom: 1,
                                            hoursTo: 24,
                                            days: true,
                                            daysFrom: 1,
                                            daysTo: 366,
                                            weeks: true,
                                            weeksFrom: 1,
                                            weeksTo: 52,
                                            months: true,
                                            monthsFrom: 1,
                                            monthsTo: 12,
                                            ranges: true
                                        }
                                    },
                                    zorder: -10000,
                                    ownFirstValue: null,
                                    metaInfo: {
                                        palettes: {},
                                        inputs: [
                                            {
                                                id: "in_0",
                                                name: "K",
                                                defval: 14,
                                                type: "integer",
                                                min: 1,
                                                max: 10000,
                                                display: 15
                                            },
                                            {
                                                id: "in_1",
                                                name: "D",
                                                defval: 1,
                                                type: "integer",
                                                min: 1,
                                                max: 10000,
                                                display: 15
                                            },
                                            {
                                                id: "in_2",
                                                name: "smooth",
                                                defval: 3,
                                                type: "integer",
                                                min: 1,
                                                max: 10000,
                                                display: 15
                                            }, 
                                        ],
                                        plots: [
                                            {
                                                id: "plot_0",
                                                type: "line"
                                            },
                                            {
                                                id: "plot_1",
                                                type: "line"
                                            }, 
                                        ],
                                        graphics: {},
                                        defaults: {
                                            styles: {
                                                plot_0: {
                                                    display: 15,
                                                    linestyle: 0,
                                                    linewidth: 1,
                                                    plottype: 0,
                                                    trackPrice: false,
                                                    transparency: 0,
                                                    color: "#2196F3"
                                                },
                                                plot_1: {
                                                    display: 15,
                                                    linestyle: 0,
                                                    linewidth: 1,
                                                    plottype: 0,
                                                    trackPrice: false,
                                                    transparency: 0,
                                                    color: "#FF6D00"
                                                }
                                            },
                                            bands: [
                                                {
                                                    color: "#787B86",
                                                    linestyle: 2,
                                                    linewidth: 1,
                                                    visible: true,
                                                    value: 80
                                                },
                                                {
                                                    color: "#787B86",
                                                    linestyle: 2,
                                                    linewidth: 1,
                                                    visible: true,
                                                    value: 20
                                                }, 
                                            ],
                                            filledAreasStyle: {
                                                fill_0: {
                                                    color: "#2196F3",
                                                    transparency: 90,
                                                    visible: true
                                                }
                                            },
                                            inputs: {
                                                in_0: 14,
                                                in_1: 1,
                                                in_2: 3
                                            }
                                        },
                                        _metainfoVersion: 53,
                                        isTVScript: false,
                                        isTVScriptStub: false,
                                        is_hidden_study: false,
                                        styles: {
                                            plot_0: {
                                                title: "%K",
                                                histogramBase: 0,
                                                joinPoints: false,
                                                zorder: 1.1
                                            },
                                            plot_1: {
                                                title: "%D",
                                                histogramBase: 0,
                                                joinPoints: false,
                                                zorder: 1.11
                                            }
                                        },
                                        description: "Stochastic",
                                        shortDescription: "Stoch",
                                        is_price_study: false,
                                        bands: [
                                            {
                                                id: "hline_0",
                                                name: "UpperLimit",
                                                zorder: -1.1
                                            },
                                            {
                                                id: "hline_1",
                                                name: "LowerLimit",
                                                zorder: -1.11
                                            }, 
                                        ],
                                        filledAreas: [
                                            {
                                                id: "fill_0",
                                                objAId: "hline_0",
                                                objBId: "hline_1",
                                                type: "hline_hline",
                                                title: "Hlines Background",
                                                zorder: -2
                                            }, 
                                        ],
                                        id: "Stochastic@tv-basicstudies-1",
                                        scriptIdPart: "",
                                        name: "Stochastic",
                                        format: {
                                            precision: 2,
                                            type: "price"
                                        },
                                        usePlotsZOrder: true,
                                        description_localized: "Stochastic",
                                        shortId: "Stochastic",
                                        packageId: "tv-basicstudies",
                                        version: "1",
                                        fullId: "Stochastic@tv-basicstudies-1",
                                        productId: "tv-basicstudies",
                                        _serverMetaInfoVersion: 52
                                    }
                                }, 
                            ],
                            mainSourceId: "19Hbga",
                            stretchFactor: 601.4492753623188,
                            leftAxisesState: [],
                            rightAxisesState: [
                                {
                                    state: {
                                        id: "Otfvntv5MuNa",
                                        m_priceRange: null,
                                        m_isAutoScale: true,
                                        m_isPercentage: false,
                                        m_isIndexedTo100: false,
                                        m_isLog: false,
                                        m_isLockScale: false,
                                        m_isInverted: false,
                                        m_topMargin: 0.17,
                                        m_bottomMargin: 0.15,
                                        alignLabels: true,
                                        logFormula: {
                                            logicalOffset: 4,
                                            coordOffset: 0.0001
                                        }
                                    },
                                    sources: [
                                        "19Hbga"
                                    ]
                                }, 
                            ],
                            overlayPriceScales: {},
                            priceScaleRatio: null
                        },
                        {
                            sources: [
                                {
                                    type: "Study",
                                    id: "xRlWww",
                                    state: {
                                        styles: {
                                            plot_0: {
                                                display: 15,
                                                linestyle: 0,
                                                linewidth: 2,
                                                plottype: 0,
                                                trackPrice: false,
                                                transparency: 11,
                                                color: "#1CBECB",
                                                title: "plot_0"
                                            },
                                            smoothedMA: {
                                                display: 0,
                                                linestyle: 0,
                                                linewidth: 1,
                                                plottype: 0,
                                                trackPrice: false,
                                                transparency: 0,
                                                color: "#0496ff",
                                                title: "smoothedMA"
                                            },
                                            bands: {
                                                0: {
                                                    color: "rgba(152, 152, 152, 0.70)"
                                                },
                                                1: {
                                                    color: "rgba(152, 152, 152, 0.70)"
                                                }
                                            }
                                        },
                                        bands: {
                                            0: {
                                                color: "#787B86",
                                                linestyle: 2,
                                                linewidth: 1,
                                                visible: true,
                                                value: 70,
                                                zorder: -1.1
                                            },
                                            1: {
                                                color: "#787B86",
                                                linestyle: 2,
                                                linewidth: 1,
                                                visible: true,
                                                value: 50,
                                                zorder: -1.11
                                            },
                                            2: {
                                                color: "#787B86",
                                                linestyle: 2,
                                                linewidth: 1,
                                                visible: true,
                                                value: 30,
                                                zorder: -1.111
                                            }
                                        },
                                        filledAreasStyle: {
                                            fill_0: {
                                                color: "#7E57C2",
                                                transparency: 90,
                                                visible: false
                                            }
                                        },
                                        inputs: {
                                            length: 14,
                                            smoothingLine: "SMA",
                                            smoothingLength: 14
                                        },
                                        precision: 1,
                                        graphics: {},
                                        ohlcPlots: {},
                                        palettes: {},
                                        filledAreas: {},
                                        visible: true,
                                        showLegendValues: true,
                                        showLabelsOnPriceScale: true,
                                        parentSources: {},
                                        intervalsVisibilities: {
                                            ticks: true,
                                            seconds: true,
                                            secondsFrom: 1,
                                            secondsTo: 59,
                                            minutes: true,
                                            minutesFrom: 1,
                                            minutesTo: 59,
                                            hours: true,
                                            hoursFrom: 1,
                                            hoursTo: 24,
                                            days: true,
                                            daysFrom: 1,
                                            daysTo: 366,
                                            weeks: true,
                                            weeksFrom: 1,
                                            weeksTo: 52,
                                            months: true,
                                            monthsFrom: 1,
                                            monthsTo: 12,
                                            ranges: true
                                        }
                                    },
                                    zorder: -10000,
                                    ownFirstValue: null,
                                    metaInfo: {
                                        palettes: {},
                                        inputs: [
                                            {
                                                id: "length",
                                                name: "Length",
                                                defval: 14,
                                                type: "integer",
                                                min: 1,
                                                max: 2000,
                                                display: 15
                                            },
                                            {
                                                id: "smoothingLine",
                                                name: "Smoothing Line",
                                                defval: "SMA",
                                                type: "text",
                                                options: [
                                                    "SMA",
                                                    "EMA",
                                                    "WMA"
                                                ],
                                                display: 15
                                            },
                                            {
                                                id: "smoothingLength",
                                                name: "Smoothing Length",
                                                defval: 14,
                                                type: "integer",
                                                min: 1,
                                                max: 10000,
                                                display: 15
                                            }, 
                                        ],
                                        plots: [
                                            {
                                                id: "plot_0",
                                                type: "line"
                                            },
                                            {
                                                id: "smoothedMA",
                                                type: "line"
                                            }, 
                                        ],
                                        graphics: {},
                                        defaults: {
                                            styles: {
                                                plot_0: {
                                                    display: 15,
                                                    linestyle: 0,
                                                    linewidth: 1,
                                                    plottype: 0,
                                                    trackPrice: false,
                                                    transparency: 0,
                                                    color: "#7E57C2"
                                                },
                                                smoothedMA: {
                                                    display: 0,
                                                    linestyle: 0,
                                                    linewidth: 1,
                                                    plottype: 0,
                                                    trackPrice: false,
                                                    transparency: 0
                                                }
                                            },
                                            bands: [
                                                {
                                                    color: "#787B86",
                                                    linestyle: 2,
                                                    linewidth: 1,
                                                    visible: true,
                                                    value: 70,
                                                    zorder: -1.1
                                                },
                                                {
                                                    color: "#787B86",
                                                    linestyle: 2,
                                                    linewidth: 1,
                                                    visible: true,
                                                    value: 50,
                                                    zorder: -1.11
                                                },
                                                {
                                                    color: "#787B86",
                                                    linestyle: 2,
                                                    linewidth: 1,
                                                    visible: true,
                                                    value: 30,
                                                    zorder: -1.111
                                                }, 
                                            ],
                                            filledAreasStyle: {
                                                fill_0: {
                                                    color: "#7E57C2",
                                                    transparency: 90,
                                                    visible: true
                                                }
                                            },
                                            inputs: {
                                                length: 14,
                                                smoothingLine: "SMA",
                                                smoothingLength: 14
                                            }
                                        },
                                        _metainfoVersion: 53,
                                        isTVScript: false,
                                        isTVScriptStub: false,
                                        is_hidden_study: false,
                                        styles: {
                                            plot_0: {
                                                title: "Plot",
                                                histogramBase: 0,
                                                joinPoints: false,
                                                zorder: 1
                                            },
                                            smoothedMA: {
                                                title: "Smoothed MA",
                                                histogramBase: 0,
                                                joinPoints: false,
                                                zorder: 2
                                            },
                                            "Relative Strength Index@tv-basicstudies": {
                                                title: "Smoothed MA",
                                                histogramBase: 0,
                                                joinPoints: false
                                            }
                                        },
                                        description: "Relative Strength Index",
                                        shortDescription: "RSI",
                                        is_price_study: false,
                                        bands: [
                                            {
                                                id: "hline_0",
                                                name: "UpperLimit",
                                                zorder: -1.1
                                            },
                                            {
                                                id: "hline_2",
                                                name: "MiddleLimit",
                                                zorder: -1.11
                                            },
                                            {
                                                id: "hline_1",
                                                name: "LowerLimit",
                                                zorder: -1.111
                                            }, 
                                        ],
                                        filledAreas: [
                                            {
                                                id: "fill_0",
                                                objAId: "hline_0",
                                                objBId: "hline_1",
                                                type: "hline_hline",
                                                title: "Hlines Background",
                                                zorder: -2
                                            }, 
                                        ],
                                        id: "Relative Strength Index@tv-basicstudies-1",
                                        scriptIdPart: "",
                                        name: "Relative Strength Index",
                                        format: {
                                            precision: 2,
                                            type: "price"
                                        },
                                        usePlotsZOrder: true,
                                        description_localized: "Relative Strength Index",
                                        shortId: "Relative Strength Index",
                                        packageId: "tv-basicstudies",
                                        version: "1",
                                        fullId: "Relative Strength Index@tv-basicstudies-1",
                                        productId: "tv-basicstudies",
                                        _serverMetaInfoVersion: 52
                                    }
                                }, 
                            ],
                            mainSourceId: "xRlWww",
                            stretchFactor: 608.695652173913,
                            leftAxisesState: [],
                            rightAxisesState: [
                                {
                                    state: {
                                        id: "h7jqfpa3lHVy",
                                        m_priceRange: null,
                                        m_isAutoScale: true,
                                        m_isPercentage: false,
                                        m_isIndexedTo100: false,
                                        m_isLog: false,
                                        m_isLockScale: false,
                                        m_isInverted: false,
                                        m_topMargin: 0.17,
                                        m_bottomMargin: 0.15,
                                        alignLabels: true,
                                        logFormula: {
                                            logicalOffset: 4,
                                            coordOffset: 0.0001
                                        }
                                    },
                                    sources: [
                                        "xRlWww"
                                    ]
                                }, 
                            ],
                            overlayPriceScales: {},
                            priceScaleRatio: null
                        }, 
                    ],
                    timeScale: {
                        m_barSpacing: 5.869312088008223,
                        m_rightOffset: 10,
                        rightOffsetPercentage: 5,
                        usePercentageRightOffset: false
                    },
                    chartProperties: {
                        paneProperties: {
                            backgroundType: "solid",
                            background: "#ffffff",
                            backgroundGradientStartColor: "#ffffff",
                            backgroundGradientEndColor: "#ffffff",
                            gridLinesMode: "both",
                            vertGridProperties: {
                                color: "rgba(42, 46, 57, 0.06)"
                            },
                            horzGridProperties: {
                                color: "rgba(42, 46, 57, 0.06)"
                            },
                            crossHairProperties: {
                                color: "#9598A1",
                                style: 2,
                                transparency: 0,
                                width: 1,
                                "color:": "#9598A1"
                            },
                            topMargin: 17,
                            bottomMargin: 15,
                            axisProperties: {
                                autoScale: true,
                                autoScaleDisabled: false,
                                lockScale: false,
                                percentage: false,
                                percentageDisabled: false,
                                indexedTo100: false,
                                log: false,
                                logDisabled: false,
                                alignLabels: true,
                                isInverted: false
                            },
                            legendProperties: {
                                showStudyArguments: true,
                                showStudyTitles: true,
                                showStudyValues: false,
                                showSeriesTitle: true,
                                showSeriesOHLC: true,
                                showLegend: true,
                                showBarChange: true,
                                showVolume: false,
                                showBackground: true,
                                showPriceSource: true,
                                backgroundTransparency: 50,
                                showLogo: true,
                                wrapText: false,
                                showOnlyPriceSource: true
                            },
                            separatorColor: "#E0E3EB",
                            gridProperties: {
                                color: "#e1ecf2",
                                style: 0
                            },
                            leftAxisProperties: {
                                autoScale: true,
                                autoScaleDisabled: false,
                                lockScale: false,
                                percentage: false,
                                percentageDisabled: false,
                                indexedTo100: false,
                                log: false,
                                logDisabled: false,
                                alignLabels: true
                            },
                            rightAxisProperties: {
                                autoScale: true,
                                autoScaleDisabled: false,
                                lockScale: false,
                                percentage: false,
                                percentageDisabled: false,
                                log: false,
                                logDisabled: false,
                                alignLabels: true,
                                indexedTo100: false
                            },
                            rightOffset: null
                        },
                        scalesProperties: {
                            backgroundColor: "#ffffff",
                            lineColor: "rgba(42, 46, 57, 0)",
                            textColor: "#131722",
                            fontSize: 12,
                            scaleSeriesOnly: false,
                            showSeriesLastValue: true,
                            seriesLastValueMode: 1,
                            showSeriesPrevCloseValue: false,
                            showStudyLastValue: true,
                            showSymbolLabels: false,
                            showStudyPlotLabels: false,
                            showBidAskLabels: false,
                            showPrePostMarketPriceLabel: true,
                            showFundamentalNameLabel: false,
                            showFundamentalLastValue: true,
                            barSpacing: 6,
                            axisHighlightColor: "rgba(41, 98, 255, 0.25)",
                            axisLineToolLabelBackgroundColorCommon: "#2962FF",
                            axisLineToolLabelBackgroundColorActive: "#143EB3",
                            showPriceScaleCrosshairLabel: true,
                            showTimeScaleCrosshairLabel: true,
                            crosshairLabelBgColorLight: "#131722",
                            crosshairLabelBgColorDark: "#363A45",
                            showCurrency: true,
                            showUnit: true,
                            showLeftScale: false,
                            showRightScale: true
                        },
                        chartEventsSourceProperties: {
                            visible: true,
                            futureOnly: true,
                            breaks: {
                                color: "rgba(85, 85, 85, 1)",
                                visible: false,
                                style: 2,
                                width: 1
                            }
                        },
                        tradingProperties: {
                            showPositions: true,
                            positionPL: {
                                visibility: true,
                                display: 0
                            },
                            bracketsPL: {
                                visibility: true,
                                display: 0
                            },
                            showOrders: true,
                            showExecutions: true,
                            showExecutionsLabels: false,
                            showReverse: true,
                            horizontalAlignment: 2,
                            extendLeft: true,
                            lineLength: 5,
                            lineWidth: 1,
                            lineStyle: 0
                        },
                        priceScaleSelectionStrategyName: "auto"
                    },
                    sessions: {
                        properties: {
                            graphics: {
                                backgrounds: {
                                    outOfSession: {
                                        color: "#2962FF",
                                        transparency: 92,
                                        visible: false
                                    },
                                    preMarket: {
                                        color: "#FF9800",
                                        transparency: 92,
                                        visible: false
                                    },
                                    postMarket: {
                                        color: "#2962FF",
                                        transparency: 92,
                                        visible: false
                                    }
                                },
                                vertlines: {
                                    sessBreaks: {
                                        color: "#4985e7",
                                        style: 2,
                                        visible: false,
                                        width: 1
                                    }
                                }
                            }
                        }
                    },
                    version: 3,
                    timezone: "Asia/Jakarta",
                    shouldBeSavedEvenIfHidden: true,
                    linkingGroup: null,
                    lineToolsGroups: {
                        groups: []
                    },
                    chartId: "1",
                    theme: "light"
                }, 
            ],
            symbolLock: 0,
            intervalLock: 0,
            trackTimeLock: 0,
            dateRangeLock: 0,
            crosshairLock: 1,
            layoutsSizes: {
                s: [
                    {
                        percent: 1
                    }
                ]
            }
        }
    },
    {
        key: "foreign_flow",
        name: "Foreign Flow",
        template: {
            layout: "s",
            charts: [
                {
                    panes: [
                        {
                            sources: [
                                {
                                    type: "MainSeries",
                                    id: "_seriesId",
                                    zorder: 0,
                                    haStyle: {
                                        studyId: "BarSetHeikenAshi@tv-basicstudies-60"
                                    },
                                    renkoStyle: {
                                        studyId: "BarSetRenko@tv-prostudies-64"
                                    },
                                    pbStyle: {
                                        studyId: "BarSetPriceBreak@tv-prostudies-34"
                                    },
                                    kagiStyle: {
                                        studyId: "BarSetKagi@tv-prostudies-34"
                                    },
                                    pnfStyle: {
                                        studyId: "BarSetPnF@tv-prostudies-34"
                                    },
                                    rangeStyle: {
                                        studyId: "BarSetRange@tv-basicstudies-72"
                                    },
                                    formattingDeps: {
                                        format: "price",
                                        pricescale: 1,
                                        minmov: 1
                                    },
                                    state: {
                                        style: 1,
                                        esdShowDividends: true,
                                        esdShowSplits: true,
                                        esdShowEarnings: true,
                                        esdShowBreaks: false,
                                        esdFlagSize: 2,
                                        showContinuousContractSwitches: true,
                                        showContinuousContractSwitchesBreaks: false,
                                        showFuturesContractExpiration: true,
                                        showLastNews: true,
                                        showCountdown: false,
                                        bidAsk: {
                                            visible: false,
                                            lineStyle: 1,
                                            lineWidth: 1,
                                            bidLineColor: "#2962FF",
                                            askLineColor: "#F7525F"
                                        },
                                        prePostMarket: {
                                            visible: true,
                                            lineStyle: 1,
                                            lineWidth: 1,
                                            preMarketColor: "#FB8C00",
                                            postMarketColor: "#2962FF"
                                        },
                                        highLowAvgPrice: {
                                            highLowPriceLinesVisible: false,
                                            highLowPriceLabelsVisible: false,
                                            averageClosePriceLineVisible: false,
                                            averageClosePriceLabelVisible: false,
                                            highLowPriceLinesColor: "",
                                            highLowPriceLinesWidth: 1,
                                            averagePriceLineColor: "",
                                            averagePriceLineWidth: 1
                                        },
                                        visible: true,
                                        showPriceLine: true,
                                        priceLineWidth: 1,
                                        priceLineColor: "",
                                        baseLineColor: "#B2B5BE",
                                        showPrevClosePriceLine: false,
                                        prevClosePriceLineWidth: 1,
                                        prevClosePriceLineColor: "#555555",
                                        minTick: "default",
                                        dividendsAdjustment: null,
                                        backAdjustment: false,
                                        settlementAsClose: true,
                                        sessionId: "regular",
                                        sessVis: false,
                                        statusViewStyle: {
                                            fontSize: 16,
                                            showExchange: true,
                                            showInterval: true,
                                            symbolTextSource: "description",
                                            showSymbolAsDescription: false
                                        },
                                        candleStyle: {
                                            upColor: "#009900",
                                            downColor: "#B80E0C",
                                            drawWick: true,
                                            drawBorder: true,
                                            borderColor: "#000000",
                                            borderUpColor: "#000000",
                                            borderDownColor: "#000000",
                                            wickColor: "#737375",
                                            wickUpColor: "#000000",
                                            wickDownColor: "#000000",
                                            barColorsOnPrevClose: false,
                                            drawBody: true
                                        },
                                        hollowCandleStyle: {
                                            upColor: "#089981",
                                            downColor: "#F23645",
                                            drawWick: true,
                                            drawBorder: true,
                                            borderColor: "#378658",
                                            borderUpColor: "#089981",
                                            borderDownColor: "#F23645",
                                            wickColor: "#737375",
                                            wickUpColor: "#089981",
                                            wickDownColor: "#F23645",
                                            drawBody: true
                                        },
                                        haStyle: {
                                            upColor: "#089981",
                                            downColor: "#F23645",
                                            drawWick: true,
                                            drawBorder: true,
                                            borderColor: "#378658",
                                            borderUpColor: "#089981",
                                            borderDownColor: "#F23645",
                                            wickColor: "#737375",
                                            wickUpColor: "#089981",
                                            wickDownColor: "#F23645",
                                            showRealLastPrice: false,
                                            barColorsOnPrevClose: false,
                                            inputs: {},
                                            inputInfo: {},
                                            drawBody: true
                                        },
                                        barStyle: {
                                            upColor: "#089981",
                                            downColor: "#F23645",
                                            barColorsOnPrevClose: false,
                                            dontDrawOpen: false,
                                            thinBars: true
                                        },
                                        hiloStyle: {
                                            color: "#2962FF",
                                            showBorders: true,
                                            borderColor: "#2962FF",
                                            showLabels: true,
                                            labelColor: "#2962FF",
                                            drawBody: true,
                                            fontSize: 7
                                        },
                                        columnStyle: {
                                            upColor: "rgba(8, 153, 129, 0.5)",
                                            downColor: "rgba(242, 54, 69, 0.5)",
                                            barColorsOnPrevClose: true,
                                            priceSource: "close"
                                        },
                                        lineStyle: {
                                            color: "#2962FF",
                                            linestyle: 0,
                                            linewidth: 2,
                                            priceSource: "close"
                                        },
                                        lineWithMarkersStyle: {
                                            color: "#2962FF",
                                            linestyle: 0,
                                            linewidth: 2,
                                            priceSource: "close"
                                        },
                                        steplineStyle: {
                                            color: "#2962FF",
                                            linestyle: 0,
                                            linewidth: 2,
                                            priceSource: "close"
                                        },
                                        areaStyle: {
                                            color1: "rgba(41, 98, 255, 0.28)",
                                            color2: "#2962FF",
                                            linecolor: "#2962FF",
                                            linestyle: 0,
                                            linewidth: 1,
                                            priceSource: "close",
                                            transparency: 100
                                        },
                                        hlcAreaStyle: {
                                            highLineColor: "#089981",
                                            highLineStyle: 0,
                                            highLineWidth: 2,
                                            lowLineColor: "#F23645",
                                            lowLineStyle: 0,
                                            lowLineWidth: 2,
                                            closeLineColor: "#868993",
                                            closeLineStyle: 0,
                                            closeLineWidth: 2,
                                            highCloseFillColor: "rgba(8, 153, 129, 0.2)",
                                            closeLowFillColor: "rgba(242, 54, 69, 0.2)"
                                        },
                                        renkoStyle: {
                                            upColor: "#089981",
                                            downColor: "#F23645",
                                            borderUpColor: "#089981",
                                            borderDownColor: "#F23645",
                                            upColorProjection: "#a9dcc3",
                                            downColorProjection: "#f5a6ae",
                                            borderUpColorProjection: "#a9dcc3",
                                            borderDownColorProjection: "#f5a6ae",
                                            wickUpColor: "#089981",
                                            wickDownColor: "#F23645",
                                            inputs: {
                                                source: "close",
                                                sources: "Close",
                                                boxSize: 3,
                                                style: "ATR",
                                                atrLength: 14,
                                                wicks: true
                                            },
                                            inputInfo: {
                                                source: {
                                                    name: "Source"
                                                },
                                                sources: {
                                                    name: "Source"
                                                },
                                                boxSize: {
                                                    name: "Box size"
                                                },
                                                style: {
                                                    name: "Style"
                                                },
                                                atrLength: {
                                                    name: "ATR length"
                                                },
                                                wicks: {
                                                    name: "Wicks"
                                                }
                                            }
                                        },
                                        pbStyle: {
                                            upColor: "#089981",
                                            downColor: "#F23645",
                                            borderUpColor: "#089981",
                                            borderDownColor: "#F23645",
                                            upColorProjection: "#a9dcc3",
                                            downColorProjection: "#f5a6ae",
                                            borderUpColorProjection: "#a9dcc3",
                                            borderDownColorProjection: "#f5a6ae",
                                            inputs: {
                                                source: "close",
                                                lb: 3
                                            },
                                            inputInfo: {
                                                source: {
                                                    name: "Source"
                                                },
                                                lb: {
                                                    name: "Number of line"
                                                }
                                            }
                                        },
                                        kagiStyle: {
                                            upColor: "#089981",
                                            downColor: "#F23645",
                                            upColorProjection: "#a9dcc3",
                                            downColorProjection: "#f5a6ae",
                                            inputs: {
                                                source: "close",
                                                style: "ATR",
                                                atrLength: 14,
                                                reversalAmount: 1
                                            },
                                            inputInfo: {
                                                source: {
                                                    name: "Source"
                                                },
                                                style: {
                                                    name: "Style"
                                                },
                                                atrLength: {
                                                    name: "ATR length"
                                                },
                                                reversalAmount: {
                                                    name: "Reversal amount"
                                                }
                                            }
                                        },
                                        pnfStyle: {
                                            upColor: "#089981",
                                            downColor: "#F23645",
                                            upColorProjection: "#a9dcc3",
                                            downColorProjection: "#f5a6ae",
                                            inputs: {
                                                sources: "Close",
                                                reversalAmount: 3,
                                                boxSize: 1,
                                                style: "ATR",
                                                atrLength: 14,
                                                oneStepBackBuilding: false
                                            },
                                            inputInfo: {
                                                sources: {
                                                    name: "Source"
                                                },
                                                boxSize: {
                                                    name: "Box size"
                                                },
                                                reversalAmount: {
                                                    name: "Reversal amount"
                                                },
                                                style: {
                                                    name: "Style"
                                                },
                                                atrLength: {
                                                    name: "ATR length"
                                                },
                                                oneStepBackBuilding: {
                                                    name: "One step back building"
                                                }
                                            }
                                        },
                                        baselineStyle: {
                                            baselineColor: "#758696",
                                            topFillColor1: "rgba(8, 153, 129, 0.28)",
                                            topFillColor2: "rgba(8, 153, 129, 0.05)",
                                            bottomFillColor1: "rgba(242, 54, 69, 0.05)",
                                            bottomFillColor2: "rgba(242, 54, 69, 0.28)",
                                            topLineColor: "#089981",
                                            bottomLineColor: "#F23645",
                                            topLineWidth: 1,
                                            bottomLineWidth: 1,
                                            priceSource: "close",
                                            transparency: 50,
                                            baseLevelPercentage: 50
                                        },
                                        rangeStyle: {
                                            barStyle: 0,
                                            upColor: "#089981",
                                            downColor: "#F23645",
                                            upColorProjection: "#a9dcc3",
                                            downColorProjection: "#f5a6ae",
                                            thinBars: true,
                                            candlesUpColor: "#089981",
                                            candlesDownColor: "#F23645",
                                            candlesBorderUpColor: "#089981",
                                            candlesBorderDownColor: "#F23645",
                                            candlesWickUpColor: "#089981",
                                            candlesWickDownColor: "#F23645",
                                            inputs: {
                                                range: 10,
                                                phantomBars: false
                                            },
                                            inputInfo: {
                                                range: {
                                                    name: "Range"
                                                },
                                                phantomBars: {
                                                    name: "Phantom bars"
                                                }
                                            }
                                        },
                                        showInDataWindow: true,
                                        symbol: "BBCA",
                                        shortName: "BBCA",
                                        timeframe: "",
                                        onWidget: false,
                                        interval: "D",
                                        unitId: null,
                                        showSessions: false,
                                        shortname: "",
                                        currencyId: null,
                                        priceAxisProperties: {
                                            autoScale: true,
                                            autoScaleDisabled: false,
                                            lockScale: false,
                                            percentage: false,
                                            percentageDisabled: false,
                                            log: false,
                                            logDisabled: false,
                                            alignLabels: true,
                                            isInverted: false,
                                            indexedTo100: false
                                        }
                                    }
                                },
                                {
                                    type: "Study",
                                    id: "z5XxkQ",
                                    state: {
                                        styles: {
                                            plot_0: {
                                                display: 15,
                                                linestyle: 0,
                                                linewidth: 2,
                                                plottype: 0,
                                                trackPrice: false,
                                                transparency: 11,
                                                color: "#5F72EC",
                                                title: "plot_0"
                                            }
                                        },
                                        precision: "default",
                                        inputs: {},
                                        bands: {},
                                        graphics: {},
                                        ohlcPlots: {},
                                        palettes: {},
                                        filledAreasStyle: {},
                                        filledAreas: {},
                                        visible: true,
                                        showLegendValues: true,
                                        showLabelsOnPriceScale: true,
                                        parentSources: {},
                                        intervalsVisibilities: {
                                            ticks: true,
                                            seconds: true,
                                            secondsFrom: 1,
                                            secondsTo: 59,
                                            minutes: true,
                                            minutesFrom: 1,
                                            minutesTo: 59,
                                            hours: true,
                                            hoursFrom: 1,
                                            hoursTo: 24,
                                            days: true,
                                            daysFrom: 1,
                                            daysTo: 366,
                                            weeks: true,
                                            weeksFrom: 1,
                                            weeksTo: 52,
                                            months: true,
                                            monthsFrom: 1,
                                            monthsTo: 12,
                                            ranges: true
                                        }
                                    },
                                    zorder: -10000,
                                    ownFirstValue: null,
                                    metaInfo: {
                                        palettes: {},
                                        inputs: [],
                                        plots: [
                                            {
                                                id: "plot_0",
                                                type: "line"
                                            }
                                        ],
                                        graphics: {},
                                        defaults: {
                                            styles: {
                                                plot_0: {
                                                    display: 15,
                                                    linestyle: 0,
                                                    linewidth: 2,
                                                    plottype: 0,
                                                    trackPrice: false,
                                                    transparency: 11,
                                                    color: "#5F72EC"
                                                }
                                            },
                                            precision: 0,
                                            inputs: {}
                                        },
                                        _metainfoVersion: 53,
                                        id: "Foreign Flow Underlay@tv-basicstudies-1",
                                        name: "Foreign Flow Underlay",
                                        description: "Foreign Flow Underlay",
                                        shortDescription: "Foreign Flow Underlay",
                                        is_hidden_study: false,
                                        is_price_study: true,
                                        isCustomIndicator: true,
                                        format: {
                                            type: "volume",
                                            precision: 3
                                        },
                                        styles: {
                                            plot_0: {
                                                title: "Foreign Flow Underlay value",
                                                histogramBase: 0
                                            }
                                        },
                                        description_localized: "Foreign Flow Underlay",
                                        shortId: "Foreign Flow Underlay",
                                        packageId: "tv-basicstudies",
                                        version: "1",
                                        fullId: "Foreign Flow Underlay@tv-basicstudies-1",
                                        productId: "tv-basicstudies",
                                        _serverMetaInfoVersion: 51
                                    }
                                }, 
                            ],
                            mainSourceId: "_seriesId",
                            stretchFactor: 3084.82420537963,
                            leftAxisesState: [],
                            rightAxisesState: [
                                {
                                    state: {
                                        id: "WZB8dP50LJ7p",
                                        m_priceRange: null,
                                        m_isAutoScale: true,
                                        m_isPercentage: false,
                                        m_isIndexedTo100: false,
                                        m_isLog: false,
                                        m_isLockScale: false,
                                        m_isInverted: false,
                                        m_topMargin: 0.17,
                                        m_bottomMargin: 0.15,
                                        alignLabels: true,
                                        logFormula: {
                                            logicalOffset: 4,
                                            coordOffset: 0.0001
                                        }
                                    },
                                    sources: [
                                        "_seriesId"
                                    ]
                                }, 
                            ],
                            overlayPriceScales: {
                                z5XxkQ: {
                                    id: "duRWXItYdRlD",
                                    m_priceRange: null,
                                    m_isAutoScale: true,
                                    m_isPercentage: false,
                                    m_isIndexedTo100: false,
                                    m_isLog: false,
                                    m_isLockScale: false,
                                    m_isInverted: false,
                                    m_topMargin: 0.17,
                                    m_bottomMargin: 0.15,
                                    alignLabels: true,
                                    logFormula: {
                                        logicalOffset: 4,
                                        coordOffset: 0.0001
                                    }
                                }
                            },
                            priceScaleRatio: null
                        },
                        {
                            sources: [
                                {
                                    type: "Study",
                                    id: "1wSsej",
                                    state: {
                                        styles: {
                                            vol: {
                                                display: 15,
                                                linestyle: 0,
                                                linewidth: 1,
                                                plottype: 5,
                                                trackPrice: false,
                                                transparency: 0,
                                                color: "#000080",
                                                title: "vol"
                                            },
                                            vol_ma: {
                                                display: 15,
                                                linestyle: 0,
                                                linewidth: 2,
                                                plottype: 0,
                                                trackPrice: false,
                                                transparency: 30,
                                                color: "#0496ff",
                                                title: "vol_ma"
                                            }
                                        },
                                        precision: "default",
                                        palettes: {
                                            volumePalette: {
                                                colors: {
                                                    0: {
                                                        color: "rgba(235, 77, 92, 0.50)",
                                                        width: 1,
                                                        style: 0
                                                    },
                                                    1: {
                                                        color: "rgba(83, 185, 135, 0.50)",
                                                        width: 1,
                                                        style: 0
                                                    }
                                                }
                                            }
                                        },
                                        inputs: {
                                            showMA: true,
                                            maLength: 20
                                        },
                                        bands: {},
                                        graphics: {},
                                        ohlcPlots: {},
                                        filledAreasStyle: {},
                                        filledAreas: {},
                                        visible: true,
                                        showLegendValues: true,
                                        showLabelsOnPriceScale: true,
                                        parentSources: {},
                                        intervalsVisibilities: {
                                            ticks: true,
                                            seconds: true,
                                            secondsFrom: 1,
                                            secondsTo: 59,
                                            minutes: true,
                                            minutesFrom: 1,
                                            minutesTo: 59,
                                            hours: true,
                                            hoursFrom: 1,
                                            hoursTo: 24,
                                            days: true,
                                            daysFrom: 1,
                                            daysTo: 366,
                                            weeks: true,
                                            weeksFrom: 1,
                                            weeksTo: 52,
                                            months: true,
                                            monthsFrom: 1,
                                            monthsTo: 12,
                                            ranges: true
                                        }
                                    },
                                    zorder: -10000,
                                    ownFirstValue: null,
                                    metaInfo: {
                                        palettes: {
                                            volumePalette: {
                                                colors: [
                                                    {
                                                        name: "Falling"
                                                    },
                                                    {
                                                        name: "Growing"
                                                    }
                                                ]
                                            }
                                        },
                                        inputs: [
                                            {
                                                id: "showMA",
                                                name: "show MA",
                                                defval: true,
                                                type: "bool",
                                                display: 0
                                            },
                                            {
                                                id: "maLength",
                                                name: "MA Length",
                                                defval: 20,
                                                type: "integer",
                                                min: 1,
                                                max: 2000,
                                                display: 15
                                            }, 
                                        ],
                                        plots: [
                                            {
                                                id: "vol",
                                                type: "line"
                                            },
                                            {
                                                id: "volumePalette",
                                                palette: "volumePalette",
                                                target: "vol",
                                                type: "colorer"
                                            },
                                            {
                                                id: "vol_ma",
                                                type: "line"
                                            }, 
                                        ],
                                        graphics: {},
                                        defaults: {
                                            styles: {
                                                vol: {
                                                    display: 15,
                                                    linestyle: 0,
                                                    linewidth: 1,
                                                    plottype: 5,
                                                    trackPrice: false,
                                                    transparency: 0,
                                                    color: "#000080"
                                                },
                                                vol_ma: {
                                                    display: 15,
                                                    linestyle: 0,
                                                    linewidth: 2,
                                                    plottype: 0,
                                                    trackPrice: false,
                                                    transparency: 30,
                                                    color: "#0496FF"
                                                }
                                            },
                                            precision: 0,
                                            palettes: {
                                                volumePalette: {
                                                    colors: {
                                                        0: {
                                                            color: "rgba(235, 77, 92, 0.50)",
                                                            width: 1,
                                                            style: 0
                                                        },
                                                        1: {
                                                            color: "rgba(83, 185, 135, 0.50)",
                                                            width: 1,
                                                            style: 0
                                                        }
                                                    }
                                                }
                                            },
                                            inputs: {
                                                showMA: true,
                                                maLength: 20
                                            }
                                        },
                                        _metainfoVersion: 53,
                                        id: "Volume_@tv-basicstudies-1",
                                        is_hidden_study: false,
                                        description: "Volume_",
                                        shortDescription: "Volume",
                                        is_price_study: false,
                                        format: {
                                            type: "volume",
                                            precision: 3
                                        },
                                        styles: {
                                            vol: {
                                                title: "Volume_",
                                                histogramBase: 0
                                            },
                                            vol_ma: {
                                                title: "Volume MA",
                                                histogramBase: 0
                                            }
                                        },
                                        description_localized: "Volume_",
                                        shortId: "Volume_",
                                        packageId: "tv-basicstudies",
                                        version: "1",
                                        fullId: "Volume_@tv-basicstudies-1",
                                        productId: "tv-basicstudies",
                                        _serverMetaInfoVersion: 51
                                    }
                                }, 
                            ],
                            mainSourceId: "1wSsej",
                            stretchFactor: 761.6340921567289,
                            leftAxisesState: [],
                            rightAxisesState: [
                                {
                                    state: {
                                        id: "u9NUxWMF044v",
                                        m_priceRange: null,
                                        m_isAutoScale: true,
                                        m_isPercentage: false,
                                        m_isIndexedTo100: false,
                                        m_isLog: false,
                                        m_isLockScale: false,
                                        m_isInverted: false,
                                        m_topMargin: 0.17,
                                        m_bottomMargin: 0.15,
                                        alignLabels: true,
                                        logFormula: {
                                            logicalOffset: 4,
                                            coordOffset: 0.0001
                                        }
                                    },
                                    sources: [
                                        "1wSsej"
                                    ]
                                }, 
                            ],
                            overlayPriceScales: {},
                            priceScaleRatio: null
                        },
                        {
                            sources: [
                                {
                                    type: "Study",
                                    id: "HJwr9F",
                                    state: {
                                        styles: {
                                            plot_0: {
                                                display: 15,
                                                linestyle: 0,
                                                linewidth: 2,
                                                plottype: 0,
                                                trackPrice: false,
                                                transparency: 11,
                                                color: "#BE5FEC",
                                                title: "plot_0"
                                            }
                                        },
                                        precision: "default",
                                        inputs: {},
                                        bands: {},
                                        graphics: {},
                                        ohlcPlots: {},
                                        palettes: {},
                                        filledAreasStyle: {},
                                        filledAreas: {},
                                        visible: true,
                                        showLegendValues: true,
                                        showLabelsOnPriceScale: true,
                                        parentSources: {},
                                        intervalsVisibilities: {
                                            ticks: true,
                                            seconds: true,
                                            secondsFrom: 1,
                                            secondsTo: 59,
                                            minutes: true,
                                            minutesFrom: 1,
                                            minutesTo: 59,
                                            hours: true,
                                            hoursFrom: 1,
                                            hoursTo: 24,
                                            days: true,
                                            daysFrom: 1,
                                            daysTo: 366,
                                            weeks: true,
                                            weeksFrom: 1,
                                            weeksTo: 52,
                                            months: true,
                                            monthsFrom: 1,
                                            monthsTo: 12,
                                            ranges: true
                                        }
                                    },
                                    zorder: -10000,
                                    ownFirstValue: null,
                                    metaInfo: {
                                        palettes: {},
                                        inputs: [],
                                        plots: [
                                            {
                                                id: "plot_0",
                                                type: "line"
                                            }
                                        ],
                                        graphics: {},
                                        defaults: {
                                            styles: {
                                                plot_0: {
                                                    display: 15,
                                                    linestyle: 0,
                                                    linewidth: 2,
                                                    plottype: 0,
                                                    trackPrice: false,
                                                    transparency: 11,
                                                    color: "#BE5FEC"
                                                }
                                            },
                                            precision: 0,
                                            inputs: {}
                                        },
                                        _metainfoVersion: 53,
                                        id: "Foreign Flow@tv-basicstudies-1",
                                        name: "Foreign Flow",
                                        description: "Foreign Flow",
                                        shortDescription: "Foreign Flow",
                                        is_hidden_study: false,
                                        is_price_study: false,
                                        isCustomIndicator: true,
                                        format: {
                                            type: "volume",
                                            precision: 3
                                        },
                                        styles: {
                                            plot_0: {
                                                title: "Foreign Flow value",
                                                histogramBase: 0
                                            }
                                        },
                                        description_localized: "Foreign Flow",
                                        shortId: "Foreign Flow",
                                        packageId: "tv-basicstudies",
                                        version: "1",
                                        fullId: "Foreign Flow@tv-basicstudies-1",
                                        productId: "tv-basicstudies",
                                        _serverMetaInfoVersion: 51
                                    }
                                }, 
                            ],
                            mainSourceId: "HJwr9F",
                            stretchFactor: 624.0973825912547,
                            leftAxisesState: [],
                            rightAxisesState: [
                                {
                                    state: {
                                        id: "SGv9ypZYDeGF",
                                        m_priceRange: null,
                                        m_isAutoScale: true,
                                        m_isPercentage: false,
                                        m_isIndexedTo100: false,
                                        m_isLog: false,
                                        m_isLockScale: false,
                                        m_isInverted: false,
                                        m_topMargin: 0.17,
                                        m_bottomMargin: 0.15,
                                        alignLabels: true,
                                        logFormula: {
                                            logicalOffset: 4,
                                            coordOffset: 0.0001
                                        }
                                    },
                                    sources: [
                                        "HJwr9F"
                                    ]
                                }, 
                            ],
                            overlayPriceScales: {},
                            priceScaleRatio: null
                        },
                        {
                            sources: [
                                {
                                    type: "Study",
                                    id: "sEAGzL",
                                    state: {
                                        palettes: {
                                            palette_0: {
                                                colors: {
                                                    0: {
                                                        color: "#B80E0C",
                                                        width: 5,
                                                        style: 0
                                                    },
                                                    1: {
                                                        color: "#009900",
                                                        width: 5,
                                                        style: 0
                                                    }
                                                }
                                            }
                                        },
                                        styles: {
                                            plot_0: {
                                                display: 15,
                                                linestyle: 0,
                                                linewidth: 5,
                                                plottype: 5,
                                                trackPrice: false,
                                                transparency: 30,
                                                color: "#009900",
                                                title: "plot_0"
                                            }
                                        },
                                        precision: "default",
                                        inputs: {},
                                        bands: {},
                                        graphics: {},
                                        ohlcPlots: {},
                                        filledAreasStyle: {},
                                        filledAreas: {},
                                        visible: true,
                                        showLegendValues: true,
                                        showLabelsOnPriceScale: true,
                                        parentSources: {},
                                        intervalsVisibilities: {
                                            ticks: true,
                                            seconds: true,
                                            secondsFrom: 1,
                                            secondsTo: 59,
                                            minutes: true,
                                            minutesFrom: 1,
                                            minutesTo: 59,
                                            hours: true,
                                            hoursFrom: 1,
                                            hoursTo: 24,
                                            days: true,
                                            daysFrom: 1,
                                            daysTo: 366,
                                            weeks: true,
                                            weeksFrom: 1,
                                            weeksTo: 52,
                                            months: true,
                                            monthsFrom: 1,
                                            monthsTo: 12,
                                            ranges: true
                                        }
                                    },
                                    zorder: -10000,
                                    ownFirstValue: null,
                                    metaInfo: {
                                        palettes: {
                                            palette_0: {
                                                colors: [
                                                    {
                                                        name: "Color 0"
                                                    },
                                                    {
                                                        name: "Color 1"
                                                    }
                                                ]
                                            }
                                        },
                                        inputs: [],
                                        plots: [
                                            {
                                                id: "plot_0",
                                                type: "line"
                                            },
                                            {
                                                id: "plot_1",
                                                palette: "palette_0",
                                                target: "plot_0",
                                                type: "colorer"
                                            }, 
                                        ],
                                        graphics: {},
                                        defaults: {
                                            palettes: {
                                                palette_0: {
                                                    colors: [
                                                        {
                                                            color: "#B80E0C",
                                                            width: 5,
                                                            style: 0
                                                        },
                                                        {
                                                            color: "#009900",
                                                            width: 5,
                                                            style: 0
                                                        }, 
                                                    ]
                                                }
                                            },
                                            styles: {
                                                plot_0: {
                                                    display: 15,
                                                    linestyle: 0,
                                                    linewidth: 5,
                                                    plottype: 5,
                                                    trackPrice: false,
                                                    transparency: 30,
                                                    color: "#009900"
                                                }
                                            },
                                            precision: 0,
                                            inputs: {}
                                        },
                                        _metainfoVersion: 53,
                                        id: "Net Foreign Buy / Sell@tv-basicstudies-12",
                                        name: "Net Foreign Buy / Sell",
                                        description: "Net Foreign Buy / Sell",
                                        shortDescription: "Net Foreign Buy / Sell",
                                        is_hidden_study: false,
                                        is_price_study: false,
                                        isCustomIndicator: true,
                                        format: {
                                            type: "volume",
                                            precision: 3
                                        },
                                        styles: {
                                            plot_0: {
                                                title: "Net Foreign Buy / Sell value",
                                                histogramBase: 0,
                                                joinPoints: false
                                            }
                                        },
                                        description_localized: "Net Foreign Buy / Sell",
                                        shortId: "Net Foreign Buy / Sell",
                                        packageId: "tv-basicstudies",
                                        version: "12",
                                        fullId: "Net Foreign Buy / Sell@tv-basicstudies-12",
                                        productId: "tv-basicstudies",
                                        _serverMetaInfoVersion: 51
                                    }
                                }, 
                            ],
                            mainSourceId: "sEAGzL",
                            stretchFactor: 642.5084855766199,
                            leftAxisesState: [],
                            rightAxisesState: [
                                {
                                    state: {
                                        id: "qZdE2NiKmlfh",
                                        m_priceRange: null,
                                        m_isAutoScale: true,
                                        m_isPercentage: false,
                                        m_isIndexedTo100: false,
                                        m_isLog: false,
                                        m_isLockScale: false,
                                        m_isInverted: false,
                                        m_topMargin: 0.17,
                                        m_bottomMargin: 0.15,
                                        alignLabels: true,
                                        logFormula: {
                                            logicalOffset: 4,
                                            coordOffset: 0.0001
                                        }
                                    },
                                    sources: [
                                        "sEAGzL"
                                    ]
                                }, 
                            ],
                            overlayPriceScales: {},
                            priceScaleRatio: null
                        },
                        {
                            sources: [
                                {
                                    type: "Study",
                                    id: "wt9yiH",
                                    state: {
                                        filledAreasStyle: {
                                            strongArea: {
                                                color: "#009900",
                                                transparency: 80,
                                                visible: true
                                            },
                                            weakArea: {
                                                color: "#B80E0C",
                                                transparency: 80,
                                                visible: true
                                            }
                                        },
                                        styles: {
                                            main: {
                                                display: 15,
                                                plottype: 0,
                                                color: "#333333",
                                                linewidth: 2,
                                                transparency: 50,
                                                linestyle: 0,
                                                trackPrice: false,
                                                title: "main"
                                            },
                                            strong: {
                                                display: 15,
                                                plottype: 0,
                                                color: "#b80e0c",
                                                transparency: 80,
                                                linewidth: 1,
                                                linestyle: 0,
                                                trackPrice: false,
                                                title: "strong"
                                            },
                                            weak: {
                                                display: 15,
                                                plottype: 0,
                                                color: "#b80e0c",
                                                transparency: 80,
                                                linewidth: 1,
                                                linestyle: 0,
                                                trackPrice: false,
                                                title: "weak"
                                            }
                                        },
                                        precision: "default",
                                        inputs: {
                                            showZones: true,
                                            period: 50,
                                            strong: 20,
                                            weak: 20
                                        },
                                        bands: {},
                                        graphics: {},
                                        ohlcPlots: {},
                                        palettes: {},
                                        filledAreas: {},
                                        visible: true,
                                        showLegendValues: true,
                                        showLabelsOnPriceScale: true,
                                        parentSources: {},
                                        intervalsVisibilities: {
                                            ticks: true,
                                            seconds: true,
                                            secondsFrom: 1,
                                            secondsTo: 59,
                                            minutes: true,
                                            minutesFrom: 1,
                                            minutesTo: 59,
                                            hours: true,
                                            hoursFrom: 1,
                                            hoursTo: 24,
                                            days: true,
                                            daysFrom: 1,
                                            daysTo: 366,
                                            weeks: true,
                                            weeksFrom: 1,
                                            weeksTo: 52,
                                            months: true,
                                            monthsFrom: 1,
                                            monthsTo: 12,
                                            ranges: true
                                        }
                                    },
                                    zorder: -10000,
                                    ownFirstValue: null,
                                    metaInfo: {
                                        palettes: {},
                                        inputs: [
                                            {
                                                id: "showZones",
                                                name: "Show Zones",
                                                defval: true,
                                                type: "bool",
                                                display: 0
                                            },
                                            {
                                                id: "period",
                                                name: "Period",
                                                defval: 50,
                                                type: "integer",
                                                min: 1,
                                                max: 500,
                                                display: 15
                                            },
                                            {
                                                id: "strong",
                                                name: "Strong",
                                                defval: 20,
                                                type: "integer",
                                                min: 1,
                                                max: 500,
                                                display: 15
                                            },
                                            {
                                                id: "weak",
                                                name: "Weak",
                                                defval: 20,
                                                type: "integer",
                                                min: 1,
                                                max: 500,
                                                display: 15
                                            }, 
                                        ],
                                        plots: [
                                            {
                                                id: "main",
                                                type: "line"
                                            },
                                            {
                                                id: "strong",
                                                type: "line"
                                            },
                                            {
                                                id: "weak",
                                                type: "line"
                                            }, 
                                        ],
                                        graphics: {},
                                        defaults: {
                                            filledAreasStyle: {
                                                strongArea: {
                                                    color: "#009900",
                                                    transparency: 80,
                                                    visible: true
                                                },
                                                weakArea: {
                                                    color: "#B80E0C",
                                                    transparency: 80,
                                                    visible: true
                                                }
                                            },
                                            styles: {
                                                main: {
                                                    display: 15,
                                                    plottype: 0,
                                                    color: "#333333",
                                                    linewidth: 2,
                                                    transparency: 50
                                                },
                                                strong: {
                                                    display: 15,
                                                    plottype: 0,
                                                    color: "#B80E0C",
                                                    transparency: 80,
                                                    linewidth: 1
                                                },
                                                weak: {
                                                    display: 15,
                                                    plottype: 0,
                                                    color: "#B80E0C",
                                                    transparency: 80,
                                                    linewidth: 1
                                                }
                                            },
                                            precision: 2,
                                            inputs: {
                                                showZones: true,
                                                period: 50,
                                                strong: 20,
                                                weak: 20
                                            }
                                        },
                                        _metainfoVersion: 53,
                                        id: "Foreign Strength@tv-basicstudies-1",
                                        name: "Foreign Strength",
                                        description: "Foreign Strength",
                                        shortDescription: "Foreign Strength",
                                        is_price_study: false,
                                        isCustomIndicator: true,
                                        format: {
                                            type: "price",
                                            precision: 2
                                        },
                                        filledAreas: [
                                            {
                                                id: "strongArea",
                                                objAId: "main",
                                                objBId: "strong",
                                                type: "plot_plot",
                                                title: "Strong Background"
                                            },
                                            {
                                                id: "weakArea",
                                                objAId: "main",
                                                objBId: "weak",
                                                type: "plot_plot",
                                                title: "Weak Background"
                                            }, 
                                        ],
                                        styles: {
                                            main: {
                                                title: "Foreign Strength"
                                            },
                                            strong: {
                                                title: "Strong"
                                            },
                                            weak: {
                                                title: "Weak"
                                            }
                                        },
                                        description_localized: "Foreign Strength",
                                        shortId: "Foreign Strength",
                                        packageId: "tv-basicstudies",
                                        version: "1",
                                        fullId: "Foreign Strength@tv-basicstudies-1",
                                        productId: "tv-basicstudies",
                                        _serverMetaInfoVersion: 51
                                    }
                                }, 
                            ],
                            mainSourceId: "wt9yiH",
                            stretchFactor: 648.5699264524955,
                            leftAxisesState: [],
                            rightAxisesState: [
                                {
                                    state: {
                                        id: "KgncAbvd9mxY",
                                        m_priceRange: null,
                                        m_isAutoScale: true,
                                        m_isPercentage: false,
                                        m_isIndexedTo100: false,
                                        m_isLog: false,
                                        m_isLockScale: false,
                                        m_isInverted: false,
                                        m_topMargin: 0.17,
                                        m_bottomMargin: 0.15,
                                        alignLabels: true,
                                        logFormula: {
                                            logicalOffset: 4,
                                            coordOffset: 0.0001
                                        }
                                    },
                                    sources: [
                                        "wt9yiH"
                                    ]
                                }, 
                            ],
                            overlayPriceScales: {},
                            priceScaleRatio: null
                        }, 
                    ],
                    timeScale: {
                        m_barSpacing: 6,
                        m_rightOffset: 10,
                        rightOffsetPercentage: 5,
                        usePercentageRightOffset: false
                    },
                    chartProperties: {
                        paneProperties: {
                            backgroundType: "solid",
                            background: "#ffffff",
                            backgroundGradientStartColor: "#ffffff",
                            backgroundGradientEndColor: "#ffffff",
                            gridLinesMode: "both",
                            vertGridProperties: {
                                color: "rgba(42, 46, 57, 0.06)"
                            },
                            horzGridProperties: {
                                color: "rgba(42, 46, 57, 0.06)"
                            },
                            crossHairProperties: {
                                color: "#9598A1",
                                style: 2,
                                transparency: 0,
                                width: 1,
                                "color:": "#9598A1"
                            },
                            topMargin: 17,
                            bottomMargin: 15,
                            axisProperties: {
                                autoScale: true,
                                autoScaleDisabled: false,
                                lockScale: false,
                                percentage: false,
                                percentageDisabled: false,
                                indexedTo100: false,
                                log: false,
                                logDisabled: false,
                                alignLabels: true,
                                isInverted: false
                            },
                            legendProperties: {
                                showStudyArguments: true,
                                showStudyTitles: true,
                                showStudyValues: false,
                                showSeriesTitle: true,
                                showSeriesOHLC: true,
                                showLegend: true,
                                showBarChange: true,
                                showVolume: false,
                                showBackground: true,
                                showPriceSource: true,
                                backgroundTransparency: 50,
                                showLogo: true,
                                wrapText: false,
                                showOnlyPriceSource: true
                            },
                            separatorColor: "#E0E3EB",
                            gridProperties: {
                                color: "#e1ecf2",
                                style: 0
                            },
                            leftAxisProperties: {
                                autoScale: true,
                                autoScaleDisabled: false,
                                lockScale: false,
                                percentage: false,
                                percentageDisabled: false,
                                indexedTo100: false,
                                log: false,
                                logDisabled: false,
                                alignLabels: true
                            },
                            rightAxisProperties: {
                                autoScale: true,
                                autoScaleDisabled: false,
                                lockScale: false,
                                percentage: false,
                                percentageDisabled: false,
                                log: false,
                                logDisabled: false,
                                alignLabels: true,
                                indexedTo100: false
                            },
                            rightOffset: null
                        },
                        scalesProperties: {
                            backgroundColor: "#ffffff",
                            lineColor: "rgba(42, 46, 57, 0)",
                            textColor: "#131722",
                            fontSize: 12,
                            scaleSeriesOnly: false,
                            showSeriesLastValue: true,
                            seriesLastValueMode: 1,
                            showSeriesPrevCloseValue: false,
                            showStudyLastValue: true,
                            showSymbolLabels: false,
                            showStudyPlotLabels: false,
                            showBidAskLabels: false,
                            showPrePostMarketPriceLabel: true,
                            showFundamentalNameLabel: false,
                            showFundamentalLastValue: true,
                            barSpacing: 6,
                            axisHighlightColor: "rgba(41, 98, 255, 0.25)",
                            axisLineToolLabelBackgroundColorCommon: "#2962FF",
                            axisLineToolLabelBackgroundColorActive: "#143EB3",
                            showPriceScaleCrosshairLabel: true,
                            showTimeScaleCrosshairLabel: true,
                            crosshairLabelBgColorLight: "#131722",
                            crosshairLabelBgColorDark: "#363A45",
                            showCurrency: true,
                            showUnit: true,
                            showLeftScale: false,
                            showRightScale: true
                        },
                        chartEventsSourceProperties: {
                            visible: true,
                            futureOnly: true,
                            breaks: {
                                color: "rgba(85, 85, 85, 1)",
                                visible: false,
                                style: 2,
                                width: 1
                            }
                        },
                        tradingProperties: {
                            showPositions: true,
                            positionPL: {
                                visibility: true,
                                display: 0
                            },
                            bracketsPL: {
                                visibility: true,
                                display: 0
                            },
                            showOrders: true,
                            showExecutions: true,
                            showExecutionsLabels: false,
                            showReverse: true,
                            horizontalAlignment: 2,
                            extendLeft: true,
                            lineLength: 5,
                            lineWidth: 1,
                            lineStyle: 0
                        },
                        priceScaleSelectionStrategyName: "auto"
                    },
                    sessions: {
                        properties: {
                            graphics: {
                                backgrounds: {
                                    outOfSession: {
                                        color: "#2962FF",
                                        transparency: 92,
                                        visible: false
                                    },
                                    preMarket: {
                                        color: "#FF9800",
                                        transparency: 92,
                                        visible: false
                                    },
                                    postMarket: {
                                        color: "#2962FF",
                                        transparency: 92,
                                        visible: false
                                    }
                                },
                                vertlines: {
                                    sessBreaks: {
                                        color: "#4985e7",
                                        style: 2,
                                        visible: false,
                                        width: 1
                                    }
                                }
                            }
                        }
                    },
                    version: 3,
                    timezone: "Asia/Jakarta",
                    shouldBeSavedEvenIfHidden: true,
                    linkingGroup: null,
                    lineToolsGroups: {
                        groups: []
                    },
                    chartId: "1",
                    theme: "light"
                }, 
            ],
            symbolLock: 0,
            intervalLock: 0,
            trackTimeLock: 0,
            dateRangeLock: 0,
            crosshairLock: 1,
            layoutsSizes: {
                s: [
                    {
                        percent: 1
                    }
                ]
            }
        }
    },
    {
        key: "bandarmology",
        name: "Bandarmology",
        template: {
            layout: "s",
            charts: [
                {
                    panes: [
                        {
                            sources: [
                                {
                                    type: "MainSeries",
                                    id: "_seriesId",
                                    zorder: 0,
                                    haStyle: {
                                        studyId: "BarSetHeikenAshi@tv-basicstudies-60"
                                    },
                                    renkoStyle: {
                                        studyId: "BarSetRenko@tv-prostudies-64"
                                    },
                                    pbStyle: {
                                        studyId: "BarSetPriceBreak@tv-prostudies-34"
                                    },
                                    kagiStyle: {
                                        studyId: "BarSetKagi@tv-prostudies-34"
                                    },
                                    pnfStyle: {
                                        studyId: "BarSetPnF@tv-prostudies-34"
                                    },
                                    rangeStyle: {
                                        studyId: "BarSetRange@tv-basicstudies-72"
                                    },
                                    formattingDeps: {
                                        format: "price",
                                        pricescale: 1,
                                        minmov: 1
                                    },
                                    state: {
                                        style: 1,
                                        esdShowDividends: true,
                                        esdShowSplits: true,
                                        esdShowEarnings: true,
                                        esdShowBreaks: false,
                                        esdFlagSize: 2,
                                        showContinuousContractSwitches: true,
                                        showContinuousContractSwitchesBreaks: false,
                                        showFuturesContractExpiration: true,
                                        showLastNews: true,
                                        showCountdown: false,
                                        bidAsk: {
                                            visible: false,
                                            lineStyle: 1,
                                            lineWidth: 1,
                                            bidLineColor: "#2962FF",
                                            askLineColor: "#F7525F"
                                        },
                                        prePostMarket: {
                                            visible: true,
                                            lineStyle: 1,
                                            lineWidth: 1,
                                            preMarketColor: "#FB8C00",
                                            postMarketColor: "#2962FF"
                                        },
                                        highLowAvgPrice: {
                                            highLowPriceLinesVisible: false,
                                            highLowPriceLabelsVisible: false,
                                            averageClosePriceLineVisible: false,
                                            averageClosePriceLabelVisible: false,
                                            highLowPriceLinesColor: "",
                                            highLowPriceLinesWidth: 1,
                                            averagePriceLineColor: "",
                                            averagePriceLineWidth: 1
                                        },
                                        visible: true,
                                        showPriceLine: true,
                                        priceLineWidth: 1,
                                        priceLineColor: "",
                                        baseLineColor: "#B2B5BE",
                                        showPrevClosePriceLine: false,
                                        prevClosePriceLineWidth: 1,
                                        prevClosePriceLineColor: "#555555",
                                        minTick: "default",
                                        dividendsAdjustment: null,
                                        backAdjustment: false,
                                        settlementAsClose: true,
                                        sessionId: "regular",
                                        sessVis: false,
                                        statusViewStyle: {
                                            fontSize: 16,
                                            showExchange: true,
                                            showInterval: true,
                                            symbolTextSource: "description",
                                            showSymbolAsDescription: false
                                        },
                                        candleStyle: {
                                            upColor: "#009900",
                                            downColor: "#B80E0C",
                                            drawWick: true,
                                            drawBorder: true,
                                            borderColor: "#000000",
                                            borderUpColor: "#000000",
                                            borderDownColor: "#000000",
                                            wickColor: "#737375",
                                            wickUpColor: "#000000",
                                            wickDownColor: "#000000",
                                            barColorsOnPrevClose: false,
                                            drawBody: true
                                        },
                                        hollowCandleStyle: {
                                            upColor: "#089981",
                                            downColor: "#F23645",
                                            drawWick: true,
                                            drawBorder: true,
                                            borderColor: "#378658",
                                            borderUpColor: "#089981",
                                            borderDownColor: "#F23645",
                                            wickColor: "#737375",
                                            wickUpColor: "#089981",
                                            wickDownColor: "#F23645",
                                            drawBody: true
                                        },
                                        haStyle: {
                                            upColor: "#089981",
                                            downColor: "#F23645",
                                            drawWick: true,
                                            drawBorder: true,
                                            borderColor: "#378658",
                                            borderUpColor: "#089981",
                                            borderDownColor: "#F23645",
                                            wickColor: "#737375",
                                            wickUpColor: "#089981",
                                            wickDownColor: "#F23645",
                                            showRealLastPrice: false,
                                            barColorsOnPrevClose: false,
                                            inputs: {},
                                            inputInfo: {},
                                            drawBody: true
                                        },
                                        barStyle: {
                                            upColor: "#089981",
                                            downColor: "#F23645",
                                            barColorsOnPrevClose: false,
                                            dontDrawOpen: false,
                                            thinBars: true
                                        },
                                        hiloStyle: {
                                            color: "#2962FF",
                                            showBorders: true,
                                            borderColor: "#2962FF",
                                            showLabels: true,
                                            labelColor: "#2962FF",
                                            drawBody: true,
                                            fontSize: 7
                                        },
                                        columnStyle: {
                                            upColor: "rgba(8, 153, 129, 0.5)",
                                            downColor: "rgba(242, 54, 69, 0.5)",
                                            barColorsOnPrevClose: true,
                                            priceSource: "close"
                                        },
                                        lineStyle: {
                                            color: "#2962FF",
                                            linestyle: 0,
                                            linewidth: 2,
                                            priceSource: "close"
                                        },
                                        lineWithMarkersStyle: {
                                            color: "#2962FF",
                                            linestyle: 0,
                                            linewidth: 2,
                                            priceSource: "close"
                                        },
                                        steplineStyle: {
                                            color: "#2962FF",
                                            linestyle: 0,
                                            linewidth: 2,
                                            priceSource: "close"
                                        },
                                        areaStyle: {
                                            color1: "rgba(41, 98, 255, 0.28)",
                                            color2: "#2962FF",
                                            linecolor: "#2962FF",
                                            linestyle: 0,
                                            linewidth: 1,
                                            priceSource: "close",
                                            transparency: 100
                                        },
                                        hlcAreaStyle: {
                                            highLineColor: "#089981",
                                            highLineStyle: 0,
                                            highLineWidth: 2,
                                            lowLineColor: "#F23645",
                                            lowLineStyle: 0,
                                            lowLineWidth: 2,
                                            closeLineColor: "#868993",
                                            closeLineStyle: 0,
                                            closeLineWidth: 2,
                                            highCloseFillColor: "rgba(8, 153, 129, 0.2)",
                                            closeLowFillColor: "rgba(242, 54, 69, 0.2)"
                                        },
                                        renkoStyle: {
                                            upColor: "#089981",
                                            downColor: "#F23645",
                                            borderUpColor: "#089981",
                                            borderDownColor: "#F23645",
                                            upColorProjection: "#a9dcc3",
                                            downColorProjection: "#f5a6ae",
                                            borderUpColorProjection: "#a9dcc3",
                                            borderDownColorProjection: "#f5a6ae",
                                            wickUpColor: "#089981",
                                            wickDownColor: "#F23645",
                                            inputs: {
                                                source: "close",
                                                sources: "Close",
                                                boxSize: 3,
                                                style: "ATR",
                                                atrLength: 14,
                                                wicks: true
                                            },
                                            inputInfo: {
                                                source: {
                                                    name: "Source"
                                                },
                                                sources: {
                                                    name: "Source"
                                                },
                                                boxSize: {
                                                    name: "Box size"
                                                },
                                                style: {
                                                    name: "Style"
                                                },
                                                atrLength: {
                                                    name: "ATR length"
                                                },
                                                wicks: {
                                                    name: "Wicks"
                                                }
                                            }
                                        },
                                        pbStyle: {
                                            upColor: "#089981",
                                            downColor: "#F23645",
                                            borderUpColor: "#089981",
                                            borderDownColor: "#F23645",
                                            upColorProjection: "#a9dcc3",
                                            downColorProjection: "#f5a6ae",
                                            borderUpColorProjection: "#a9dcc3",
                                            borderDownColorProjection: "#f5a6ae",
                                            inputs: {
                                                source: "close",
                                                lb: 3
                                            },
                                            inputInfo: {
                                                source: {
                                                    name: "Source"
                                                },
                                                lb: {
                                                    name: "Number of line"
                                                }
                                            }
                                        },
                                        kagiStyle: {
                                            upColor: "#089981",
                                            downColor: "#F23645",
                                            upColorProjection: "#a9dcc3",
                                            downColorProjection: "#f5a6ae",
                                            inputs: {
                                                source: "close",
                                                style: "ATR",
                                                atrLength: 14,
                                                reversalAmount: 1
                                            },
                                            inputInfo: {
                                                source: {
                                                    name: "Source"
                                                },
                                                style: {
                                                    name: "Style"
                                                },
                                                atrLength: {
                                                    name: "ATR length"
                                                },
                                                reversalAmount: {
                                                    name: "Reversal amount"
                                                }
                                            }
                                        },
                                        pnfStyle: {
                                            upColor: "#089981",
                                            downColor: "#F23645",
                                            upColorProjection: "#a9dcc3",
                                            downColorProjection: "#f5a6ae",
                                            inputs: {
                                                sources: "Close",
                                                reversalAmount: 3,
                                                boxSize: 1,
                                                style: "ATR",
                                                atrLength: 14,
                                                oneStepBackBuilding: false
                                            },
                                            inputInfo: {
                                                sources: {
                                                    name: "Source"
                                                },
                                                boxSize: {
                                                    name: "Box size"
                                                },
                                                reversalAmount: {
                                                    name: "Reversal amount"
                                                },
                                                style: {
                                                    name: "Style"
                                                },
                                                atrLength: {
                                                    name: "ATR length"
                                                },
                                                oneStepBackBuilding: {
                                                    name: "One step back building"
                                                }
                                            }
                                        },
                                        baselineStyle: {
                                            baselineColor: "#758696",
                                            topFillColor1: "rgba(8, 153, 129, 0.28)",
                                            topFillColor2: "rgba(8, 153, 129, 0.05)",
                                            bottomFillColor1: "rgba(242, 54, 69, 0.05)",
                                            bottomFillColor2: "rgba(242, 54, 69, 0.28)",
                                            topLineColor: "#089981",
                                            bottomLineColor: "#F23645",
                                            topLineWidth: 1,
                                            bottomLineWidth: 1,
                                            priceSource: "close",
                                            transparency: 50,
                                            baseLevelPercentage: 50
                                        },
                                        rangeStyle: {
                                            barStyle: 0,
                                            upColor: "#089981",
                                            downColor: "#F23645",
                                            upColorProjection: "#a9dcc3",
                                            downColorProjection: "#f5a6ae",
                                            thinBars: true,
                                            candlesUpColor: "#089981",
                                            candlesDownColor: "#F23645",
                                            candlesBorderUpColor: "#089981",
                                            candlesBorderDownColor: "#F23645",
                                            candlesWickUpColor: "#089981",
                                            candlesWickDownColor: "#F23645",
                                            inputs: {
                                                range: 10,
                                                phantomBars: false
                                            },
                                            inputInfo: {
                                                range: {
                                                    name: "Range"
                                                },
                                                phantomBars: {
                                                    name: "Phantom bars"
                                                }
                                            }
                                        },
                                        symbol: "BBCA",
                                        shortName: "BBCA",
                                        timeframe: "",
                                        onWidget: false,
                                        interval: "D",
                                        unitId: null,
                                        showInDataWindow: true,
                                        showSessions: false,
                                        shortname: "",
                                        currencyId: null,
                                        priceAxisProperties: {
                                            autoScale: true,
                                            autoScaleDisabled: false,
                                            lockScale: false,
                                            percentage: false,
                                            percentageDisabled: false,
                                            log: false,
                                            logDisabled: false,
                                            alignLabels: true,
                                            isInverted: false,
                                            indexedTo100: false
                                        }
                                    }
                                }, 
                            ],
                            mainSourceId: "_seriesId",
                            stretchFactor: 4910.315574383505,
                            leftAxisesState: [],
                            rightAxisesState: [
                                {
                                    state: {
                                        id: "fuH0asbqXhZu",
                                        m_priceRange: null,
                                        m_isAutoScale: true,
                                        m_isPercentage: false,
                                        m_isIndexedTo100: false,
                                        m_isLog: false,
                                        m_isLockScale: false,
                                        m_isInverted: false,
                                        m_topMargin: 0.17,
                                        m_bottomMargin: 0.15,
                                        alignLabels: true,
                                        logFormula: {
                                            logicalOffset: 4,
                                            coordOffset: 0.0001
                                        }
                                    },
                                    sources: [
                                        "_seriesId"
                                    ]
                                }, 
                            ],
                            overlayPriceScales: {},
                            priceScaleRatio: null
                        },
                        {
                            sources: [
                                {
                                    type: "Study",
                                    id: "1di27H",
                                    state: {
                                        styles: {
                                            vol: {
                                                display: 15,
                                                linestyle: 0,
                                                linewidth: 1,
                                                plottype: 5,
                                                trackPrice: false,
                                                transparency: 0,
                                                color: "#000080",
                                                title: "vol"
                                            },
                                            vol_ma: {
                                                display: 15,
                                                linestyle: 0,
                                                linewidth: 2,
                                                plottype: 0,
                                                trackPrice: false,
                                                transparency: 30,
                                                color: "#0496ff",
                                                title: "vol_ma"
                                            }
                                        },
                                        precision: "default",
                                        palettes: {
                                            volumePalette: {
                                                colors: {
                                                    0: {
                                                        color: "rgba(235, 77, 92, 0.50)",
                                                        width: 1,
                                                        style: 0
                                                    },
                                                    1: {
                                                        color: "rgba(83, 185, 135, 0.50)",
                                                        width: 1,
                                                        style: 0
                                                    }
                                                }
                                            }
                                        },
                                        inputs: {
                                            showMA: true,
                                            maLength: 20
                                        },
                                        bands: {},
                                        graphics: {},
                                        ohlcPlots: {},
                                        filledAreasStyle: {},
                                        filledAreas: {},
                                        visible: true,
                                        showLegendValues: true,
                                        showLabelsOnPriceScale: true,
                                        parentSources: {},
                                        intervalsVisibilities: {
                                            ticks: true,
                                            seconds: true,
                                            secondsFrom: 1,
                                            secondsTo: 59,
                                            minutes: true,
                                            minutesFrom: 1,
                                            minutesTo: 59,
                                            hours: true,
                                            hoursFrom: 1,
                                            hoursTo: 24,
                                            days: true,
                                            daysFrom: 1,
                                            daysTo: 366,
                                            weeks: true,
                                            weeksFrom: 1,
                                            weeksTo: 52,
                                            months: true,
                                            monthsFrom: 1,
                                            monthsTo: 12,
                                            ranges: true
                                        }
                                    },
                                    zorder: -10000,
                                    ownFirstValue: null,
                                    metaInfo: {
                                        palettes: {
                                            volumePalette: {
                                                colors: [
                                                    {
                                                        name: "Falling"
                                                    },
                                                    {
                                                        name: "Growing"
                                                    }
                                                ]
                                            }
                                        },
                                        inputs: [
                                            {
                                                id: "showMA",
                                                name: "show MA",
                                                defval: true,
                                                type: "bool",
                                                display: 0
                                            },
                                            {
                                                id: "maLength",
                                                name: "MA Length",
                                                defval: 20,
                                                type: "integer",
                                                min: 1,
                                                max: 2000,
                                                display: 15
                                            }, 
                                        ],
                                        plots: [
                                            {
                                                id: "vol",
                                                type: "line"
                                            },
                                            {
                                                id: "volumePalette",
                                                palette: "volumePalette",
                                                target: "vol",
                                                type: "colorer"
                                            },
                                            {
                                                id: "vol_ma",
                                                type: "line"
                                            }, 
                                        ],
                                        graphics: {},
                                        defaults: {
                                            styles: {
                                                vol: {
                                                    display: 15,
                                                    linestyle: 0,
                                                    linewidth: 1,
                                                    plottype: 5,
                                                    trackPrice: false,
                                                    transparency: 0,
                                                    color: "#000080"
                                                },
                                                vol_ma: {
                                                    display: 15,
                                                    linestyle: 0,
                                                    linewidth: 2,
                                                    plottype: 0,
                                                    trackPrice: false,
                                                    transparency: 30,
                                                    color: "#0496FF"
                                                }
                                            },
                                            precision: 0,
                                            palettes: {
                                                volumePalette: {
                                                    colors: {
                                                        0: {
                                                            color: "rgba(235, 77, 92, 0.50)",
                                                            width: 1,
                                                            style: 0
                                                        },
                                                        1: {
                                                            color: "rgba(83, 185, 135, 0.50)",
                                                            width: 1,
                                                            style: 0
                                                        }
                                                    }
                                                }
                                            },
                                            inputs: {
                                                showMA: true,
                                                maLength: 20
                                            }
                                        },
                                        _metainfoVersion: 53,
                                        id: "Volume_@tv-basicstudies-1",
                                        is_hidden_study: false,
                                        description: "Volume_",
                                        shortDescription: "Volume",
                                        is_price_study: false,
                                        format: {
                                            type: "volume",
                                            precision: 3
                                        },
                                        styles: {
                                            vol: {
                                                title: "Volume_",
                                                histogramBase: 0
                                            },
                                            vol_ma: {
                                                title: "Volume MA",
                                                histogramBase: 0
                                            }
                                        },
                                        description_localized: "Volume_",
                                        shortId: "Volume_",
                                        packageId: "tv-basicstudies",
                                        version: "1",
                                        fullId: "Volume_@tv-basicstudies-1",
                                        productId: "tv-basicstudies",
                                        _serverMetaInfoVersion: 51
                                    }
                                }, 
                            ],
                            mainSourceId: "1di27H",
                            stretchFactor: 761.6340921567289,
                            leftAxisesState: [],
                            rightAxisesState: [
                                {
                                    state: {
                                        id: "OT5Qz68Vr8kM",
                                        m_priceRange: null,
                                        m_isAutoScale: true,
                                        m_isPercentage: false,
                                        m_isIndexedTo100: false,
                                        m_isLog: false,
                                        m_isLockScale: false,
                                        m_isInverted: false,
                                        m_topMargin: 0.17,
                                        m_bottomMargin: 0.15,
                                        alignLabels: true,
                                        logFormula: {
                                            logicalOffset: 4,
                                            coordOffset: 0.0001
                                        }
                                    },
                                    sources: [
                                        "1di27H"
                                    ]
                                }, 
                            ],
                            overlayPriceScales: {},
                            priceScaleRatio: null
                        },
                        {
                            sources: [
                                {
                                    type: "Study",
                                    id: "FRzT2x",
                                    state: {
                                        styles: {
                                            plot_0: {
                                                display: 15,
                                                linestyle: 0,
                                                linewidth: 2,
                                                plottype: 0,
                                                transparency: 40,
                                                color: "#1CBECB",
                                                trackPrice: false,
                                                title: "plot_0"
                                            }
                                        },
                                        precision: "default",
                                        inputs: {},
                                        bands: {},
                                        graphics: {},
                                        ohlcPlots: {},
                                        palettes: {},
                                        filledAreasStyle: {},
                                        filledAreas: {},
                                        visible: true,
                                        showLegendValues: true,
                                        showLabelsOnPriceScale: true,
                                        parentSources: {},
                                        intervalsVisibilities: {
                                            ticks: true,
                                            seconds: true,
                                            secondsFrom: 1,
                                            secondsTo: 59,
                                            minutes: true,
                                            minutesFrom: 1,
                                            minutesTo: 59,
                                            hours: true,
                                            hoursFrom: 1,
                                            hoursTo: 24,
                                            days: true,
                                            daysFrom: 1,
                                            daysTo: 366,
                                            weeks: true,
                                            weeksFrom: 1,
                                            weeksTo: 52,
                                            months: true,
                                            monthsFrom: 1,
                                            monthsTo: 12,
                                            ranges: true
                                        }
                                    },
                                    zorder: -10000,
                                    ownFirstValue: null,
                                    metaInfo: {
                                        palettes: {},
                                        inputs: [],
                                        plots: [
                                            {
                                                id: "plot_0",
                                                type: "line",
                                                palette: "palette_0",
                                                target: "Bandar Value (Rp)"
                                            }, 
                                        ],
                                        graphics: {},
                                        defaults: {
                                            styles: {
                                                plot_0: {
                                                    display: 15,
                                                    linestyle: 0,
                                                    linewidth: 2,
                                                    plottype: 0,
                                                    transparency: 11,
                                                    color: "#465ADB"
                                                }
                                            },
                                            precision: 0,
                                            inputs: {}
                                        },
                                        _metainfoVersion: 53,
                                        id: "Bandar Value (Rp)@tv-basicstudies-1",
                                        name: "Bandar Value (Rp)",
                                        description: "Bandar Value (Rp)",
                                        shortDescription: "Bandar Value (Rp)",
                                        is_hidden_study: false,
                                        is_price_study: false,
                                        isCustomIndicator: true,
                                        format: {
                                            type: "volume",
                                            precision: 3
                                        },
                                        styles: {
                                            plot_0: {
                                                title: "Bandar Value (Rp) value",
                                                histogramBase: 0
                                            }
                                        },
                                        description_localized: "Bandar Value (Rp)",
                                        shortId: "Bandar Value (Rp)",
                                        packageId: "tv-basicstudies",
                                        version: "1",
                                        fullId: "Bandar Value (Rp)@tv-basicstudies-1",
                                        productId: "tv-basicstudies",
                                        _serverMetaInfoVersion: 51
                                    }
                                }, 
                            ],
                            mainSourceId: "FRzT2x",
                            stretchFactor: 639.1681834955561,
                            leftAxisesState: [],
                            rightAxisesState: [
                                {
                                    state: {
                                        id: "GN2Rji3Lwd0M",
                                        m_priceRange: null,
                                        m_isAutoScale: true,
                                        m_isPercentage: false,
                                        m_isIndexedTo100: false,
                                        m_isLog: false,
                                        m_isLockScale: false,
                                        m_isInverted: false,
                                        m_topMargin: 0.17,
                                        m_bottomMargin: 0.15,
                                        alignLabels: true,
                                        logFormula: {
                                            logicalOffset: 4,
                                            coordOffset: 0.0001
                                        }
                                    },
                                    sources: [
                                        "FRzT2x"
                                    ]
                                }, 
                            ],
                            overlayPriceScales: {},
                            priceScaleRatio: null
                        },
                        {
                            sources: [
                                {
                                    type: "Study",
                                    id: "Tpv9Jx",
                                    state: {
                                        palettes: {
                                            palette_0: {
                                                colors: {
                                                    0: {
                                                        color: "#B80E0C",
                                                        width: 5,
                                                        style: 0
                                                    },
                                                    1: {
                                                        color: "#009900",
                                                        width: 5,
                                                        style: 0
                                                    }
                                                }
                                            }
                                        },
                                        styles: {
                                            plot_0: {
                                                display: 15,
                                                linestyle: 0,
                                                linewidth: 5,
                                                plottype: 5,
                                                trackPrice: false,
                                                transparency: 11,
                                                color: "#009900",
                                                title: "plot_0"
                                            }
                                        },
                                        precision: "default",
                                        inputs: {},
                                        bands: {},
                                        graphics: {},
                                        ohlcPlots: {},
                                        filledAreasStyle: {},
                                        filledAreas: {},
                                        visible: true,
                                        showLegendValues: true,
                                        showLabelsOnPriceScale: true,
                                        parentSources: {},
                                        intervalsVisibilities: {
                                            ticks: true,
                                            seconds: true,
                                            secondsFrom: 1,
                                            secondsTo: 59,
                                            minutes: true,
                                            minutesFrom: 1,
                                            minutesTo: 59,
                                            hours: true,
                                            hoursFrom: 1,
                                            hoursTo: 24,
                                            days: true,
                                            daysFrom: 1,
                                            daysTo: 366,
                                            weeks: true,
                                            weeksFrom: 1,
                                            weeksTo: 52,
                                            months: true,
                                            monthsFrom: 1,
                                            monthsTo: 12,
                                            ranges: true
                                        }
                                    },
                                    zorder: -10000,
                                    ownFirstValue: null,
                                    metaInfo: {
                                        palettes: {
                                            palette_0: {
                                                colors: [
                                                    {
                                                        name: "Color 0"
                                                    },
                                                    {
                                                        name: "Color 1"
                                                    }
                                                ]
                                            }
                                        },
                                        inputs: [],
                                        plots: [
                                            {
                                                id: "plot_0",
                                                type: "line"
                                            },
                                            {
                                                id: "plot_1",
                                                palette: "palette_0",
                                                target: "plot_0",
                                                type: "colorer"
                                            }, 
                                        ],
                                        graphics: {},
                                        defaults: {
                                            palettes: {
                                                palette_0: {
                                                    colors: [
                                                        {
                                                            color: "#B80E0C",
                                                            width: 5,
                                                            style: 0
                                                        },
                                                        {
                                                            color: "#009900",
                                                            width: 5,
                                                            style: 0
                                                        }, 
                                                    ]
                                                }
                                            },
                                            styles: {
                                                plot_0: {
                                                    display: 15,
                                                    linestyle: 0,
                                                    linewidth: 5,
                                                    plottype: 5,
                                                    trackPrice: false,
                                                    transparency: 11,
                                                    color: "#009900"
                                                }
                                            },
                                            precision: 0,
                                            inputs: {}
                                        },
                                        _metainfoVersion: 53,
                                        id: "Bandar Volume@tv-basicstudies-1",
                                        name: "Bandar Volume",
                                        description: "Bandar Volume",
                                        shortDescription: "Bandar Volume",
                                        is_hidden_study: false,
                                        is_price_study: false,
                                        isCustomIndicator: true,
                                        format: {
                                            type: "volume",
                                            precision: 2
                                        },
                                        styles: {
                                            plot_0: {
                                                title: "Bandar Volume value",
                                                histogramBase: 0,
                                                joinPoints: false
                                            }
                                        },
                                        description_localized: "Bandar Volume",
                                        shortId: "Bandar Volume",
                                        packageId: "tv-basicstudies",
                                        version: "1",
                                        fullId: "Bandar Volume@tv-basicstudies-1",
                                        productId: "tv-basicstudies",
                                        _serverMetaInfoVersion: 51
                                    }
                                }, 
                            ],
                            mainSourceId: "Tpv9Jx",
                            stretchFactor: 781.9548872180451,
                            leftAxisesState: [],
                            rightAxisesState: [
                                {
                                    state: {
                                        id: "E3WO8eglD0cw",
                                        m_priceRange: null,
                                        m_isAutoScale: true,
                                        m_isPercentage: false,
                                        m_isIndexedTo100: false,
                                        m_isLog: false,
                                        m_isLockScale: false,
                                        m_isInverted: false,
                                        m_topMargin: 0.17,
                                        m_bottomMargin: 0.15,
                                        alignLabels: true,
                                        logFormula: {
                                            logicalOffset: 4,
                                            coordOffset: 0.0001
                                        }
                                    },
                                    sources: [
                                        "Tpv9Jx"
                                    ]
                                }, 
                            ],
                            overlayPriceScales: {},
                            priceScaleRatio: null
                        }, 
                    ],
                    timeScale: {
                        m_barSpacing: 6,
                        m_rightOffset: 10,
                        rightOffsetPercentage: 5,
                        usePercentageRightOffset: false
                    },
                    chartProperties: {
                        paneProperties: {
                            backgroundType: "solid",
                            background: "#ffffff",
                            backgroundGradientStartColor: "#ffffff",
                            backgroundGradientEndColor: "#ffffff",
                            gridLinesMode: "both",
                            vertGridProperties: {
                                color: "rgba(42, 46, 57, 0.06)"
                            },
                            horzGridProperties: {
                                color: "rgba(42, 46, 57, 0.06)"
                            },
                            crossHairProperties: {
                                color: "#9598A1",
                                style: 2,
                                transparency: 0,
                                width: 1,
                                "color:": "#9598A1"
                            },
                            topMargin: 17,
                            bottomMargin: 15,
                            axisProperties: {
                                autoScale: true,
                                autoScaleDisabled: false,
                                lockScale: false,
                                percentage: false,
                                percentageDisabled: false,
                                indexedTo100: false,
                                log: false,
                                logDisabled: false,
                                alignLabels: true,
                                isInverted: false
                            },
                            legendProperties: {
                                showStudyArguments: true,
                                showStudyTitles: true,
                                showStudyValues: false,
                                showSeriesTitle: true,
                                showSeriesOHLC: true,
                                showLegend: true,
                                showBarChange: true,
                                showVolume: false,
                                showBackground: true,
                                showPriceSource: true,
                                backgroundTransparency: 50,
                                showLogo: true,
                                wrapText: false,
                                showOnlyPriceSource: true
                            },
                            separatorColor: "#E0E3EB",
                            gridProperties: {
                                color: "#e1ecf2",
                                style: 0
                            },
                            leftAxisProperties: {
                                autoScale: true,
                                autoScaleDisabled: false,
                                lockScale: false,
                                percentage: false,
                                percentageDisabled: false,
                                indexedTo100: false,
                                log: false,
                                logDisabled: false,
                                alignLabels: true
                            },
                            rightAxisProperties: {
                                autoScale: true,
                                autoScaleDisabled: false,
                                lockScale: false,
                                percentage: false,
                                percentageDisabled: false,
                                log: false,
                                logDisabled: false,
                                alignLabels: true,
                                indexedTo100: false
                            },
                            rightOffset: null
                        },
                        scalesProperties: {
                            backgroundColor: "#ffffff",
                            lineColor: "rgba(42, 46, 57, 0)",
                            textColor: "#131722",
                            fontSize: 12,
                            scaleSeriesOnly: false,
                            showSeriesLastValue: true,
                            seriesLastValueMode: 1,
                            showSeriesPrevCloseValue: false,
                            showStudyLastValue: true,
                            showSymbolLabels: false,
                            showStudyPlotLabels: false,
                            showBidAskLabels: false,
                            showPrePostMarketPriceLabel: true,
                            showFundamentalNameLabel: false,
                            showFundamentalLastValue: true,
                            barSpacing: 6,
                            axisHighlightColor: "rgba(41, 98, 255, 0.25)",
                            axisLineToolLabelBackgroundColorCommon: "#2962FF",
                            axisLineToolLabelBackgroundColorActive: "#143EB3",
                            showPriceScaleCrosshairLabel: true,
                            showTimeScaleCrosshairLabel: true,
                            crosshairLabelBgColorLight: "#131722",
                            crosshairLabelBgColorDark: "#363A45",
                            showCurrency: true,
                            showUnit: true,
                            showLeftScale: false,
                            showRightScale: true
                        },
                        chartEventsSourceProperties: {
                            visible: true,
                            futureOnly: true,
                            breaks: {
                                color: "rgba(85, 85, 85, 1)",
                                visible: false,
                                style: 2,
                                width: 1
                            }
                        },
                        tradingProperties: {
                            showPositions: true,
                            positionPL: {
                                visibility: true,
                                display: 0
                            },
                            bracketsPL: {
                                visibility: true,
                                display: 0
                            },
                            showOrders: true,
                            showExecutions: true,
                            showExecutionsLabels: false,
                            showReverse: true,
                            horizontalAlignment: 2,
                            extendLeft: true,
                            lineLength: 5,
                            lineWidth: 1,
                            lineStyle: 0
                        },
                        priceScaleSelectionStrategyName: "auto"
                    },
                    sessions: {
                        properties: {
                            graphics: {
                                backgrounds: {
                                    outOfSession: {
                                        color: "#2962FF",
                                        transparency: 92,
                                        visible: false
                                    },
                                    preMarket: {
                                        color: "#FF9800",
                                        transparency: 92,
                                        visible: false
                                    },
                                    postMarket: {
                                        color: "#2962FF",
                                        transparency: 92,
                                        visible: false
                                    }
                                },
                                vertlines: {
                                    sessBreaks: {
                                        color: "#4985e7",
                                        style: 2,
                                        visible: false,
                                        width: 1
                                    }
                                }
                            }
                        }
                    },
                    version: 3,
                    timezone: "Asia/Jakarta",
                    shouldBeSavedEvenIfHidden: true,
                    linkingGroup: null,
                    lineToolsGroups: {
                        groups: []
                    },
                    chartId: "1",
                    theme: "light"
                }, 
            ],
            symbolLock: 0,
            intervalLock: 0,
            trackTimeLock: 0,
            dateRangeLock: 0,
            crosshairLock: 1,
            layoutsSizes: {
                s: [
                    {
                        percent: 1
                    }
                ]
            }
        }
    }, 
];
/* harmony default export */ __webpack_exports__["Z"] = (templates);


/***/ }),

/***/ 72950:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cw": function() { return /* binding */ MaintenanceTitle; },
/* harmony export */   "KK": function() { return /* binding */ ChartbitLayoutWrapper; },
/* harmony export */   "Vz": function() { return /* binding */ MaintenanceBackButton; },
/* harmony export */   "Xb": function() { return /* binding */ MaintenanceContainer; },
/* harmony export */   "dd": function() { return /* binding */ MaintenanceDesc; },
/* harmony export */   "hq": function() { return /* binding */ MyInvestmentWrapper; },
/* harmony export */   "mU": function() { return /* binding */ ErrorContainer; },
/* harmony export */   "n8": function() { return /* binding */ ChartbitWrapper; },
/* harmony export */   "rZ": function() { return /* binding */ MaintenanceModal; },
/* harmony export */   "xG": function() { return /* binding */ ErrorDesc; },
/* harmony export */   "y": function() { return /* binding */ ErrorRetryButton; }
/* harmony export */ });
/* unused harmony export MaintenanceImage */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);
/* harmony import */ var global_MainLayout_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92589);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 100vh;\n  position: relative;\n\n  /* article > div > div {\n    height: 100vh !important;\n  } */\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        width: calc(100% - ",
        ") !important;\n      "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  position: relative;\n\n  @media ",
        " {\n    width: calc(100% - ",
        ");\n\n    ",
        "\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: none;\n  position: absolute;\n  top: 42px;\n  right: ",
        ";\n  z-index: 1;\n\n  @media ",
        " {\n    display: ",
        ";\n  }\n\n  & > a > div {\n    margin-bottom: 0;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 100vh;\n  background-color: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction column;\n  padding: 20px;\n\n  img {\n    width: 120px;\n    margin-bottom: 10px;\n  }\n\n  @media ",
        " {\n    img {\n      width: 160px;\n    }\n  }\n\n  @media screen and (max-width: 450px) {\n    img {\n      width: 120px !important;\n    }\n    p:first-of-type {\n      font-size: 16px;\n    }\n    p:nth-of-type(2){\n      font-size: 12px\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 16px;\n  margin-bottom: 8px;\n\n  @media ",
        " {\n    font-size: 24px;\n    margin-bottom: 10px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 16px;\n  margin-bottom: 8px;\n  font-weight: 700;\n\n  @media ",
        " {\n    font-size: 24px;\n    margin-bottom: 10px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 14px;\n  margin-bottom: 0;\n  max-width: 280px;\n\n  @media ",
        " {\n    font-size: 16px;\n    max-width: unset;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 12px 20.5px;\n  border-radius: 100px;\n  margin-top: 30px;\n  display: none;\n\n  @media ",
        " {\n    display: flex;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-content {\n    border-radius: 3px;\n    background-color: ",
        ";\n  }\n  .ant-modal-header {\n    background-color: ",
        ";\n  }\n  .ant-modal-close {\n    color: ",
        ";\n  }\n  @media screen and (max-width: 700px) {\n    width: 335px !important;\n\n    .ant-modal-title div {\n      height: unset !important;\n      padding-bottom: 12px !important;\n      p {\n        font-size: 16px;\n        line-height: 22px;\n        width: 267px;\n      }\n    }\n\n    .ant-modal-body div {\n      padding-bottom: 20px !important;\n      p {\n        font-size: 13px;\n      }\n    }\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 100vh;\n  background-color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  padding: 20px;\n\n  @media ",
        " {\n    img {\n      width: 223px;\n      height: 167px;\n    }\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 14px;\n  margin-top: 10px;\n  max-width: 319px;\n\n  @media ",
        " {\n    font-size: 18px;\n    font-family: var(--font-bold);\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 12px 20.5px;\n  border-radius: 100px;\n  margin-top: 30px;\n  display: flex;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}



var Button = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Button */ .Gn.Button, Text = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Text */ .Gn.Text, BaseModal = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Modal */ .Gn.Modal;
var ChartbitWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
    componentId: "sc-ae548a33-0"
})(_templateObject());
var ChartbitLayoutWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
    componentId: "sc-ae548a33-1"
})(_templateObject2(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet, global_MainLayout_styled__WEBPACK_IMPORTED_MODULE_2__/* .SIDE_WIDGET_TOOLBAR_WIDTH */ .zX, function(param) {
    var isSideWidgetOpen = param.isSideWidgetOpen;
    return isSideWidgetOpen && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__.css)(_templateObject1(), global_MainLayout_styled__WEBPACK_IMPORTED_MODULE_2__/* .SIDE_WIDGET_OPENED_WIDTH */ .RU);
});
var MyInvestmentWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
    componentId: "sc-ae548a33-2"
})(_templateObject3(), function(param) {
    var right = param.right;
    return "".concat(right, "px");
}, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet, function(param) {
    var show = param.show;
    return show ? "block" : "none";
});
var MaintenanceContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
    componentId: "sc-ae548a33-3"
})(_templateObject4(), function(props) {
    return props.background;
}, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet);
var MaintenanceImage = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Text).withConfig({
    componentId: "sc-ae548a33-4"
})(_templateObject5(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet);
var MaintenanceTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Text).withConfig({
    componentId: "sc-ae548a33-5"
})(_templateObject6(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet);
var MaintenanceDesc = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Text).withConfig({
    componentId: "sc-ae548a33-6"
})(_templateObject7(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet);
var MaintenanceBackButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Button).withConfig({
    componentId: "sc-ae548a33-7"
})(_templateObject8(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet);
var MaintenanceModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(BaseModal).withConfig({
    componentId: "sc-ae548a33-8"
})(_templateObject9(), function(param) {
    var theme = param.theme;
    return theme.color.modals.surfaceDefault;
}, function(param) {
    var theme = param.theme;
    return theme.color.modals.surfaceDefault;
}, function(param) {
    var theme = param.theme;
    return theme.color.text.primary;
});
var ErrorContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
    componentId: "sc-ae548a33-9"
})(_templateObject10(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet);
var ErrorDesc = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Text).withConfig({
    componentId: "sc-ae548a33-10"
})(_templateObject11(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet);
var ErrorRetryButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Button).withConfig({
    componentId: "sc-ae548a33-11"
})(_templateObject12());
// eslint-disable-next-line import/prefer-default-export



/***/ }),

/***/ 72521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gn": function() { return /* binding */ handleBackgroundColor; },
/* harmony export */   "wL": function() { return /* binding */ getValueForLowestKey; }
/* harmony export */ });
/* unused harmony export handleCustomCss */
/* harmony import */ var _constants_app__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86123);

var handleBackgroundColor = function(isDark, isDesktop) {
    if (isDesktop || isDark) {
        return "#1F1F1F";
    }
    return "#fff";
};
var handleCustomCss = function(isMobile, isDesktop) {
    if (isDesktop) return "../../tradingview/styles/custom-desktop.css";
    if (isMobile) return "".concat(assetPrefix, "/tradingview/styles/custom-mobile.css");
    return "".concat(assetPrefix, "/tradingview/styles/custom.css");
};
var getValueForLowestKey = function(object, index) {
    var returned;
    for(var key in object){
        if (Number(key) > index) break;
        returned = object[key];
    }
    return returned;
};



/***/ }),

/***/ 29658:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var If = function(param) {
    var children = param.children, condition = param.condition;
    if (!condition) {
        return null;
    }
    // render children if the condition is truthy
    return children;
};
/* harmony default export */ __webpack_exports__["Z"] = (If); /**
 * https://www.stefanjudis.com/snippets/a-react-if-component/
 *
 * Use the component as follows:
 *
 * <IF condition={condition}>
 *   <Greeter username={user.name} />
 * </IF>
 */ 


/***/ })

}]);